// source: billing-manager.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.billingmanager.AcceptCancelOfferReply', null, global);
goog.exportSymbol('proto.billingmanager.AcceptCancelOfferReq', null, global);
goog.exportSymbol('proto.billingmanager.AdAttribution', null, global);
goog.exportSymbol('proto.billingmanager.AddSubscriptionItemReply', null, global);
goog.exportSymbol('proto.billingmanager.AddSubscriptionItemReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminAddCampaignAllowlistEmailsReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminAddCampaignAllowlistEmailsReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminAddSubscriptionItemReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminAddSubscriptionItemReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminAssignDedicatedEnvReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminAssignDedicatedEnvReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminBillingOverviewReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminBillingOverviewReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminCampaign', null, global);
goog.exportSymbol('proto.billingmanager.AdminCancelSubscriptionImmediatelyReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminCancelSubscriptionImmediatelyReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminCancelSubscriptionReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminCancelSubscriptionReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminCreateCampaignReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminCreateCampaignReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminDeleteCardReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminDeleteCardReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetDownloadableInvoiceReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetDownloadableInvoiceReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetOverDueInfoReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetOverDueInfoReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetSubscriptionFreezeReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetSubscriptionFreezeReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetUpcomingInvoiceReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminGetUpcomingInvoiceReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminListCampaignAllowlistReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminListCampaignAllowlistReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminListCampaignsReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminListCampaignsReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminListCancelOffersReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminListCancelOffersReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminListCardsReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminListCardsReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminListInvoicesReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminListInvoicesReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminListPricesReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminListPricesReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminListSubscriptionFreezesReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminListSubscriptionFreezesReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminListSubscriptionsReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminListSubscriptionsReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminModifySubscriptionReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminModifySubscriptionReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminPreviewCheckoutReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminPreviewCheckoutReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminReactivateSubscriptionReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminReactivateSubscriptionReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminRemoveSubscriptionItemReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminRemoveSubscriptionItemReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminRenewOverDueSubscriptionReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminRenewOverDueSubscriptionReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminRetrySubscriptionFreezeReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminRetrySubscriptionFreezeReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminSetDefaultPaymentMethodReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminSetDefaultPaymentMethodReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminSubscriptionFreeze', null, global);
goog.exportSymbol('proto.billingmanager.AdminUpdateCampaignReply', null, global);
goog.exportSymbol('proto.billingmanager.AdminUpdateCampaignReq', null, global);
goog.exportSymbol('proto.billingmanager.AdminUser', null, global);
goog.exportSymbol('proto.billingmanager.BillingOverviewReply', null, global);
goog.exportSymbol('proto.billingmanager.BillingOverviewReq', null, global);
goog.exportSymbol('proto.billingmanager.CampaignAllowlistEntry', null, global);
goog.exportSymbol('proto.billingmanager.CancelCryptoPaymentReply', null, global);
goog.exportSymbol('proto.billingmanager.CancelCryptoPaymentRequest', null, global);
goog.exportSymbol('proto.billingmanager.CancelOffer', null, global);
goog.exportSymbol('proto.billingmanager.CancelOfferCharge', null, global);
goog.exportSymbol('proto.billingmanager.CancelSubscriptionFreezeReply', null, global);
goog.exportSymbol('proto.billingmanager.CancelSubscriptionFreezeReq', null, global);
goog.exportSymbol('proto.billingmanager.CancelSubscriptionImmediatelyReply', null, global);
goog.exportSymbol('proto.billingmanager.CancelSubscriptionImmediatelyReq', null, global);
goog.exportSymbol('proto.billingmanager.CancelSubscriptionReply', null, global);
goog.exportSymbol('proto.billingmanager.CancelSubscriptionReq', null, global);
goog.exportSymbol('proto.billingmanager.Card', null, global);
goog.exportSymbol('proto.billingmanager.CardSetUpIntentReply', null, global);
goog.exportSymbol('proto.billingmanager.CardSetUpIntentReq', null, global);
goog.exportSymbol('proto.billingmanager.ClaimCampaignReply', null, global);
goog.exportSymbol('proto.billingmanager.ClaimCampaignReq', null, global);
goog.exportSymbol('proto.billingmanager.CreateCryptoPaymentReply', null, global);
goog.exportSymbol('proto.billingmanager.CreateCryptoPaymentRequest', null, global);
goog.exportSymbol('proto.billingmanager.CreateSubscriptionFreezeReply', null, global);
goog.exportSymbol('proto.billingmanager.CreateSubscriptionFreezeReq', null, global);
goog.exportSymbol('proto.billingmanager.CreateSubscriptionReply', null, global);
goog.exportSymbol('proto.billingmanager.CreateSubscriptionReq', null, global);
goog.exportSymbol('proto.billingmanager.DeleteCardReply', null, global);
goog.exportSymbol('proto.billingmanager.DeleteCardReq', null, global);
goog.exportSymbol('proto.billingmanager.GetCancelOfferReply', null, global);
goog.exportSymbol('proto.billingmanager.GetCancelOfferReq', null, global);
goog.exportSymbol('proto.billingmanager.GetDownloadableInvoiceReply', null, global);
goog.exportSymbol('proto.billingmanager.GetDownloadableInvoiceReq', null, global);
goog.exportSymbol('proto.billingmanager.GetOverDueInfoReply', null, global);
goog.exportSymbol('proto.billingmanager.GetOverDueInfoReq', null, global);
goog.exportSymbol('proto.billingmanager.GetSubscriptionFreezeEligibilityReply', null, global);
goog.exportSymbol('proto.billingmanager.GetSubscriptionFreezeEligibilityReq', null, global);
goog.exportSymbol('proto.billingmanager.GetSubscriptionFreezeReply', null, global);
goog.exportSymbol('proto.billingmanager.GetSubscriptionFreezeReq', null, global);
goog.exportSymbol('proto.billingmanager.GetUpcomingInvoiceReply', null, global);
goog.exportSymbol('proto.billingmanager.GetUpcomingInvoiceReq', null, global);
goog.exportSymbol('proto.billingmanager.HasPendingCryptoPaymentReply', null, global);
goog.exportSymbol('proto.billingmanager.HasPendingCryptoPaymentRequest', null, global);
goog.exportSymbol('proto.billingmanager.IntApplyCouponToSubsManyReply', null, global);
goog.exportSymbol('proto.billingmanager.IntApplyCouponToSubsManyReq', null, global);
goog.exportSymbol('proto.billingmanager.IntFinalizeSubscriptionFreezeReply', null, global);
goog.exportSymbol('proto.billingmanager.IntFinalizeSubscriptionFreezeReq', null, global);
goog.exportSymbol('proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply', null, global);
goog.exportSymbol('proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq', null, global);
goog.exportSymbol('proto.billingmanager.IntPauseSubscriptionsManyReply', null, global);
goog.exportSymbol('proto.billingmanager.IntPauseSubscriptionsManyReq', null, global);
goog.exportSymbol('proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply', null, global);
goog.exportSymbol('proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq', null, global);
goog.exportSymbol('proto.billingmanager.IntRegisterUserToStripeReply', null, global);
goog.exportSymbol('proto.billingmanager.IntRegisterUserToStripeReq', null, global);
goog.exportSymbol('proto.billingmanager.IntRemoveUsersBillingInfoReply', null, global);
goog.exportSymbol('proto.billingmanager.IntRemoveUsersBillingInfoReq', null, global);
goog.exportSymbol('proto.billingmanager.IntResumeSubscriptionManyReply', null, global);
goog.exportSymbol('proto.billingmanager.IntResumeSubscriptionManyReq', null, global);
goog.exportSymbol('proto.billingmanager.IntUpdateSubscriptionRenewalReply', null, global);
goog.exportSymbol('proto.billingmanager.IntUpdateSubscriptionRenewalReq', null, global);
goog.exportSymbol('proto.billingmanager.IntUpdateUserToStripeReply', null, global);
goog.exportSymbol('proto.billingmanager.IntUpdateUserToStripeReq', null, global);
goog.exportSymbol('proto.billingmanager.Invoice', null, global);
goog.exportSymbol('proto.billingmanager.ListCardsReply', null, global);
goog.exportSymbol('proto.billingmanager.ListCardsReq', null, global);
goog.exportSymbol('proto.billingmanager.ListInvoicesReply', null, global);
goog.exportSymbol('proto.billingmanager.ListInvoicesReq', null, global);
goog.exportSymbol('proto.billingmanager.ListPricesReply', null, global);
goog.exportSymbol('proto.billingmanager.ListPricesReq', null, global);
goog.exportSymbol('proto.billingmanager.ListSubscriptionsReply', null, global);
goog.exportSymbol('proto.billingmanager.ListSubscriptionsReq', null, global);
goog.exportSymbol('proto.billingmanager.ModifySubscriptionReply', null, global);
goog.exportSymbol('proto.billingmanager.ModifySubscriptionReq', null, global);
goog.exportSymbol('proto.billingmanager.NewSubscriptionPreview', null, global);
goog.exportSymbol('proto.billingmanager.PaymentIntent', null, global);
goog.exportSymbol('proto.billingmanager.PendingSubscription', null, global);
goog.exportSymbol('proto.billingmanager.PreviewCheckoutReply', null, global);
goog.exportSymbol('proto.billingmanager.PreviewCheckoutReq', null, global);
goog.exportSymbol('proto.billingmanager.PreviewLine', null, global);
goog.exportSymbol('proto.billingmanager.PreviewSubscriptionFreezeReply', null, global);
goog.exportSymbol('proto.billingmanager.PreviewSubscriptionFreezeReq', null, global);
goog.exportSymbol('proto.billingmanager.Price', null, global);
goog.exportSymbol('proto.billingmanager.PriceTier', null, global);
goog.exportSymbol('proto.billingmanager.Purchase', null, global);
goog.exportSymbol('proto.billingmanager.ReactivateSubscriptionReply', null, global);
goog.exportSymbol('proto.billingmanager.ReactivateSubscriptionReq', null, global);
goog.exportSymbol('proto.billingmanager.RemoveSubscriptionItemReply', null, global);
goog.exportSymbol('proto.billingmanager.RemoveSubscriptionItemReq', null, global);
goog.exportSymbol('proto.billingmanager.RenewOverDueSubscriptionReply', null, global);
goog.exportSymbol('proto.billingmanager.RenewOverDueSubscriptionReq', null, global);
goog.exportSymbol('proto.billingmanager.ResumeSubscriptionFreezeReply', null, global);
goog.exportSymbol('proto.billingmanager.ResumeSubscriptionFreezeReq', null, global);
goog.exportSymbol('proto.billingmanager.SetDefaultPaymentMethodReply', null, global);
goog.exportSymbol('proto.billingmanager.SetDefaultPaymentMethodReq', null, global);
goog.exportSymbol('proto.billingmanager.SubscriptionFreezeAllowedAction', null, global);
goog.exportSymbol('proto.billingmanager.SubscriptionFreezeEligibility', null, global);
goog.exportSymbol('proto.billingmanager.SubscriptionFreezeState', null, global);
goog.exportSymbol('proto.billingmanager.SubscriptionFreezeStatus', null, global);
goog.exportSymbol('proto.billingmanager.SubscriptionItem', null, global);
goog.exportSymbol('proto.billingmanager.SubscriptionItemDelta', null, global);
goog.exportSymbol('proto.billingmanager.SubscriptionLineItem', null, global);
goog.exportSymbol('proto.billingmanager.SubscriptionLite', null, global);
goog.exportSymbol('proto.billingmanager.SubscriptionUpdate', null, global);
goog.exportSymbol('proto.billingmanager.UpcomingInvoiceTypeEnum', null, global);
goog.exportSymbol('proto.billingmanager.UserSubscription', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ClaimCampaignReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ClaimCampaignReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ClaimCampaignReq.displayName = 'proto.billingmanager.ClaimCampaignReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ClaimCampaignReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ClaimCampaignReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ClaimCampaignReply.displayName = 'proto.billingmanager.ClaimCampaignReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntRemoveUsersBillingInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntRemoveUsersBillingInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntRemoveUsersBillingInfoReq.displayName = 'proto.billingmanager.IntRemoveUsersBillingInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntRemoveUsersBillingInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntRemoveUsersBillingInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntRemoveUsersBillingInfoReply.displayName = 'proto.billingmanager.IntRemoveUsersBillingInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.PendingSubscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.PendingSubscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.PendingSubscription.displayName = 'proto.billingmanager.PendingSubscription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.UserSubscription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.UserSubscription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.UserSubscription.displayName = 'proto.billingmanager.UserSubscription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminAssignDedicatedEnvReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminAssignDedicatedEnvReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminAssignDedicatedEnvReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminAssignDedicatedEnvReq.displayName = 'proto.billingmanager.AdminAssignDedicatedEnvReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminAssignDedicatedEnvReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminAssignDedicatedEnvReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminAssignDedicatedEnvReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminAssignDedicatedEnvReply.displayName = 'proto.billingmanager.AdminAssignDedicatedEnvReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.displayName = 'proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.displayName = 'proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CreateSubscriptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.CreateSubscriptionReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.CreateSubscriptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CreateSubscriptionReq.displayName = 'proto.billingmanager.CreateSubscriptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdAttribution = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdAttribution, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdAttribution.displayName = 'proto.billingmanager.AdAttribution';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.SubscriptionItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.SubscriptionItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.SubscriptionItem.displayName = 'proto.billingmanager.SubscriptionItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CreateSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CreateSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CreateSubscriptionReply.displayName = 'proto.billingmanager.CreateSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelSubscriptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelSubscriptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelSubscriptionReq.displayName = 'proto.billingmanager.CancelSubscriptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelSubscriptionReply.displayName = 'proto.billingmanager.CancelSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ModifySubscriptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ModifySubscriptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ModifySubscriptionReq.displayName = 'proto.billingmanager.ModifySubscriptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ModifySubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ModifySubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ModifySubscriptionReply.displayName = 'proto.billingmanager.ModifySubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AddSubscriptionItemReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AddSubscriptionItemReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AddSubscriptionItemReq.displayName = 'proto.billingmanager.AddSubscriptionItemReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AddSubscriptionItemReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AddSubscriptionItemReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AddSubscriptionItemReply.displayName = 'proto.billingmanager.AddSubscriptionItemReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.RemoveSubscriptionItemReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.RemoveSubscriptionItemReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.RemoveSubscriptionItemReq.displayName = 'proto.billingmanager.RemoveSubscriptionItemReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.RemoveSubscriptionItemReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.RemoveSubscriptionItemReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.RemoveSubscriptionItemReply.displayName = 'proto.billingmanager.RemoveSubscriptionItemReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.PaymentIntent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.PaymentIntent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.PaymentIntent.displayName = 'proto.billingmanager.PaymentIntent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ListSubscriptionsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.ListSubscriptionsReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.ListSubscriptionsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ListSubscriptionsReq.displayName = 'proto.billingmanager.ListSubscriptionsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ListSubscriptionsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.ListSubscriptionsReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.ListSubscriptionsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ListSubscriptionsReply.displayName = 'proto.billingmanager.ListSubscriptionsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.SubscriptionLineItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.SubscriptionLineItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.SubscriptionLineItem.displayName = 'proto.billingmanager.SubscriptionLineItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.SubscriptionLite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.SubscriptionLite.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.SubscriptionLite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.SubscriptionLite.displayName = 'proto.billingmanager.SubscriptionLite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ReactivateSubscriptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ReactivateSubscriptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ReactivateSubscriptionReq.displayName = 'proto.billingmanager.ReactivateSubscriptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ReactivateSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ReactivateSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ReactivateSubscriptionReply.displayName = 'proto.billingmanager.ReactivateSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ListInvoicesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ListInvoicesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ListInvoicesReq.displayName = 'proto.billingmanager.ListInvoicesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ListInvoicesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.ListInvoicesReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.ListInvoicesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ListInvoicesReply.displayName = 'proto.billingmanager.ListInvoicesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.Invoice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.Invoice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.Invoice.displayName = 'proto.billingmanager.Invoice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ListPricesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ListPricesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ListPricesReq.displayName = 'proto.billingmanager.ListPricesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ListPricesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.ListPricesReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.ListPricesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ListPricesReply.displayName = 'proto.billingmanager.ListPricesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.PriceTier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.PriceTier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.PriceTier.displayName = 'proto.billingmanager.PriceTier';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.Price = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.Price.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.Price, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.Price.displayName = 'proto.billingmanager.Price';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ListCardsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ListCardsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ListCardsReq.displayName = 'proto.billingmanager.ListCardsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ListCardsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.ListCardsReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.ListCardsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ListCardsReply.displayName = 'proto.billingmanager.ListCardsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.Card = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.Card, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.Card.displayName = 'proto.billingmanager.Card';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.SetDefaultPaymentMethodReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.SetDefaultPaymentMethodReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.SetDefaultPaymentMethodReq.displayName = 'proto.billingmanager.SetDefaultPaymentMethodReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.SetDefaultPaymentMethodReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.SetDefaultPaymentMethodReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.SetDefaultPaymentMethodReply.displayName = 'proto.billingmanager.SetDefaultPaymentMethodReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.DeleteCardReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.DeleteCardReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.DeleteCardReq.displayName = 'proto.billingmanager.DeleteCardReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.DeleteCardReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.DeleteCardReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.DeleteCardReply.displayName = 'proto.billingmanager.DeleteCardReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CardSetUpIntentReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CardSetUpIntentReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CardSetUpIntentReq.displayName = 'proto.billingmanager.CardSetUpIntentReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CardSetUpIntentReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CardSetUpIntentReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CardSetUpIntentReply.displayName = 'proto.billingmanager.CardSetUpIntentReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntRegisterUserToStripeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntRegisterUserToStripeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntRegisterUserToStripeReq.displayName = 'proto.billingmanager.IntRegisterUserToStripeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntRegisterUserToStripeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntRegisterUserToStripeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntRegisterUserToStripeReply.displayName = 'proto.billingmanager.IntRegisterUserToStripeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntUpdateUserToStripeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntUpdateUserToStripeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntUpdateUserToStripeReq.displayName = 'proto.billingmanager.IntUpdateUserToStripeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntUpdateUserToStripeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntUpdateUserToStripeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntUpdateUserToStripeReply.displayName = 'proto.billingmanager.IntUpdateUserToStripeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetUpcomingInvoiceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetUpcomingInvoiceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetUpcomingInvoiceReq.displayName = 'proto.billingmanager.GetUpcomingInvoiceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetUpcomingInvoiceReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetUpcomingInvoiceReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetUpcomingInvoiceReply.displayName = 'proto.billingmanager.GetUpcomingInvoiceReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.PreviewCheckoutReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.PreviewCheckoutReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.PreviewCheckoutReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.PreviewCheckoutReq.displayName = 'proto.billingmanager.PreviewCheckoutReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.SubscriptionUpdate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.SubscriptionUpdate.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.SubscriptionUpdate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.SubscriptionUpdate.displayName = 'proto.billingmanager.SubscriptionUpdate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.SubscriptionItemDelta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.SubscriptionItemDelta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.SubscriptionItemDelta.displayName = 'proto.billingmanager.SubscriptionItemDelta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.NewSubscriptionPreview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.NewSubscriptionPreview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.NewSubscriptionPreview.displayName = 'proto.billingmanager.NewSubscriptionPreview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.PreviewCheckoutReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.PreviewCheckoutReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.PreviewCheckoutReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.PreviewCheckoutReply.displayName = 'proto.billingmanager.PreviewCheckoutReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.PreviewLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.PreviewLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.PreviewLine.displayName = 'proto.billingmanager.PreviewLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetDownloadableInvoiceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetDownloadableInvoiceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetDownloadableInvoiceReq.displayName = 'proto.billingmanager.GetDownloadableInvoiceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetDownloadableInvoiceReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetDownloadableInvoiceReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetDownloadableInvoiceReply.displayName = 'proto.billingmanager.GetDownloadableInvoiceReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.BillingOverviewReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.BillingOverviewReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.BillingOverviewReq.displayName = 'proto.billingmanager.BillingOverviewReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.BillingOverviewReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.BillingOverviewReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.BillingOverviewReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.BillingOverviewReply.displayName = 'proto.billingmanager.BillingOverviewReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelSubscriptionImmediatelyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelSubscriptionImmediatelyReq.displayName = 'proto.billingmanager.CancelSubscriptionImmediatelyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelSubscriptionImmediatelyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelSubscriptionImmediatelyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelSubscriptionImmediatelyReply.displayName = 'proto.billingmanager.CancelSubscriptionImmediatelyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.RenewOverDueSubscriptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.RenewOverDueSubscriptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.RenewOverDueSubscriptionReq.displayName = 'proto.billingmanager.RenewOverDueSubscriptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.RenewOverDueSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.RenewOverDueSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.RenewOverDueSubscriptionReply.displayName = 'proto.billingmanager.RenewOverDueSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetOverDueInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetOverDueInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetOverDueInfoReq.displayName = 'proto.billingmanager.GetOverDueInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetOverDueInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetOverDueInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetOverDueInfoReply.displayName = 'proto.billingmanager.GetOverDueInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminBillingOverviewReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminBillingOverviewReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminBillingOverviewReq.displayName = 'proto.billingmanager.AdminBillingOverviewReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminBillingOverviewReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminBillingOverviewReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminBillingOverviewReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminBillingOverviewReply.displayName = 'proto.billingmanager.AdminBillingOverviewReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListSubscriptionsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListSubscriptionsReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListSubscriptionsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListSubscriptionsReq.displayName = 'proto.billingmanager.AdminListSubscriptionsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListSubscriptionsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListSubscriptionsReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListSubscriptionsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListSubscriptionsReply.displayName = 'proto.billingmanager.AdminListSubscriptionsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListInvoicesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminListInvoicesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListInvoicesReq.displayName = 'proto.billingmanager.AdminListInvoicesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListInvoicesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListInvoicesReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListInvoicesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListInvoicesReply.displayName = 'proto.billingmanager.AdminListInvoicesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminGetDownloadableInvoiceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetDownloadableInvoiceReq.displayName = 'proto.billingmanager.AdminGetDownloadableInvoiceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetDownloadableInvoiceReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminGetDownloadableInvoiceReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetDownloadableInvoiceReply.displayName = 'proto.billingmanager.AdminGetDownloadableInvoiceReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListCardsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminListCardsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListCardsReq.displayName = 'proto.billingmanager.AdminListCardsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListCardsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListCardsReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListCardsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListCardsReply.displayName = 'proto.billingmanager.AdminListCardsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminSetDefaultPaymentMethodReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminSetDefaultPaymentMethodReq.displayName = 'proto.billingmanager.AdminSetDefaultPaymentMethodReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminSetDefaultPaymentMethodReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminSetDefaultPaymentMethodReply.displayName = 'proto.billingmanager.AdminSetDefaultPaymentMethodReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminDeleteCardReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminDeleteCardReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminDeleteCardReq.displayName = 'proto.billingmanager.AdminDeleteCardReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminDeleteCardReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminDeleteCardReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminDeleteCardReply.displayName = 'proto.billingmanager.AdminDeleteCardReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminGetUpcomingInvoiceReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetUpcomingInvoiceReq.displayName = 'proto.billingmanager.AdminGetUpcomingInvoiceReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminGetUpcomingInvoiceReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetUpcomingInvoiceReply.displayName = 'proto.billingmanager.AdminGetUpcomingInvoiceReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListPricesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminListPricesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListPricesReq.displayName = 'proto.billingmanager.AdminListPricesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListPricesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListPricesReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListPricesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListPricesReply.displayName = 'proto.billingmanager.AdminListPricesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminModifySubscriptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminModifySubscriptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminModifySubscriptionReq.displayName = 'proto.billingmanager.AdminModifySubscriptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminModifySubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminModifySubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminModifySubscriptionReply.displayName = 'proto.billingmanager.AdminModifySubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminAddSubscriptionItemReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminAddSubscriptionItemReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminAddSubscriptionItemReq.displayName = 'proto.billingmanager.AdminAddSubscriptionItemReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminAddSubscriptionItemReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminAddSubscriptionItemReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminAddSubscriptionItemReply.displayName = 'proto.billingmanager.AdminAddSubscriptionItemReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminRemoveSubscriptionItemReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminRemoveSubscriptionItemReq.displayName = 'proto.billingmanager.AdminRemoveSubscriptionItemReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminRemoveSubscriptionItemReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminRemoveSubscriptionItemReply.displayName = 'proto.billingmanager.AdminRemoveSubscriptionItemReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminPreviewCheckoutReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminPreviewCheckoutReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminPreviewCheckoutReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminPreviewCheckoutReq.displayName = 'proto.billingmanager.AdminPreviewCheckoutReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminPreviewCheckoutReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminPreviewCheckoutReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminPreviewCheckoutReply.displayName = 'proto.billingmanager.AdminPreviewCheckoutReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminCancelSubscriptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminCancelSubscriptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminCancelSubscriptionReq.displayName = 'proto.billingmanager.AdminCancelSubscriptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminCancelSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminCancelSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminCancelSubscriptionReply.displayName = 'proto.billingmanager.AdminCancelSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminReactivateSubscriptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminReactivateSubscriptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminReactivateSubscriptionReq.displayName = 'proto.billingmanager.AdminReactivateSubscriptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminReactivateSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminReactivateSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminReactivateSubscriptionReply.displayName = 'proto.billingmanager.AdminReactivateSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminRenewOverDueSubscriptionReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminRenewOverDueSubscriptionReq.displayName = 'proto.billingmanager.AdminRenewOverDueSubscriptionReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminRenewOverDueSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminRenewOverDueSubscriptionReply.displayName = 'proto.billingmanager.AdminRenewOverDueSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetOverDueInfoReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminGetOverDueInfoReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetOverDueInfoReq.displayName = 'proto.billingmanager.AdminGetOverDueInfoReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetOverDueInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminGetOverDueInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetOverDueInfoReply.displayName = 'proto.billingmanager.AdminGetOverDueInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminCancelSubscriptionImmediatelyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.displayName = 'proto.billingmanager.AdminCancelSubscriptionImmediatelyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminCancelSubscriptionImmediatelyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.displayName = 'proto.billingmanager.AdminCancelSubscriptionImmediatelyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntPauseSubscriptionsManyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.IntPauseSubscriptionsManyReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.IntPauseSubscriptionsManyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntPauseSubscriptionsManyReq.displayName = 'proto.billingmanager.IntPauseSubscriptionsManyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntPauseSubscriptionsManyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.IntPauseSubscriptionsManyReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.IntPauseSubscriptionsManyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntPauseSubscriptionsManyReply.displayName = 'proto.billingmanager.IntPauseSubscriptionsManyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntResumeSubscriptionManyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.IntResumeSubscriptionManyReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.IntResumeSubscriptionManyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntResumeSubscriptionManyReq.displayName = 'proto.billingmanager.IntResumeSubscriptionManyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntResumeSubscriptionManyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.IntResumeSubscriptionManyReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.IntResumeSubscriptionManyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntResumeSubscriptionManyReply.displayName = 'proto.billingmanager.IntResumeSubscriptionManyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntApplyCouponToSubsManyReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.IntApplyCouponToSubsManyReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.IntApplyCouponToSubsManyReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntApplyCouponToSubsManyReq.displayName = 'proto.billingmanager.IntApplyCouponToSubsManyReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntApplyCouponToSubsManyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.IntApplyCouponToSubsManyReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.IntApplyCouponToSubsManyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntApplyCouponToSubsManyReply.displayName = 'proto.billingmanager.IntApplyCouponToSubsManyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.IntUpdateSubscriptionRenewalReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.IntUpdateSubscriptionRenewalReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntUpdateSubscriptionRenewalReq.displayName = 'proto.billingmanager.IntUpdateSubscriptionRenewalReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.IntUpdateSubscriptionRenewalReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.IntUpdateSubscriptionRenewalReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntUpdateSubscriptionRenewalReply.displayName = 'proto.billingmanager.IntUpdateSubscriptionRenewalReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CreateCryptoPaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CreateCryptoPaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CreateCryptoPaymentRequest.displayName = 'proto.billingmanager.CreateCryptoPaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CreateCryptoPaymentReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CreateCryptoPaymentReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CreateCryptoPaymentReply.displayName = 'proto.billingmanager.CreateCryptoPaymentReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.HasPendingCryptoPaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.HasPendingCryptoPaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.HasPendingCryptoPaymentRequest.displayName = 'proto.billingmanager.HasPendingCryptoPaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.HasPendingCryptoPaymentReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.HasPendingCryptoPaymentReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.HasPendingCryptoPaymentReply.displayName = 'proto.billingmanager.HasPendingCryptoPaymentReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelCryptoPaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelCryptoPaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelCryptoPaymentRequest.displayName = 'proto.billingmanager.CancelCryptoPaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelCryptoPaymentReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelCryptoPaymentReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelCryptoPaymentReply.displayName = 'proto.billingmanager.CancelCryptoPaymentReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.Purchase = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.Purchase, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.Purchase.displayName = 'proto.billingmanager.Purchase';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminCampaign = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminCampaign, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminCampaign.displayName = 'proto.billingmanager.AdminCampaign';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListCampaignsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminListCampaignsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListCampaignsReq.displayName = 'proto.billingmanager.AdminListCampaignsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListCampaignsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListCampaignsReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListCampaignsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListCampaignsReply.displayName = 'proto.billingmanager.AdminListCampaignsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminCreateCampaignReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminCreateCampaignReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminCreateCampaignReq.displayName = 'proto.billingmanager.AdminCreateCampaignReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminCreateCampaignReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminCreateCampaignReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminCreateCampaignReply.displayName = 'proto.billingmanager.AdminCreateCampaignReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminUpdateCampaignReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminUpdateCampaignReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminUpdateCampaignReq.displayName = 'proto.billingmanager.AdminUpdateCampaignReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminUpdateCampaignReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminUpdateCampaignReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminUpdateCampaignReply.displayName = 'proto.billingmanager.AdminUpdateCampaignReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListCampaignAllowlistReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminListCampaignAllowlistReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListCampaignAllowlistReq.displayName = 'proto.billingmanager.AdminListCampaignAllowlistReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CampaignAllowlistEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CampaignAllowlistEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CampaignAllowlistEntry.displayName = 'proto.billingmanager.CampaignAllowlistEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListCampaignAllowlistReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListCampaignAllowlistReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListCampaignAllowlistReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListCampaignAllowlistReply.displayName = 'proto.billingmanager.AdminListCampaignAllowlistReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminAddCampaignAllowlistEmailsReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.displayName = 'proto.billingmanager.AdminAddCampaignAllowlistEmailsReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminAddCampaignAllowlistEmailsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.displayName = 'proto.billingmanager.AdminAddCampaignAllowlistEmailsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.displayName = 'proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.displayName = 'proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.SubscriptionFreezeState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.SubscriptionFreezeState.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.SubscriptionFreezeState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.SubscriptionFreezeState.displayName = 'proto.billingmanager.SubscriptionFreezeState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.PreviewSubscriptionFreezeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.PreviewSubscriptionFreezeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.PreviewSubscriptionFreezeReq.displayName = 'proto.billingmanager.PreviewSubscriptionFreezeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.SubscriptionFreezeEligibility = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.SubscriptionFreezeEligibility.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.SubscriptionFreezeEligibility, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.SubscriptionFreezeEligibility.displayName = 'proto.billingmanager.SubscriptionFreezeEligibility';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetSubscriptionFreezeEligibilityReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetSubscriptionFreezeEligibilityReq.displayName = 'proto.billingmanager.GetSubscriptionFreezeEligibilityReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetSubscriptionFreezeEligibilityReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetSubscriptionFreezeEligibilityReply.displayName = 'proto.billingmanager.GetSubscriptionFreezeEligibilityReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.PreviewSubscriptionFreezeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.PreviewSubscriptionFreezeReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.PreviewSubscriptionFreezeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.PreviewSubscriptionFreezeReply.displayName = 'proto.billingmanager.PreviewSubscriptionFreezeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CreateSubscriptionFreezeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CreateSubscriptionFreezeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CreateSubscriptionFreezeReq.displayName = 'proto.billingmanager.CreateSubscriptionFreezeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CreateSubscriptionFreezeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CreateSubscriptionFreezeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CreateSubscriptionFreezeReply.displayName = 'proto.billingmanager.CreateSubscriptionFreezeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetSubscriptionFreezeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetSubscriptionFreezeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetSubscriptionFreezeReq.displayName = 'proto.billingmanager.GetSubscriptionFreezeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetSubscriptionFreezeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetSubscriptionFreezeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetSubscriptionFreezeReply.displayName = 'proto.billingmanager.GetSubscriptionFreezeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ResumeSubscriptionFreezeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ResumeSubscriptionFreezeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ResumeSubscriptionFreezeReq.displayName = 'proto.billingmanager.ResumeSubscriptionFreezeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.ResumeSubscriptionFreezeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.ResumeSubscriptionFreezeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.ResumeSubscriptionFreezeReply.displayName = 'proto.billingmanager.ResumeSubscriptionFreezeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminGetSubscriptionFreezeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetSubscriptionFreezeReq.displayName = 'proto.billingmanager.AdminGetSubscriptionFreezeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminGetSubscriptionFreezeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminGetSubscriptionFreezeReply.displayName = 'proto.billingmanager.AdminGetSubscriptionFreezeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListSubscriptionFreezesReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListSubscriptionFreezesReq.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListSubscriptionFreezesReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListSubscriptionFreezesReq.displayName = 'proto.billingmanager.AdminListSubscriptionFreezesReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminUser.displayName = 'proto.billingmanager.AdminUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminSubscriptionFreeze = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminSubscriptionFreeze, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminSubscriptionFreeze.displayName = 'proto.billingmanager.AdminSubscriptionFreeze';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListSubscriptionFreezesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListSubscriptionFreezesReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListSubscriptionFreezesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListSubscriptionFreezesReply.displayName = 'proto.billingmanager.AdminListSubscriptionFreezesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelSubscriptionFreezeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelSubscriptionFreezeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelSubscriptionFreezeReq.displayName = 'proto.billingmanager.CancelSubscriptionFreezeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelSubscriptionFreezeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelSubscriptionFreezeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelSubscriptionFreezeReply.displayName = 'proto.billingmanager.CancelSubscriptionFreezeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelOfferCharge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelOfferCharge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelOfferCharge.displayName = 'proto.billingmanager.CancelOfferCharge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetCancelOfferReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.GetCancelOfferReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetCancelOfferReq.displayName = 'proto.billingmanager.GetCancelOfferReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.GetCancelOfferReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.GetCancelOfferReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.GetCancelOfferReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.GetCancelOfferReply.displayName = 'proto.billingmanager.GetCancelOfferReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AcceptCancelOfferReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AcceptCancelOfferReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AcceptCancelOfferReq.displayName = 'proto.billingmanager.AcceptCancelOfferReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.CancelOffer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.CancelOffer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.CancelOffer.displayName = 'proto.billingmanager.CancelOffer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AcceptCancelOfferReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AcceptCancelOfferReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AcceptCancelOfferReply.displayName = 'proto.billingmanager.AcceptCancelOfferReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListCancelOffersReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminListCancelOffersReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListCancelOffersReq.displayName = 'proto.billingmanager.AdminListCancelOffersReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminListCancelOffersReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.billingmanager.AdminListCancelOffersReply.repeatedFields_, null);
};
goog.inherits(proto.billingmanager.AdminListCancelOffersReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminListCancelOffersReply.displayName = 'proto.billingmanager.AdminListCancelOffersReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminRetrySubscriptionFreezeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminRetrySubscriptionFreezeReq.displayName = 'proto.billingmanager.AdminRetrySubscriptionFreezeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.AdminRetrySubscriptionFreezeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.AdminRetrySubscriptionFreezeReply.displayName = 'proto.billingmanager.AdminRetrySubscriptionFreezeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntFinalizeSubscriptionFreezeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntFinalizeSubscriptionFreezeReq.displayName = 'proto.billingmanager.IntFinalizeSubscriptionFreezeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntFinalizeSubscriptionFreezeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntFinalizeSubscriptionFreezeReply.displayName = 'proto.billingmanager.IntFinalizeSubscriptionFreezeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.displayName = 'proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.displayName = 'proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.displayName = 'proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.displayName = 'proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ClaimCampaignReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ClaimCampaignReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ClaimCampaignReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ClaimCampaignReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
campaignKey: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ClaimCampaignReq}
 */
proto.billingmanager.ClaimCampaignReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ClaimCampaignReq;
  return proto.billingmanager.ClaimCampaignReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ClaimCampaignReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ClaimCampaignReq}
 */
proto.billingmanager.ClaimCampaignReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ClaimCampaignReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ClaimCampaignReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ClaimCampaignReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ClaimCampaignReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCampaignKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.ClaimCampaignReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ClaimCampaignReq} returns this
 */
proto.billingmanager.ClaimCampaignReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string campaign_key = 2;
 * @return {string}
 */
proto.billingmanager.ClaimCampaignReq.prototype.getCampaignKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ClaimCampaignReq} returns this
 */
proto.billingmanager.ClaimCampaignReq.prototype.setCampaignKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ClaimCampaignReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ClaimCampaignReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ClaimCampaignReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ClaimCampaignReply.toObject = function(includeInstance, msg) {
  var f, obj = {
claimed: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
alreadyClaimed: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
creditCents: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ClaimCampaignReply}
 */
proto.billingmanager.ClaimCampaignReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ClaimCampaignReply;
  return proto.billingmanager.ClaimCampaignReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ClaimCampaignReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ClaimCampaignReply}
 */
proto.billingmanager.ClaimCampaignReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClaimed(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAlreadyClaimed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreditCents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ClaimCampaignReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ClaimCampaignReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ClaimCampaignReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ClaimCampaignReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClaimed();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAlreadyClaimed();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getCreditCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional bool claimed = 1;
 * @return {boolean}
 */
proto.billingmanager.ClaimCampaignReply.prototype.getClaimed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.ClaimCampaignReply} returns this
 */
proto.billingmanager.ClaimCampaignReply.prototype.setClaimed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool already_claimed = 2;
 * @return {boolean}
 */
proto.billingmanager.ClaimCampaignReply.prototype.getAlreadyClaimed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.ClaimCampaignReply} returns this
 */
proto.billingmanager.ClaimCampaignReply.prototype.setAlreadyClaimed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int64 credit_cents = 3;
 * @return {number}
 */
proto.billingmanager.ClaimCampaignReply.prototype.getCreditCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.ClaimCampaignReply} returns this
 */
proto.billingmanager.ClaimCampaignReply.prototype.setCreditCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntRemoveUsersBillingInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntRemoveUsersBillingInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntRemoveUsersBillingInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntRemoveUsersBillingInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntRemoveUsersBillingInfoReq}
 */
proto.billingmanager.IntRemoveUsersBillingInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntRemoveUsersBillingInfoReq;
  return proto.billingmanager.IntRemoveUsersBillingInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntRemoveUsersBillingInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntRemoveUsersBillingInfoReq}
 */
proto.billingmanager.IntRemoveUsersBillingInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntRemoveUsersBillingInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntRemoveUsersBillingInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntRemoveUsersBillingInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntRemoveUsersBillingInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.IntRemoveUsersBillingInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntRemoveUsersBillingInfoReq} returns this
 */
proto.billingmanager.IntRemoveUsersBillingInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntRemoveUsersBillingInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntRemoveUsersBillingInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntRemoveUsersBillingInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntRemoveUsersBillingInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntRemoveUsersBillingInfoReply}
 */
proto.billingmanager.IntRemoveUsersBillingInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntRemoveUsersBillingInfoReply;
  return proto.billingmanager.IntRemoveUsersBillingInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntRemoveUsersBillingInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntRemoveUsersBillingInfoReply}
 */
proto.billingmanager.IntRemoveUsersBillingInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntRemoveUsersBillingInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntRemoveUsersBillingInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntRemoveUsersBillingInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntRemoveUsersBillingInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.PendingSubscription.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.PendingSubscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.PendingSubscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PendingSubscription.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
productName: jspb.Message.getFieldWithDefault(msg, 3, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.PendingSubscription}
 */
proto.billingmanager.PendingSubscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.PendingSubscription;
  return proto.billingmanager.PendingSubscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.PendingSubscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.PendingSubscription}
 */
proto.billingmanager.PendingSubscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.PendingSubscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.PendingSubscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.PendingSubscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PendingSubscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.PendingSubscription.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PendingSubscription} returns this
 */
proto.billingmanager.PendingSubscription.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.PendingSubscription.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PendingSubscription} returns this
 */
proto.billingmanager.PendingSubscription.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string product_name = 3;
 * @return {string}
 */
proto.billingmanager.PendingSubscription.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PendingSubscription} returns this
 */
proto.billingmanager.PendingSubscription.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 quantity = 4;
 * @return {number}
 */
proto.billingmanager.PendingSubscription.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PendingSubscription} returns this
 */
proto.billingmanager.PendingSubscription.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.UserSubscription.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.UserSubscription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.UserSubscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.UserSubscription.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.UserSubscription}
 */
proto.billingmanager.UserSubscription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.UserSubscription;
  return proto.billingmanager.UserSubscription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.UserSubscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.UserSubscription}
 */
proto.billingmanager.UserSubscription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.UserSubscription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.UserSubscription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.UserSubscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.UserSubscription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.UserSubscription.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.UserSubscription} returns this
 */
proto.billingmanager.UserSubscription.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.UserSubscription.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.UserSubscription} returns this
 */
proto.billingmanager.UserSubscription.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminAssignDedicatedEnvReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminAssignDedicatedEnvReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.toObject = function(includeInstance, msg) {
  var f, obj = {
pendingUserSubscriptionsList: jspb.Message.toObjectList(msg.getPendingUserSubscriptionsList(),
    proto.billingmanager.UserSubscription.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminAssignDedicatedEnvReq}
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminAssignDedicatedEnvReq;
  return proto.billingmanager.AdminAssignDedicatedEnvReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminAssignDedicatedEnvReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminAssignDedicatedEnvReq}
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.UserSubscription;
      reader.readMessage(value,proto.billingmanager.UserSubscription.deserializeBinaryFromReader);
      msg.addPendingUserSubscriptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminAssignDedicatedEnvReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminAssignDedicatedEnvReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPendingUserSubscriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.UserSubscription.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserSubscription pending_user_subscriptions = 1;
 * @return {!Array<!proto.billingmanager.UserSubscription>}
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.prototype.getPendingUserSubscriptionsList = function() {
  return /** @type{!Array<!proto.billingmanager.UserSubscription>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.UserSubscription, 1));
};


/**
 * @param {!Array<!proto.billingmanager.UserSubscription>} value
 * @return {!proto.billingmanager.AdminAssignDedicatedEnvReq} returns this
*/
proto.billingmanager.AdminAssignDedicatedEnvReq.prototype.setPendingUserSubscriptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.UserSubscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.UserSubscription}
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.prototype.addPendingUserSubscriptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.UserSubscription, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminAssignDedicatedEnvReq} returns this
 */
proto.billingmanager.AdminAssignDedicatedEnvReq.prototype.clearPendingUserSubscriptionsList = function() {
  return this.setPendingUserSubscriptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminAssignDedicatedEnvReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminAssignDedicatedEnvReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedList: jspb.Message.toObjectList(msg.getFailedList(),
    proto.billingmanager.UserSubscription.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminAssignDedicatedEnvReply}
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminAssignDedicatedEnvReply;
  return proto.billingmanager.AdminAssignDedicatedEnvReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminAssignDedicatedEnvReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminAssignDedicatedEnvReply}
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.UserSubscription;
      reader.readMessage(value,proto.billingmanager.UserSubscription.deserializeBinaryFromReader);
      msg.addFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminAssignDedicatedEnvReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminAssignDedicatedEnvReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.UserSubscription.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UserSubscription failed = 1;
 * @return {!Array<!proto.billingmanager.UserSubscription>}
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.prototype.getFailedList = function() {
  return /** @type{!Array<!proto.billingmanager.UserSubscription>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.UserSubscription, 1));
};


/**
 * @param {!Array<!proto.billingmanager.UserSubscription>} value
 * @return {!proto.billingmanager.AdminAssignDedicatedEnvReply} returns this
*/
proto.billingmanager.AdminAssignDedicatedEnvReply.prototype.setFailedList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.UserSubscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.UserSubscription}
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.prototype.addFailed = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.UserSubscription, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminAssignDedicatedEnvReply} returns this
 */
proto.billingmanager.AdminAssignDedicatedEnvReply.prototype.clearFailedList = function() {
  return this.setFailedList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq;
  return proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
pendingSubscriptionsList: jspb.Message.toObjectList(msg.getPendingSubscriptionsList(),
    proto.billingmanager.PendingSubscription.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply;
  return proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PendingSubscription;
      reader.readMessage(value,proto.billingmanager.PendingSubscription.deserializeBinaryFromReader);
      msg.addPendingSubscriptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPendingSubscriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.PendingSubscription.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PendingSubscription pending_subscriptions = 1;
 * @return {!Array<!proto.billingmanager.PendingSubscription>}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.prototype.getPendingSubscriptionsList = function() {
  return /** @type{!Array<!proto.billingmanager.PendingSubscription>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.PendingSubscription, 1));
};


/**
 * @param {!Array<!proto.billingmanager.PendingSubscription>} value
 * @return {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply} returns this
*/
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.prototype.setPendingSubscriptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.PendingSubscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.PendingSubscription}
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.prototype.addPendingSubscriptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.PendingSubscription, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply} returns this
 */
proto.billingmanager.AdminGetPendingDedicatedEnvSubsReply.prototype.clearPendingSubscriptionsList = function() {
  return this.setPendingSubscriptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.CreateSubscriptionReq.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CreateSubscriptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CreateSubscriptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateSubscriptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
priceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
toltReferral: jspb.Message.getFieldWithDefault(msg, 4, ""),
isDedi: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
useTrial: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.billingmanager.SubscriptionItem.toObject, includeInstance),
coupon: jspb.Message.getFieldWithDefault(msg, 8, ""),
checkoutRef: jspb.Message.getFieldWithDefault(msg, 9, ""),
adAttribution: (f = msg.getAdAttribution()) && proto.billingmanager.AdAttribution.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CreateSubscriptionReq}
 */
proto.billingmanager.CreateSubscriptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CreateSubscriptionReq;
  return proto.billingmanager.CreateSubscriptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CreateSubscriptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CreateSubscriptionReq}
 */
proto.billingmanager.CreateSubscriptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setToltReferral(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsDedi(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseTrial(value);
      break;
    case 7:
      var value = new proto.billingmanager.SubscriptionItem;
      reader.readMessage(value,proto.billingmanager.SubscriptionItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoupon(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckoutRef(value);
      break;
    case 10:
      var value = new proto.billingmanager.AdAttribution;
      reader.readMessage(value,proto.billingmanager.AdAttribution.deserializeBinaryFromReader);
      msg.setAdAttribution(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CreateSubscriptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CreateSubscriptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateSubscriptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getToltReferral();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIsDedi();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getUseTrial();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.billingmanager.SubscriptionItem.serializeBinaryToWriter
    );
  }
  f = message.getCoupon();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCheckoutRef();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAdAttribution();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.billingmanager.AdAttribution.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string price_id = 2;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 quantity = 3;
 * @return {number}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string tolt_referral = 4;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getToltReferral = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.setToltReferral = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool is_dedi = 5;
 * @return {boolean}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getIsDedi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.setIsDedi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool use_trial = 6;
 * @return {boolean}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getUseTrial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.setUseTrial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * repeated SubscriptionItem items = 7;
 * @return {!Array<!proto.billingmanager.SubscriptionItem>}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.billingmanager.SubscriptionItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.SubscriptionItem, 7));
};


/**
 * @param {!Array<!proto.billingmanager.SubscriptionItem>} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
*/
proto.billingmanager.CreateSubscriptionReq.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.billingmanager.SubscriptionItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.SubscriptionItem}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.billingmanager.SubscriptionItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional string coupon = 8;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getCoupon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.setCoupon = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string checkout_ref = 9;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getCheckoutRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.setCheckoutRef = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional AdAttribution ad_attribution = 10;
 * @return {?proto.billingmanager.AdAttribution}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.getAdAttribution = function() {
  return /** @type{?proto.billingmanager.AdAttribution} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.AdAttribution, 10));
};


/**
 * @param {?proto.billingmanager.AdAttribution|undefined} value
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
*/
proto.billingmanager.CreateSubscriptionReq.prototype.setAdAttribution = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CreateSubscriptionReq} returns this
 */
proto.billingmanager.CreateSubscriptionReq.prototype.clearAdAttribution = function() {
  return this.setAdAttribution(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CreateSubscriptionReq.prototype.hasAdAttribution = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdAttribution.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdAttribution.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdAttribution} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdAttribution.toObject = function(includeInstance, msg) {
  var f, obj = {
oppref: jspb.Message.getFieldWithDefault(msg, 1, ""),
obref: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdAttribution}
 */
proto.billingmanager.AdAttribution.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdAttribution;
  return proto.billingmanager.AdAttribution.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdAttribution} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdAttribution}
 */
proto.billingmanager.AdAttribution.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOppref(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObref(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdAttribution.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdAttribution.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdAttribution} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdAttribution.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOppref();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getObref();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string oppref = 1;
 * @return {string}
 */
proto.billingmanager.AdAttribution.prototype.getOppref = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdAttribution} returns this
 */
proto.billingmanager.AdAttribution.prototype.setOppref = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string obref = 2;
 * @return {string}
 */
proto.billingmanager.AdAttribution.prototype.getObref = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdAttribution} returns this
 */
proto.billingmanager.AdAttribution.prototype.setObref = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.SubscriptionItem.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.SubscriptionItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.SubscriptionItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionItem.toObject = function(includeInstance, msg) {
  var f, obj = {
priceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.SubscriptionItem}
 */
proto.billingmanager.SubscriptionItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.SubscriptionItem;
  return proto.billingmanager.SubscriptionItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.SubscriptionItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.SubscriptionItem}
 */
proto.billingmanager.SubscriptionItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.SubscriptionItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.SubscriptionItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.SubscriptionItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string price_id = 1;
 * @return {string}
 */
proto.billingmanager.SubscriptionItem.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionItem} returns this
 */
proto.billingmanager.SubscriptionItem.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 quantity = 2;
 * @return {number}
 */
proto.billingmanager.SubscriptionItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionItem} returns this
 */
proto.billingmanager.SubscriptionItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CreateSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CreateSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CreateSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
clientSecret: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CreateSubscriptionReply}
 */
proto.billingmanager.CreateSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CreateSubscriptionReply;
  return proto.billingmanager.CreateSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CreateSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CreateSubscriptionReply}
 */
proto.billingmanager.CreateSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CreateSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CreateSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CreateSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string client_secret = 1;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionReply.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionReply} returns this
 */
proto.billingmanager.CreateSubscriptionReply.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionReply.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionReply} returns this
 */
proto.billingmanager.CreateSubscriptionReply.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionReply.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionReply} returns this
 */
proto.billingmanager.CreateSubscriptionReply.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelSubscriptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelSubscriptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelSubscriptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelSubscriptionReq}
 */
proto.billingmanager.CancelSubscriptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelSubscriptionReq;
  return proto.billingmanager.CancelSubscriptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelSubscriptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelSubscriptionReq}
 */
proto.billingmanager.CancelSubscriptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelSubscriptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelSubscriptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelSubscriptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.CancelSubscriptionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelSubscriptionReq} returns this
 */
proto.billingmanager.CancelSubscriptionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.CancelSubscriptionReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelSubscriptionReq} returns this
 */
proto.billingmanager.CancelSubscriptionReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelSubscriptionReply}
 */
proto.billingmanager.CancelSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelSubscriptionReply;
  return proto.billingmanager.CancelSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelSubscriptionReply}
 */
proto.billingmanager.CancelSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ModifySubscriptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ModifySubscriptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ModifySubscriptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ModifySubscriptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
subscriptionItemId: jspb.Message.getFieldWithDefault(msg, 4, ""),
priceId: jspb.Message.getFieldWithDefault(msg, 5, ""),
coupon: jspb.Message.getFieldWithDefault(msg, 6, ""),
checkoutRef: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ModifySubscriptionReq}
 */
proto.billingmanager.ModifySubscriptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ModifySubscriptionReq;
  return proto.billingmanager.ModifySubscriptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ModifySubscriptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ModifySubscriptionReq}
 */
proto.billingmanager.ModifySubscriptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionItemId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoupon(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckoutRef(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ModifySubscriptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ModifySubscriptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ModifySubscriptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ModifySubscriptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSubscriptionItemId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCoupon();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCheckoutRef();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.ModifySubscriptionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ModifySubscriptionReq} returns this
 */
proto.billingmanager.ModifySubscriptionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.ModifySubscriptionReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ModifySubscriptionReq} returns this
 */
proto.billingmanager.ModifySubscriptionReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 quantity = 3;
 * @return {number}
 */
proto.billingmanager.ModifySubscriptionReq.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.ModifySubscriptionReq} returns this
 */
proto.billingmanager.ModifySubscriptionReq.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string subscription_item_id = 4;
 * @return {string}
 */
proto.billingmanager.ModifySubscriptionReq.prototype.getSubscriptionItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ModifySubscriptionReq} returns this
 */
proto.billingmanager.ModifySubscriptionReq.prototype.setSubscriptionItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string price_id = 5;
 * @return {string}
 */
proto.billingmanager.ModifySubscriptionReq.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ModifySubscriptionReq} returns this
 */
proto.billingmanager.ModifySubscriptionReq.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string coupon = 6;
 * @return {string}
 */
proto.billingmanager.ModifySubscriptionReq.prototype.getCoupon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ModifySubscriptionReq} returns this
 */
proto.billingmanager.ModifySubscriptionReq.prototype.setCoupon = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string checkout_ref = 7;
 * @return {string}
 */
proto.billingmanager.ModifySubscriptionReq.prototype.getCheckoutRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ModifySubscriptionReq} returns this
 */
proto.billingmanager.ModifySubscriptionReq.prototype.setCheckoutRef = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ModifySubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ModifySubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ModifySubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ModifySubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ModifySubscriptionReply}
 */
proto.billingmanager.ModifySubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ModifySubscriptionReply;
  return proto.billingmanager.ModifySubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ModifySubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ModifySubscriptionReply}
 */
proto.billingmanager.ModifySubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ModifySubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ModifySubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ModifySubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ModifySubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
};


/**
 * optional PaymentIntent payment_intent = 1;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.ModifySubscriptionReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 1));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.ModifySubscriptionReply} returns this
*/
proto.billingmanager.ModifySubscriptionReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.ModifySubscriptionReply} returns this
 */
proto.billingmanager.ModifySubscriptionReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.ModifySubscriptionReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AddSubscriptionItemReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AddSubscriptionItemReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AddSubscriptionItemReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
priceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 4, 0),
coupon: jspb.Message.getFieldWithDefault(msg, 5, ""),
checkoutRef: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AddSubscriptionItemReq}
 */
proto.billingmanager.AddSubscriptionItemReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AddSubscriptionItemReq;
  return proto.billingmanager.AddSubscriptionItemReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AddSubscriptionItemReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AddSubscriptionItemReq}
 */
proto.billingmanager.AddSubscriptionItemReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoupon(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheckoutRef(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AddSubscriptionItemReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AddSubscriptionItemReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AddSubscriptionItemReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCoupon();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCheckoutRef();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AddSubscriptionItemReq} returns this
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AddSubscriptionItemReq} returns this
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string price_id = 3;
 * @return {string}
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AddSubscriptionItemReq} returns this
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 quantity = 4;
 * @return {number}
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AddSubscriptionItemReq} returns this
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string coupon = 5;
 * @return {string}
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.getCoupon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AddSubscriptionItemReq} returns this
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.setCoupon = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string checkout_ref = 6;
 * @return {string}
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.getCheckoutRef = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AddSubscriptionItemReq} returns this
 */
proto.billingmanager.AddSubscriptionItemReq.prototype.setCheckoutRef = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AddSubscriptionItemReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AddSubscriptionItemReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AddSubscriptionItemReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AddSubscriptionItemReply.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f),
subscriptionItemId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AddSubscriptionItemReply}
 */
proto.billingmanager.AddSubscriptionItemReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AddSubscriptionItemReply;
  return proto.billingmanager.AddSubscriptionItemReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AddSubscriptionItemReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AddSubscriptionItemReply}
 */
proto.billingmanager.AddSubscriptionItemReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AddSubscriptionItemReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AddSubscriptionItemReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AddSubscriptionItemReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AddSubscriptionItemReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionItemId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional PaymentIntent payment_intent = 1;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.AddSubscriptionItemReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 1));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.AddSubscriptionItemReply} returns this
*/
proto.billingmanager.AddSubscriptionItemReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AddSubscriptionItemReply} returns this
 */
proto.billingmanager.AddSubscriptionItemReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AddSubscriptionItemReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string subscription_item_id = 2;
 * @return {string}
 */
proto.billingmanager.AddSubscriptionItemReply.prototype.getSubscriptionItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AddSubscriptionItemReply} returns this
 */
proto.billingmanager.AddSubscriptionItemReply.prototype.setSubscriptionItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.RemoveSubscriptionItemReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.RemoveSubscriptionItemReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.RemoveSubscriptionItemReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.RemoveSubscriptionItemReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
subscriptionItemId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.RemoveSubscriptionItemReq}
 */
proto.billingmanager.RemoveSubscriptionItemReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.RemoveSubscriptionItemReq;
  return proto.billingmanager.RemoveSubscriptionItemReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.RemoveSubscriptionItemReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.RemoveSubscriptionItemReq}
 */
proto.billingmanager.RemoveSubscriptionItemReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.RemoveSubscriptionItemReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.RemoveSubscriptionItemReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.RemoveSubscriptionItemReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.RemoveSubscriptionItemReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionItemId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.RemoveSubscriptionItemReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.RemoveSubscriptionItemReq} returns this
 */
proto.billingmanager.RemoveSubscriptionItemReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.RemoveSubscriptionItemReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.RemoveSubscriptionItemReq} returns this
 */
proto.billingmanager.RemoveSubscriptionItemReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subscription_item_id = 3;
 * @return {string}
 */
proto.billingmanager.RemoveSubscriptionItemReq.prototype.getSubscriptionItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.RemoveSubscriptionItemReq} returns this
 */
proto.billingmanager.RemoveSubscriptionItemReq.prototype.setSubscriptionItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.RemoveSubscriptionItemReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.RemoveSubscriptionItemReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.RemoveSubscriptionItemReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.RemoveSubscriptionItemReply.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.RemoveSubscriptionItemReply}
 */
proto.billingmanager.RemoveSubscriptionItemReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.RemoveSubscriptionItemReply;
  return proto.billingmanager.RemoveSubscriptionItemReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.RemoveSubscriptionItemReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.RemoveSubscriptionItemReply}
 */
proto.billingmanager.RemoveSubscriptionItemReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.RemoveSubscriptionItemReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.RemoveSubscriptionItemReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.RemoveSubscriptionItemReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.RemoveSubscriptionItemReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
};


/**
 * optional PaymentIntent payment_intent = 1;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.RemoveSubscriptionItemReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 1));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.RemoveSubscriptionItemReply} returns this
*/
proto.billingmanager.RemoveSubscriptionItemReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.RemoveSubscriptionItemReply} returns this
 */
proto.billingmanager.RemoveSubscriptionItemReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.RemoveSubscriptionItemReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.PaymentIntent.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.PaymentIntent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.PaymentIntent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PaymentIntent.toObject = function(includeInstance, msg) {
  var f, obj = {
status: jspb.Message.getFieldWithDefault(msg, 1, ""),
clientSecret: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.PaymentIntent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.PaymentIntent;
  return proto.billingmanager.PaymentIntent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.PaymentIntent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.PaymentIntent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.PaymentIntent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.PaymentIntent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.PaymentIntent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PaymentIntent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.billingmanager.PaymentIntent.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PaymentIntent} returns this
 */
proto.billingmanager.PaymentIntent.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string client_secret = 2;
 * @return {string}
 */
proto.billingmanager.PaymentIntent.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PaymentIntent} returns this
 */
proto.billingmanager.PaymentIntent.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.ListSubscriptionsReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ListSubscriptionsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ListSubscriptionsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ListSubscriptionsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListSubscriptionsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
statusList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ListSubscriptionsReq}
 */
proto.billingmanager.ListSubscriptionsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ListSubscriptionsReq;
  return proto.billingmanager.ListSubscriptionsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ListSubscriptionsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ListSubscriptionsReq}
 */
proto.billingmanager.ListSubscriptionsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ListSubscriptionsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ListSubscriptionsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ListSubscriptionsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListSubscriptionsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatusList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.ListSubscriptionsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ListSubscriptionsReq} returns this
 */
proto.billingmanager.ListSubscriptionsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string status = 2;
 * @return {!Array<string>}
 */
proto.billingmanager.ListSubscriptionsReq.prototype.getStatusList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.ListSubscriptionsReq} returns this
 */
proto.billingmanager.ListSubscriptionsReq.prototype.setStatusList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.ListSubscriptionsReq} returns this
 */
proto.billingmanager.ListSubscriptionsReq.prototype.addStatus = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.ListSubscriptionsReq} returns this
 */
proto.billingmanager.ListSubscriptionsReq.prototype.clearStatusList = function() {
  return this.setStatusList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.ListSubscriptionsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ListSubscriptionsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ListSubscriptionsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ListSubscriptionsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListSubscriptionsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
subscriptionsList: jspb.Message.toObjectList(msg.getSubscriptionsList(),
    proto.billingmanager.SubscriptionLite.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ListSubscriptionsReply}
 */
proto.billingmanager.ListSubscriptionsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ListSubscriptionsReply;
  return proto.billingmanager.ListSubscriptionsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ListSubscriptionsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ListSubscriptionsReply}
 */
proto.billingmanager.ListSubscriptionsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionLite;
      reader.readMessage(value,proto.billingmanager.SubscriptionLite.deserializeBinaryFromReader);
      msg.addSubscriptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ListSubscriptionsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ListSubscriptionsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ListSubscriptionsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListSubscriptionsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.SubscriptionLite.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubscriptionLite subscriptions = 1;
 * @return {!Array<!proto.billingmanager.SubscriptionLite>}
 */
proto.billingmanager.ListSubscriptionsReply.prototype.getSubscriptionsList = function() {
  return /** @type{!Array<!proto.billingmanager.SubscriptionLite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.SubscriptionLite, 1));
};


/**
 * @param {!Array<!proto.billingmanager.SubscriptionLite>} value
 * @return {!proto.billingmanager.ListSubscriptionsReply} returns this
*/
proto.billingmanager.ListSubscriptionsReply.prototype.setSubscriptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.SubscriptionLite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.SubscriptionLite}
 */
proto.billingmanager.ListSubscriptionsReply.prototype.addSubscriptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.SubscriptionLite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.ListSubscriptionsReply} returns this
 */
proto.billingmanager.ListSubscriptionsReply.prototype.clearSubscriptionsList = function() {
  return this.setSubscriptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.SubscriptionLineItem.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.SubscriptionLineItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.SubscriptionLineItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionLineItem.toObject = function(includeInstance, msg) {
  var f, obj = {
subscriptionItemId: jspb.Message.getFieldWithDefault(msg, 1, ""),
priceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
productId: jspb.Message.getFieldWithDefault(msg, 3, ""),
productName: jspb.Message.getFieldWithDefault(msg, 4, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 5, 0),
unitAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
priceNickname: jspb.Message.getFieldWithDefault(msg, 7, ""),
dedicatedNickName: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.SubscriptionLineItem}
 */
proto.billingmanager.SubscriptionLineItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.SubscriptionLineItem;
  return proto.billingmanager.SubscriptionLineItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.SubscriptionLineItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.SubscriptionLineItem}
 */
proto.billingmanager.SubscriptionLineItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionItemId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUnitAmount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceNickname(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDedicatedNickName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.SubscriptionLineItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.SubscriptionLineItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.SubscriptionLineItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionLineItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionItemId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUnitAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getPriceNickname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDedicatedNickName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string subscription_item_id = 1;
 * @return {string}
 */
proto.billingmanager.SubscriptionLineItem.prototype.getSubscriptionItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLineItem} returns this
 */
proto.billingmanager.SubscriptionLineItem.prototype.setSubscriptionItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string price_id = 2;
 * @return {string}
 */
proto.billingmanager.SubscriptionLineItem.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLineItem} returns this
 */
proto.billingmanager.SubscriptionLineItem.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string product_id = 3;
 * @return {string}
 */
proto.billingmanager.SubscriptionLineItem.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLineItem} returns this
 */
proto.billingmanager.SubscriptionLineItem.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string product_name = 4;
 * @return {string}
 */
proto.billingmanager.SubscriptionLineItem.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLineItem} returns this
 */
proto.billingmanager.SubscriptionLineItem.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 quantity = 5;
 * @return {number}
 */
proto.billingmanager.SubscriptionLineItem.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionLineItem} returns this
 */
proto.billingmanager.SubscriptionLineItem.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double unit_amount = 6;
 * @return {number}
 */
proto.billingmanager.SubscriptionLineItem.prototype.getUnitAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionLineItem} returns this
 */
proto.billingmanager.SubscriptionLineItem.prototype.setUnitAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional string price_nickname = 7;
 * @return {string}
 */
proto.billingmanager.SubscriptionLineItem.prototype.getPriceNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLineItem} returns this
 */
proto.billingmanager.SubscriptionLineItem.prototype.setPriceNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string dedicated_nick_name = 8;
 * @return {string}
 */
proto.billingmanager.SubscriptionLineItem.prototype.getDedicatedNickName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLineItem} returns this
 */
proto.billingmanager.SubscriptionLineItem.prototype.setDedicatedNickName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.SubscriptionLite.repeatedFields_ = [15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.SubscriptionLite.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.SubscriptionLite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.SubscriptionLite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionLite.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
currency: jspb.Message.getFieldWithDefault(msg, 2, ""),
status: jspb.Message.getFieldWithDefault(msg, 3, ""),
interval: jspb.Message.getFieldWithDefault(msg, 4, ""),
productName: jspb.Message.getFieldWithDefault(msg, 5, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 6, 0),
currentPaidTotal: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
unitAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endsOn: (f = msg.getEndsOn()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
dedicatedNickName: jspb.Message.getFieldWithDefault(msg, 11, ""),
currentPeriodEnd: jspb.Message.getFieldWithDefault(msg, 12, 0),
priceNickname: jspb.Message.getFieldWithDefault(msg, 13, ""),
intervalCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
lineItemsList: jspb.Message.toObjectList(msg.getLineItemsList(),
    proto.billingmanager.SubscriptionLineItem.toObject, includeInstance),
stripeId: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.SubscriptionLite}
 */
proto.billingmanager.SubscriptionLite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.SubscriptionLite;
  return proto.billingmanager.SubscriptionLite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.SubscriptionLite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.SubscriptionLite}
 */
proto.billingmanager.SubscriptionLite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterval(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentPaidTotal(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUnitAmount(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndsOn(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDedicatedNickName(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCurrentPeriodEnd(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceNickname(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIntervalCount(value);
      break;
    case 15:
      var value = new proto.billingmanager.SubscriptionLineItem;
      reader.readMessage(value,proto.billingmanager.SubscriptionLineItem.deserializeBinaryFromReader);
      msg.addLineItems(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setStripeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.SubscriptionLite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.SubscriptionLite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.SubscriptionLite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionLite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInterval();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCurrentPaidTotal();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getUnitAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndsOn();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDedicatedNickName();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCurrentPeriodEnd();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getPriceNickname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getIntervalCount();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getLineItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.billingmanager.SubscriptionLineItem.serializeBinaryToWriter
    );
  }
  f = message.getStripeId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.billingmanager.SubscriptionLite.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.billingmanager.SubscriptionLite.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.billingmanager.SubscriptionLite.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string interval = 4;
 * @return {string}
 */
proto.billingmanager.SubscriptionLite.prototype.getInterval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setInterval = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string product_name = 5;
 * @return {string}
 */
proto.billingmanager.SubscriptionLite.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 quantity = 6;
 * @return {number}
 */
proto.billingmanager.SubscriptionLite.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double current_paid_total = 7;
 * @return {number}
 */
proto.billingmanager.SubscriptionLite.prototype.getCurrentPaidTotal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setCurrentPaidTotal = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double unit_amount = 8;
 * @return {number}
 */
proto.billingmanager.SubscriptionLite.prototype.getUnitAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setUnitAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.SubscriptionLite.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
*/
proto.billingmanager.SubscriptionLite.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.SubscriptionLite.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp ends_on = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.SubscriptionLite.prototype.getEndsOn = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
*/
proto.billingmanager.SubscriptionLite.prototype.setEndsOn = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.clearEndsOn = function() {
  return this.setEndsOn(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.SubscriptionLite.prototype.hasEndsOn = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string dedicated_nick_name = 11;
 * @return {string}
 */
proto.billingmanager.SubscriptionLite.prototype.getDedicatedNickName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setDedicatedNickName = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 current_period_end = 12;
 * @return {number}
 */
proto.billingmanager.SubscriptionLite.prototype.getCurrentPeriodEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setCurrentPeriodEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string price_nickname = 13;
 * @return {string}
 */
proto.billingmanager.SubscriptionLite.prototype.getPriceNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setPriceNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int64 interval_count = 14;
 * @return {number}
 */
proto.billingmanager.SubscriptionLite.prototype.getIntervalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setIntervalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * repeated SubscriptionLineItem line_items = 15;
 * @return {!Array<!proto.billingmanager.SubscriptionLineItem>}
 */
proto.billingmanager.SubscriptionLite.prototype.getLineItemsList = function() {
  return /** @type{!Array<!proto.billingmanager.SubscriptionLineItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.SubscriptionLineItem, 15));
};


/**
 * @param {!Array<!proto.billingmanager.SubscriptionLineItem>} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
*/
proto.billingmanager.SubscriptionLite.prototype.setLineItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.billingmanager.SubscriptionLineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.SubscriptionLineItem}
 */
proto.billingmanager.SubscriptionLite.prototype.addLineItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.billingmanager.SubscriptionLineItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.clearLineItemsList = function() {
  return this.setLineItemsList([]);
};


/**
 * optional string stripe_id = 16;
 * @return {string}
 */
proto.billingmanager.SubscriptionLite.prototype.getStripeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionLite} returns this
 */
proto.billingmanager.SubscriptionLite.prototype.setStripeId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ReactivateSubscriptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ReactivateSubscriptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ReactivateSubscriptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ReactivateSubscriptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ReactivateSubscriptionReq}
 */
proto.billingmanager.ReactivateSubscriptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ReactivateSubscriptionReq;
  return proto.billingmanager.ReactivateSubscriptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ReactivateSubscriptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ReactivateSubscriptionReq}
 */
proto.billingmanager.ReactivateSubscriptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ReactivateSubscriptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ReactivateSubscriptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ReactivateSubscriptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ReactivateSubscriptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.ReactivateSubscriptionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ReactivateSubscriptionReq} returns this
 */
proto.billingmanager.ReactivateSubscriptionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.ReactivateSubscriptionReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ReactivateSubscriptionReq} returns this
 */
proto.billingmanager.ReactivateSubscriptionReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ReactivateSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ReactivateSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ReactivateSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ReactivateSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ReactivateSubscriptionReply}
 */
proto.billingmanager.ReactivateSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ReactivateSubscriptionReply;
  return proto.billingmanager.ReactivateSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ReactivateSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ReactivateSubscriptionReply}
 */
proto.billingmanager.ReactivateSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ReactivateSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ReactivateSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ReactivateSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ReactivateSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ListInvoicesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ListInvoicesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ListInvoicesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListInvoicesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ListInvoicesReq}
 */
proto.billingmanager.ListInvoicesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ListInvoicesReq;
  return proto.billingmanager.ListInvoicesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ListInvoicesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ListInvoicesReq}
 */
proto.billingmanager.ListInvoicesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ListInvoicesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ListInvoicesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ListInvoicesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListInvoicesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.ListInvoicesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ListInvoicesReq} returns this
 */
proto.billingmanager.ListInvoicesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.billingmanager.ListInvoicesReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ListInvoicesReq} returns this
 */
proto.billingmanager.ListInvoicesReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.billingmanager.ListInvoicesReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.ListInvoicesReq} returns this
 */
proto.billingmanager.ListInvoicesReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.ListInvoicesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ListInvoicesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ListInvoicesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ListInvoicesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListInvoicesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
invoicesList: jspb.Message.toObjectList(msg.getInvoicesList(),
    proto.billingmanager.Invoice.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ListInvoicesReply}
 */
proto.billingmanager.ListInvoicesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ListInvoicesReply;
  return proto.billingmanager.ListInvoicesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ListInvoicesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ListInvoicesReply}
 */
proto.billingmanager.ListInvoicesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.Invoice;
      reader.readMessage(value,proto.billingmanager.Invoice.deserializeBinaryFromReader);
      msg.addInvoices(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ListInvoicesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ListInvoicesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ListInvoicesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListInvoicesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.Invoice.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated Invoice invoices = 1;
 * @return {!Array<!proto.billingmanager.Invoice>}
 */
proto.billingmanager.ListInvoicesReply.prototype.getInvoicesList = function() {
  return /** @type{!Array<!proto.billingmanager.Invoice>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.Invoice, 1));
};


/**
 * @param {!Array<!proto.billingmanager.Invoice>} value
 * @return {!proto.billingmanager.ListInvoicesReply} returns this
*/
proto.billingmanager.ListInvoicesReply.prototype.setInvoicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.Invoice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.Invoice}
 */
proto.billingmanager.ListInvoicesReply.prototype.addInvoices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.Invoice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.ListInvoicesReply} returns this
 */
proto.billingmanager.ListInvoicesReply.prototype.clearInvoicesList = function() {
  return this.setInvoicesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.billingmanager.ListInvoicesReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ListInvoicesReply} returns this
 */
proto.billingmanager.ListInvoicesReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.billingmanager.ListInvoicesReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.ListInvoicesReply} returns this
 */
proto.billingmanager.ListInvoicesReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.billingmanager.ListInvoicesReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.ListInvoicesReply} returns this
 */
proto.billingmanager.ListInvoicesReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.Invoice.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.Invoice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.Invoice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.Invoice.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
invoiceNumber: jspb.Message.getFieldWithDefault(msg, 2, ""),
paymentMethod: jspb.Message.getFieldWithDefault(msg, 3, ""),
cardNumber: jspb.Message.getFieldWithDefault(msg, 4, ""),
amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
status: jspb.Message.getFieldWithDefault(msg, 6, ""),
pdfUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.Invoice}
 */
proto.billingmanager.Invoice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.Invoice;
  return proto.billingmanager.Invoice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.Invoice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.Invoice}
 */
proto.billingmanager.Invoice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethod(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardNumber(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPdfUrl(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.Invoice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.Invoice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.Invoice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.Invoice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getInvoiceNumber();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCardNumber();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPdfUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {number}
 */
proto.billingmanager.Invoice.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.Invoice} returns this
 */
proto.billingmanager.Invoice.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string invoice_number = 2;
 * @return {string}
 */
proto.billingmanager.Invoice.prototype.getInvoiceNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Invoice} returns this
 */
proto.billingmanager.Invoice.prototype.setInvoiceNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string payment_method = 3;
 * @return {string}
 */
proto.billingmanager.Invoice.prototype.getPaymentMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Invoice} returns this
 */
proto.billingmanager.Invoice.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string card_number = 4;
 * @return {string}
 */
proto.billingmanager.Invoice.prototype.getCardNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Invoice} returns this
 */
proto.billingmanager.Invoice.prototype.setCardNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double amount = 5;
 * @return {number}
 */
proto.billingmanager.Invoice.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.Invoice} returns this
 */
proto.billingmanager.Invoice.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.billingmanager.Invoice.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Invoice} returns this
 */
proto.billingmanager.Invoice.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string pdf_url = 7;
 * @return {string}
 */
proto.billingmanager.Invoice.prototype.getPdfUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Invoice} returns this
 */
proto.billingmanager.Invoice.prototype.setPdfUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.Invoice.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.Invoice} returns this
*/
proto.billingmanager.Invoice.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.Invoice} returns this
 */
proto.billingmanager.Invoice.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.Invoice.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ListPricesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ListPricesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ListPricesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListPricesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ListPricesReq}
 */
proto.billingmanager.ListPricesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ListPricesReq;
  return proto.billingmanager.ListPricesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ListPricesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ListPricesReq}
 */
proto.billingmanager.ListPricesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ListPricesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ListPricesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ListPricesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListPricesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.ListPricesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ListPricesReq} returns this
 */
proto.billingmanager.ListPricesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.ListPricesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ListPricesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ListPricesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ListPricesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListPricesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
pricesList: jspb.Message.toObjectList(msg.getPricesList(),
    proto.billingmanager.Price.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ListPricesReply}
 */
proto.billingmanager.ListPricesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ListPricesReply;
  return proto.billingmanager.ListPricesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ListPricesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ListPricesReply}
 */
proto.billingmanager.ListPricesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.Price;
      reader.readMessage(value,proto.billingmanager.Price.deserializeBinaryFromReader);
      msg.addPrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ListPricesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ListPricesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ListPricesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListPricesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.Price.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Price prices = 1;
 * @return {!Array<!proto.billingmanager.Price>}
 */
proto.billingmanager.ListPricesReply.prototype.getPricesList = function() {
  return /** @type{!Array<!proto.billingmanager.Price>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.Price, 1));
};


/**
 * @param {!Array<!proto.billingmanager.Price>} value
 * @return {!proto.billingmanager.ListPricesReply} returns this
*/
proto.billingmanager.ListPricesReply.prototype.setPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.Price=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.Price}
 */
proto.billingmanager.ListPricesReply.prototype.addPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.Price, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.ListPricesReply} returns this
 */
proto.billingmanager.ListPricesReply.prototype.clearPricesList = function() {
  return this.setPricesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.PriceTier.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.PriceTier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.PriceTier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PriceTier.toObject = function(includeInstance, msg) {
  var f, obj = {
upTo: (f = msg.getUpTo()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
unitAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
flatAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.PriceTier}
 */
proto.billingmanager.PriceTier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.PriceTier;
  return proto.billingmanager.PriceTier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.PriceTier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.PriceTier}
 */
proto.billingmanager.PriceTier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setUpTo(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUnitAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFlatAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.PriceTier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.PriceTier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.PriceTier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PriceTier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpTo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getUnitAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getFlatAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.Int64Value up_to = 1;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.billingmanager.PriceTier.prototype.getUpTo = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.billingmanager.PriceTier} returns this
*/
proto.billingmanager.PriceTier.prototype.setUpTo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.PriceTier} returns this
 */
proto.billingmanager.PriceTier.prototype.clearUpTo = function() {
  return this.setUpTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.PriceTier.prototype.hasUpTo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double unit_amount = 2;
 * @return {number}
 */
proto.billingmanager.PriceTier.prototype.getUnitAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PriceTier} returns this
 */
proto.billingmanager.PriceTier.prototype.setUnitAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double flat_amount = 3;
 * @return {number}
 */
proto.billingmanager.PriceTier.prototype.getFlatAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PriceTier} returns this
 */
proto.billingmanager.PriceTier.prototype.setFlatAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.Price.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.Price.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.Price.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.Price} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.Price.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
unitAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
nickname: jspb.Message.getFieldWithDefault(msg, 4, ""),
trialPeriodDays: jspb.Message.getFieldWithDefault(msg, 5, 0),
billingScheme: jspb.Message.getFieldWithDefault(msg, 6, ""),
tiersMode: jspb.Message.getFieldWithDefault(msg, 7, ""),
tiersList: jspb.Message.toObjectList(msg.getTiersList(),
    proto.billingmanager.PriceTier.toObject, includeInstance),
startingFromAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
stripePriceId: jspb.Message.getFieldWithDefault(msg, 10, ""),
superseded: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
productId: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.Price}
 */
proto.billingmanager.Price.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.Price;
  return proto.billingmanager.Price.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.Price} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.Price}
 */
proto.billingmanager.Price.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUnitAmount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNickname(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrialPeriodDays(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingScheme(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTiersMode(value);
      break;
    case 8:
      var value = new proto.billingmanager.PriceTier;
      reader.readMessage(value,proto.billingmanager.PriceTier.deserializeBinaryFromReader);
      msg.addTiers(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStartingFromAmount(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setStripePriceId(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuperseded(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.Price.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.Price.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.Price} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.Price.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUnitAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getNickname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTrialPeriodDays();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getBillingScheme();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTiersMode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTiersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.billingmanager.PriceTier.serializeBinaryToWriter
    );
  }
  f = message.getStartingFromAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getStripePriceId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSuperseded();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.billingmanager.Price.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.billingmanager.Price.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double unit_amount = 3;
 * @return {number}
 */
proto.billingmanager.Price.prototype.getUnitAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setUnitAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string nickname = 4;
 * @return {string}
 */
proto.billingmanager.Price.prototype.getNickname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setNickname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 trial_period_days = 5;
 * @return {number}
 */
proto.billingmanager.Price.prototype.getTrialPeriodDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setTrialPeriodDays = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string billing_scheme = 6;
 * @return {string}
 */
proto.billingmanager.Price.prototype.getBillingScheme = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setBillingScheme = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string tiers_mode = 7;
 * @return {string}
 */
proto.billingmanager.Price.prototype.getTiersMode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setTiersMode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated PriceTier tiers = 8;
 * @return {!Array<!proto.billingmanager.PriceTier>}
 */
proto.billingmanager.Price.prototype.getTiersList = function() {
  return /** @type{!Array<!proto.billingmanager.PriceTier>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.PriceTier, 8));
};


/**
 * @param {!Array<!proto.billingmanager.PriceTier>} value
 * @return {!proto.billingmanager.Price} returns this
*/
proto.billingmanager.Price.prototype.setTiersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.billingmanager.PriceTier=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.PriceTier}
 */
proto.billingmanager.Price.prototype.addTiers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.billingmanager.PriceTier, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.clearTiersList = function() {
  return this.setTiersList([]);
};


/**
 * optional double starting_from_amount = 9;
 * @return {number}
 */
proto.billingmanager.Price.prototype.getStartingFromAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setStartingFromAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional string stripe_price_id = 10;
 * @return {string}
 */
proto.billingmanager.Price.prototype.getStripePriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setStripePriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional bool superseded = 11;
 * @return {boolean}
 */
proto.billingmanager.Price.prototype.getSuperseded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setSuperseded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string product_id = 12;
 * @return {string}
 */
proto.billingmanager.Price.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Price} returns this
 */
proto.billingmanager.Price.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ListCardsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ListCardsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ListCardsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListCardsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ListCardsReq}
 */
proto.billingmanager.ListCardsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ListCardsReq;
  return proto.billingmanager.ListCardsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ListCardsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ListCardsReq}
 */
proto.billingmanager.ListCardsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ListCardsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ListCardsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ListCardsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListCardsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.ListCardsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ListCardsReq} returns this
 */
proto.billingmanager.ListCardsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.ListCardsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ListCardsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ListCardsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ListCardsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListCardsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
cardsList: jspb.Message.toObjectList(msg.getCardsList(),
    proto.billingmanager.Card.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ListCardsReply}
 */
proto.billingmanager.ListCardsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ListCardsReply;
  return proto.billingmanager.ListCardsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ListCardsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ListCardsReply}
 */
proto.billingmanager.ListCardsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.Card;
      reader.readMessage(value,proto.billingmanager.Card.deserializeBinaryFromReader);
      msg.addCards(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ListCardsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ListCardsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ListCardsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ListCardsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.Card.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Card cards = 1;
 * @return {!Array<!proto.billingmanager.Card>}
 */
proto.billingmanager.ListCardsReply.prototype.getCardsList = function() {
  return /** @type{!Array<!proto.billingmanager.Card>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.Card, 1));
};


/**
 * @param {!Array<!proto.billingmanager.Card>} value
 * @return {!proto.billingmanager.ListCardsReply} returns this
*/
proto.billingmanager.ListCardsReply.prototype.setCardsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.Card=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.Card}
 */
proto.billingmanager.ListCardsReply.prototype.addCards = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.Card, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.ListCardsReply} returns this
 */
proto.billingmanager.ListCardsReply.prototype.clearCardsList = function() {
  return this.setCardsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.Card.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.Card.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.Card} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.Card.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
brand: jspb.Message.getFieldWithDefault(msg, 2, ""),
cardNumber: jspb.Message.getFieldWithDefault(msg, 3, ""),
expiryMonth: jspb.Message.getFieldWithDefault(msg, 4, 0),
expiryYear: jspb.Message.getFieldWithDefault(msg, 5, 0),
isDefault: (f = msg.getIsDefault()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
paymentMethodId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.Card}
 */
proto.billingmanager.Card.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.Card;
  return proto.billingmanager.Card.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.Card} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.Card}
 */
proto.billingmanager.Card.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrand(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiryMonth(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiryYear(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsDefault(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethodId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.Card.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.Card.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.Card} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.Card.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBrand();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCardNumber();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExpiryMonth();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getExpiryYear();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getIsDefault();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getPaymentMethodId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.billingmanager.Card.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Card} returns this
 */
proto.billingmanager.Card.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string brand = 2;
 * @return {string}
 */
proto.billingmanager.Card.prototype.getBrand = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Card} returns this
 */
proto.billingmanager.Card.prototype.setBrand = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string card_number = 3;
 * @return {string}
 */
proto.billingmanager.Card.prototype.getCardNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Card} returns this
 */
proto.billingmanager.Card.prototype.setCardNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 expiry_month = 4;
 * @return {number}
 */
proto.billingmanager.Card.prototype.getExpiryMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.Card} returns this
 */
proto.billingmanager.Card.prototype.setExpiryMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 expiry_year = 5;
 * @return {number}
 */
proto.billingmanager.Card.prototype.getExpiryYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.Card} returns this
 */
proto.billingmanager.Card.prototype.setExpiryYear = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional google.protobuf.BoolValue is_default = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.billingmanager.Card.prototype.getIsDefault = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.billingmanager.Card} returns this
*/
proto.billingmanager.Card.prototype.setIsDefault = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.Card} returns this
 */
proto.billingmanager.Card.prototype.clearIsDefault = function() {
  return this.setIsDefault(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.Card.prototype.hasIsDefault = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string payment_method_id = 7;
 * @return {string}
 */
proto.billingmanager.Card.prototype.getPaymentMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Card} returns this
 */
proto.billingmanager.Card.prototype.setPaymentMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.SetDefaultPaymentMethodReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.SetDefaultPaymentMethodReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.SetDefaultPaymentMethodReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SetDefaultPaymentMethodReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
cardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
paymentMethodId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.SetDefaultPaymentMethodReq}
 */
proto.billingmanager.SetDefaultPaymentMethodReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.SetDefaultPaymentMethodReq;
  return proto.billingmanager.SetDefaultPaymentMethodReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.SetDefaultPaymentMethodReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.SetDefaultPaymentMethodReq}
 */
proto.billingmanager.SetDefaultPaymentMethodReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethodId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.SetDefaultPaymentMethodReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.SetDefaultPaymentMethodReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.SetDefaultPaymentMethodReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SetDefaultPaymentMethodReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaymentMethodId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.SetDefaultPaymentMethodReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SetDefaultPaymentMethodReq} returns this
 */
proto.billingmanager.SetDefaultPaymentMethodReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string card_id = 2;
 * @return {string}
 */
proto.billingmanager.SetDefaultPaymentMethodReq.prototype.getCardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SetDefaultPaymentMethodReq} returns this
 */
proto.billingmanager.SetDefaultPaymentMethodReq.prototype.setCardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string payment_method_id = 3;
 * @return {string}
 */
proto.billingmanager.SetDefaultPaymentMethodReq.prototype.getPaymentMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SetDefaultPaymentMethodReq} returns this
 */
proto.billingmanager.SetDefaultPaymentMethodReq.prototype.setPaymentMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.SetDefaultPaymentMethodReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.SetDefaultPaymentMethodReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.SetDefaultPaymentMethodReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SetDefaultPaymentMethodReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.SetDefaultPaymentMethodReply}
 */
proto.billingmanager.SetDefaultPaymentMethodReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.SetDefaultPaymentMethodReply;
  return proto.billingmanager.SetDefaultPaymentMethodReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.SetDefaultPaymentMethodReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.SetDefaultPaymentMethodReply}
 */
proto.billingmanager.SetDefaultPaymentMethodReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.SetDefaultPaymentMethodReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.SetDefaultPaymentMethodReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.SetDefaultPaymentMethodReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SetDefaultPaymentMethodReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.DeleteCardReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.DeleteCardReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.DeleteCardReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.DeleteCardReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
cardId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.DeleteCardReq}
 */
proto.billingmanager.DeleteCardReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.DeleteCardReq;
  return proto.billingmanager.DeleteCardReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.DeleteCardReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.DeleteCardReq}
 */
proto.billingmanager.DeleteCardReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.DeleteCardReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.DeleteCardReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.DeleteCardReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.DeleteCardReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.DeleteCardReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.DeleteCardReq} returns this
 */
proto.billingmanager.DeleteCardReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string card_id = 2;
 * @return {string}
 */
proto.billingmanager.DeleteCardReq.prototype.getCardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.DeleteCardReq} returns this
 */
proto.billingmanager.DeleteCardReq.prototype.setCardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.DeleteCardReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.DeleteCardReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.DeleteCardReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.DeleteCardReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.DeleteCardReply}
 */
proto.billingmanager.DeleteCardReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.DeleteCardReply;
  return proto.billingmanager.DeleteCardReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.DeleteCardReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.DeleteCardReply}
 */
proto.billingmanager.DeleteCardReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.DeleteCardReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.DeleteCardReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.DeleteCardReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.DeleteCardReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CardSetUpIntentReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CardSetUpIntentReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CardSetUpIntentReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CardSetUpIntentReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CardSetUpIntentReq}
 */
proto.billingmanager.CardSetUpIntentReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CardSetUpIntentReq;
  return proto.billingmanager.CardSetUpIntentReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CardSetUpIntentReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CardSetUpIntentReq}
 */
proto.billingmanager.CardSetUpIntentReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CardSetUpIntentReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CardSetUpIntentReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CardSetUpIntentReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CardSetUpIntentReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.CardSetUpIntentReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CardSetUpIntentReq} returns this
 */
proto.billingmanager.CardSetUpIntentReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CardSetUpIntentReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CardSetUpIntentReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CardSetUpIntentReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CardSetUpIntentReply.toObject = function(includeInstance, msg) {
  var f, obj = {
clientSecret: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CardSetUpIntentReply}
 */
proto.billingmanager.CardSetUpIntentReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CardSetUpIntentReply;
  return proto.billingmanager.CardSetUpIntentReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CardSetUpIntentReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CardSetUpIntentReply}
 */
proto.billingmanager.CardSetUpIntentReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CardSetUpIntentReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CardSetUpIntentReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CardSetUpIntentReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CardSetUpIntentReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string client_secret = 1;
 * @return {string}
 */
proto.billingmanager.CardSetUpIntentReply.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CardSetUpIntentReply} returns this
 */
proto.billingmanager.CardSetUpIntentReply.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntRegisterUserToStripeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntRegisterUserToStripeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntRegisterUserToStripeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntRegisterUserToStripeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntRegisterUserToStripeReq}
 */
proto.billingmanager.IntRegisterUserToStripeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntRegisterUserToStripeReq;
  return proto.billingmanager.IntRegisterUserToStripeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntRegisterUserToStripeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntRegisterUserToStripeReq}
 */
proto.billingmanager.IntRegisterUserToStripeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntRegisterUserToStripeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntRegisterUserToStripeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntRegisterUserToStripeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntRegisterUserToStripeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.IntRegisterUserToStripeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntRegisterUserToStripeReq} returns this
 */
proto.billingmanager.IntRegisterUserToStripeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.billingmanager.IntRegisterUserToStripeReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntRegisterUserToStripeReq} returns this
 */
proto.billingmanager.IntRegisterUserToStripeReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.billingmanager.IntRegisterUserToStripeReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntRegisterUserToStripeReq} returns this
 */
proto.billingmanager.IntRegisterUserToStripeReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntRegisterUserToStripeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntRegisterUserToStripeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntRegisterUserToStripeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntRegisterUserToStripeReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntRegisterUserToStripeReply}
 */
proto.billingmanager.IntRegisterUserToStripeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntRegisterUserToStripeReply;
  return proto.billingmanager.IntRegisterUserToStripeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntRegisterUserToStripeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntRegisterUserToStripeReply}
 */
proto.billingmanager.IntRegisterUserToStripeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntRegisterUserToStripeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntRegisterUserToStripeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntRegisterUserToStripeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntRegisterUserToStripeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntUpdateUserToStripeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntUpdateUserToStripeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntUpdateUserToStripeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntUpdateUserToStripeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntUpdateUserToStripeReq}
 */
proto.billingmanager.IntUpdateUserToStripeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntUpdateUserToStripeReq;
  return proto.billingmanager.IntUpdateUserToStripeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntUpdateUserToStripeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntUpdateUserToStripeReq}
 */
proto.billingmanager.IntUpdateUserToStripeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntUpdateUserToStripeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntUpdateUserToStripeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntUpdateUserToStripeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntUpdateUserToStripeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.IntUpdateUserToStripeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntUpdateUserToStripeReq} returns this
 */
proto.billingmanager.IntUpdateUserToStripeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.billingmanager.IntUpdateUserToStripeReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntUpdateUserToStripeReq} returns this
 */
proto.billingmanager.IntUpdateUserToStripeReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.billingmanager.IntUpdateUserToStripeReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntUpdateUserToStripeReq} returns this
 */
proto.billingmanager.IntUpdateUserToStripeReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntUpdateUserToStripeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntUpdateUserToStripeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntUpdateUserToStripeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntUpdateUserToStripeReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntUpdateUserToStripeReply}
 */
proto.billingmanager.IntUpdateUserToStripeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntUpdateUserToStripeReply;
  return proto.billingmanager.IntUpdateUserToStripeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntUpdateUserToStripeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntUpdateUserToStripeReply}
 */
proto.billingmanager.IntUpdateUserToStripeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntUpdateUserToStripeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntUpdateUserToStripeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntUpdateUserToStripeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntUpdateUserToStripeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetUpcomingInvoiceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetUpcomingInvoiceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetUpcomingInvoiceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
invoiceType: jspb.Message.getFieldWithDefault(msg, 3, 0),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
priceId: jspb.Message.getFieldWithDefault(msg, 5, ""),
coupon: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetUpcomingInvoiceReq}
 */
proto.billingmanager.GetUpcomingInvoiceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetUpcomingInvoiceReq;
  return proto.billingmanager.GetUpcomingInvoiceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetUpcomingInvoiceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetUpcomingInvoiceReq}
 */
proto.billingmanager.GetUpcomingInvoiceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {!proto.billingmanager.UpcomingInvoiceTypeEnum} */ (reader.readEnum());
      msg.setInvoiceType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoupon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetUpcomingInvoiceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetUpcomingInvoiceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetUpcomingInvoiceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getInvoiceType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCoupon();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 quantity = 2;
 * @return {number}
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional UpcomingInvoiceTypeEnum invoice_type = 3;
 * @return {!proto.billingmanager.UpcomingInvoiceTypeEnum}
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.getInvoiceType = function() {
  return /** @type {!proto.billingmanager.UpcomingInvoiceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.billingmanager.UpcomingInvoiceTypeEnum} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.setInvoiceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string subscription_id = 4;
 * @return {string}
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string price_id = 5;
 * @return {string}
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string coupon = 6;
 * @return {string}
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.getCoupon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReq.prototype.setCoupon = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetUpcomingInvoiceReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetUpcomingInvoiceReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetUpcomingInvoiceReply.toObject = function(includeInstance, msg) {
  var f, obj = {
amountDue: jspb.Message.getFieldWithDefault(msg, 1, 0),
amountPaid: jspb.Message.getFieldWithDefault(msg, 2, 0),
total: jspb.Message.getFieldWithDefault(msg, 3, 0),
subTotal: jspb.Message.getFieldWithDefault(msg, 4, 0),
currency: jspb.Message.getFieldWithDefault(msg, 5, ""),
discount: jspb.Message.getFieldWithDefault(msg, 6, 0),
appliedBalance: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetUpcomingInvoiceReply}
 */
proto.billingmanager.GetUpcomingInvoiceReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetUpcomingInvoiceReply;
  return proto.billingmanager.GetUpcomingInvoiceReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetUpcomingInvoiceReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetUpcomingInvoiceReply}
 */
proto.billingmanager.GetUpcomingInvoiceReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountDue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountPaid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubTotal(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAppliedBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetUpcomingInvoiceReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetUpcomingInvoiceReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetUpcomingInvoiceReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmountDue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAmountPaid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSubTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAppliedBalance();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 amount_due = 1;
 * @return {number}
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.getAmountDue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.setAmountDue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 amount_paid = 2;
 * @return {number}
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.getAmountPaid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.setAmountPaid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 total = 3;
 * @return {number}
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 sub_total = 4;
 * @return {number}
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.getSubTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.setSubTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string currency = 5;
 * @return {string}
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 discount = 6;
 * @return {number}
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 applied_balance = 7;
 * @return {number}
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.getAppliedBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.GetUpcomingInvoiceReply.prototype.setAppliedBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.PreviewCheckoutReq.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.PreviewCheckoutReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.PreviewCheckoutReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewCheckoutReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
updatesList: jspb.Message.toObjectList(msg.getUpdatesList(),
    proto.billingmanager.SubscriptionUpdate.toObject, includeInstance),
newSubsList: jspb.Message.toObjectList(msg.getNewSubsList(),
    proto.billingmanager.NewSubscriptionPreview.toObject, includeInstance),
coupon: jspb.Message.getFieldWithDefault(msg, 4, ""),
useTrial: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
skipCancelOffer: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.PreviewCheckoutReq}
 */
proto.billingmanager.PreviewCheckoutReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.PreviewCheckoutReq;
  return proto.billingmanager.PreviewCheckoutReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.PreviewCheckoutReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.PreviewCheckoutReq}
 */
proto.billingmanager.PreviewCheckoutReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.billingmanager.SubscriptionUpdate;
      reader.readMessage(value,proto.billingmanager.SubscriptionUpdate.deserializeBinaryFromReader);
      msg.addUpdates(value);
      break;
    case 3:
      var value = new proto.billingmanager.NewSubscriptionPreview;
      reader.readMessage(value,proto.billingmanager.NewSubscriptionPreview.deserializeBinaryFromReader);
      msg.addNewSubs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoupon(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseTrial(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSkipCancelOffer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.PreviewCheckoutReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.PreviewCheckoutReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewCheckoutReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.billingmanager.SubscriptionUpdate.serializeBinaryToWriter
    );
  }
  f = message.getNewSubsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.billingmanager.NewSubscriptionPreview.serializeBinaryToWriter
    );
  }
  f = message.getCoupon();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUseTrial();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getSkipCancelOffer();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PreviewCheckoutReq} returns this
 */
proto.billingmanager.PreviewCheckoutReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SubscriptionUpdate updates = 2;
 * @return {!Array<!proto.billingmanager.SubscriptionUpdate>}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.getUpdatesList = function() {
  return /** @type{!Array<!proto.billingmanager.SubscriptionUpdate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.SubscriptionUpdate, 2));
};


/**
 * @param {!Array<!proto.billingmanager.SubscriptionUpdate>} value
 * @return {!proto.billingmanager.PreviewCheckoutReq} returns this
*/
proto.billingmanager.PreviewCheckoutReq.prototype.setUpdatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.billingmanager.SubscriptionUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.SubscriptionUpdate}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.addUpdates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.billingmanager.SubscriptionUpdate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.PreviewCheckoutReq} returns this
 */
proto.billingmanager.PreviewCheckoutReq.prototype.clearUpdatesList = function() {
  return this.setUpdatesList([]);
};


/**
 * repeated NewSubscriptionPreview new_subs = 3;
 * @return {!Array<!proto.billingmanager.NewSubscriptionPreview>}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.getNewSubsList = function() {
  return /** @type{!Array<!proto.billingmanager.NewSubscriptionPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.NewSubscriptionPreview, 3));
};


/**
 * @param {!Array<!proto.billingmanager.NewSubscriptionPreview>} value
 * @return {!proto.billingmanager.PreviewCheckoutReq} returns this
*/
proto.billingmanager.PreviewCheckoutReq.prototype.setNewSubsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.billingmanager.NewSubscriptionPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.NewSubscriptionPreview}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.addNewSubs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.billingmanager.NewSubscriptionPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.PreviewCheckoutReq} returns this
 */
proto.billingmanager.PreviewCheckoutReq.prototype.clearNewSubsList = function() {
  return this.setNewSubsList([]);
};


/**
 * optional string coupon = 4;
 * @return {string}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.getCoupon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PreviewCheckoutReq} returns this
 */
proto.billingmanager.PreviewCheckoutReq.prototype.setCoupon = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool use_trial = 5;
 * @return {boolean}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.getUseTrial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.PreviewCheckoutReq} returns this
 */
proto.billingmanager.PreviewCheckoutReq.prototype.setUseTrial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool skip_cancel_offer = 6;
 * @return {boolean}
 */
proto.billingmanager.PreviewCheckoutReq.prototype.getSkipCancelOffer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.PreviewCheckoutReq} returns this
 */
proto.billingmanager.PreviewCheckoutReq.prototype.setSkipCancelOffer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.SubscriptionUpdate.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.SubscriptionUpdate.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.SubscriptionUpdate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.SubscriptionUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionUpdate.toObject = function(includeInstance, msg) {
  var f, obj = {
subscriptionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.billingmanager.SubscriptionItemDelta.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.SubscriptionUpdate}
 */
proto.billingmanager.SubscriptionUpdate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.SubscriptionUpdate;
  return proto.billingmanager.SubscriptionUpdate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.SubscriptionUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.SubscriptionUpdate}
 */
proto.billingmanager.SubscriptionUpdate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 2:
      var value = new proto.billingmanager.SubscriptionItemDelta;
      reader.readMessage(value,proto.billingmanager.SubscriptionItemDelta.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.SubscriptionUpdate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.SubscriptionUpdate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.SubscriptionUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionUpdate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.billingmanager.SubscriptionItemDelta.serializeBinaryToWriter
    );
  }
};


/**
 * optional string subscription_id = 1;
 * @return {string}
 */
proto.billingmanager.SubscriptionUpdate.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionUpdate} returns this
 */
proto.billingmanager.SubscriptionUpdate.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SubscriptionItemDelta items = 2;
 * @return {!Array<!proto.billingmanager.SubscriptionItemDelta>}
 */
proto.billingmanager.SubscriptionUpdate.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.billingmanager.SubscriptionItemDelta>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.SubscriptionItemDelta, 2));
};


/**
 * @param {!Array<!proto.billingmanager.SubscriptionItemDelta>} value
 * @return {!proto.billingmanager.SubscriptionUpdate} returns this
*/
proto.billingmanager.SubscriptionUpdate.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.billingmanager.SubscriptionItemDelta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.SubscriptionItemDelta}
 */
proto.billingmanager.SubscriptionUpdate.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.billingmanager.SubscriptionItemDelta, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.SubscriptionUpdate} returns this
 */
proto.billingmanager.SubscriptionUpdate.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.SubscriptionItemDelta.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.SubscriptionItemDelta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.SubscriptionItemDelta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionItemDelta.toObject = function(includeInstance, msg) {
  var f, obj = {
priceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
itemId: jspb.Message.getFieldWithDefault(msg, 3, ""),
remove: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.SubscriptionItemDelta}
 */
proto.billingmanager.SubscriptionItemDelta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.SubscriptionItemDelta;
  return proto.billingmanager.SubscriptionItemDelta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.SubscriptionItemDelta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.SubscriptionItemDelta}
 */
proto.billingmanager.SubscriptionItemDelta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemove(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.SubscriptionItemDelta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.SubscriptionItemDelta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.SubscriptionItemDelta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionItemDelta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getItemId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRemove();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string price_id = 1;
 * @return {string}
 */
proto.billingmanager.SubscriptionItemDelta.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionItemDelta} returns this
 */
proto.billingmanager.SubscriptionItemDelta.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 quantity = 2;
 * @return {number}
 */
proto.billingmanager.SubscriptionItemDelta.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionItemDelta} returns this
 */
proto.billingmanager.SubscriptionItemDelta.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string item_id = 3;
 * @return {string}
 */
proto.billingmanager.SubscriptionItemDelta.prototype.getItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionItemDelta} returns this
 */
proto.billingmanager.SubscriptionItemDelta.prototype.setItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool remove = 4;
 * @return {boolean}
 */
proto.billingmanager.SubscriptionItemDelta.prototype.getRemove = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.SubscriptionItemDelta} returns this
 */
proto.billingmanager.SubscriptionItemDelta.prototype.setRemove = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.NewSubscriptionPreview.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.NewSubscriptionPreview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.NewSubscriptionPreview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.NewSubscriptionPreview.toObject = function(includeInstance, msg) {
  var f, obj = {
priceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
dedicated: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.NewSubscriptionPreview}
 */
proto.billingmanager.NewSubscriptionPreview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.NewSubscriptionPreview;
  return proto.billingmanager.NewSubscriptionPreview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.NewSubscriptionPreview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.NewSubscriptionPreview}
 */
proto.billingmanager.NewSubscriptionPreview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDedicated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.NewSubscriptionPreview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.NewSubscriptionPreview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.NewSubscriptionPreview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.NewSubscriptionPreview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDedicated();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string price_id = 1;
 * @return {string}
 */
proto.billingmanager.NewSubscriptionPreview.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.NewSubscriptionPreview} returns this
 */
proto.billingmanager.NewSubscriptionPreview.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 quantity = 2;
 * @return {number}
 */
proto.billingmanager.NewSubscriptionPreview.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.NewSubscriptionPreview} returns this
 */
proto.billingmanager.NewSubscriptionPreview.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool dedicated = 3;
 * @return {boolean}
 */
proto.billingmanager.NewSubscriptionPreview.prototype.getDedicated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.NewSubscriptionPreview} returns this
 */
proto.billingmanager.NewSubscriptionPreview.prototype.setDedicated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.PreviewCheckoutReply.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.PreviewCheckoutReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.PreviewCheckoutReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewCheckoutReply.toObject = function(includeInstance, msg) {
  var f, obj = {
dueNow: jspb.Message.getFieldWithDefault(msg, 1, 0),
subtotal: jspb.Message.getFieldWithDefault(msg, 2, 0),
discount: jspb.Message.getFieldWithDefault(msg, 3, 0),
appliedBalance: jspb.Message.getFieldWithDefault(msg, 4, 0),
startingBalance: jspb.Message.getFieldWithDefault(msg, 5, 0),
currency: jspb.Message.getFieldWithDefault(msg, 6, ""),
linesList: jspb.Message.toObjectList(msg.getLinesList(),
    proto.billingmanager.PreviewLine.toObject, includeInstance),
nextInvoiceAmount: jspb.Message.getFieldWithDefault(msg, 8, 0),
nextInvoiceDate: (f = msg.getNextInvoiceDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
cancelOfferApplied: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
cancelOfferPercentBps: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.PreviewCheckoutReply}
 */
proto.billingmanager.PreviewCheckoutReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.PreviewCheckoutReply;
  return proto.billingmanager.PreviewCheckoutReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.PreviewCheckoutReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.PreviewCheckoutReply}
 */
proto.billingmanager.PreviewCheckoutReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueNow(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubtotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAppliedBalance(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartingBalance(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 7:
      var value = new proto.billingmanager.PreviewLine;
      reader.readMessage(value,proto.billingmanager.PreviewLine.deserializeBinaryFromReader);
      msg.addLines(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNextInvoiceAmount(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextInvoiceDate(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCancelOfferApplied(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCancelOfferPercentBps(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.PreviewCheckoutReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.PreviewCheckoutReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewCheckoutReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDueNow();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSubtotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getAppliedBalance();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getStartingBalance();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLinesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.billingmanager.PreviewLine.serializeBinaryToWriter
    );
  }
  f = message.getNextInvoiceAmount();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getNextInvoiceDate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCancelOfferApplied();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getCancelOfferPercentBps();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
};


/**
 * optional int64 due_now = 1;
 * @return {number}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getDueNow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.setDueNow = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 subtotal = 2;
 * @return {number}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getSubtotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.setSubtotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 discount = 3;
 * @return {number}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 applied_balance = 4;
 * @return {number}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getAppliedBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.setAppliedBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 starting_balance = 5;
 * @return {number}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getStartingBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.setStartingBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string currency = 6;
 * @return {string}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated PreviewLine lines = 7;
 * @return {!Array<!proto.billingmanager.PreviewLine>}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getLinesList = function() {
  return /** @type{!Array<!proto.billingmanager.PreviewLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.PreviewLine, 7));
};


/**
 * @param {!Array<!proto.billingmanager.PreviewLine>} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
*/
proto.billingmanager.PreviewCheckoutReply.prototype.setLinesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.billingmanager.PreviewLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.PreviewLine}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.addLines = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.billingmanager.PreviewLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.clearLinesList = function() {
  return this.setLinesList([]);
};


/**
 * optional int64 next_invoice_amount = 8;
 * @return {number}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getNextInvoiceAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.setNextInvoiceAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp next_invoice_date = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getNextInvoiceDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
*/
proto.billingmanager.PreviewCheckoutReply.prototype.setNextInvoiceDate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.clearNextInvoiceDate = function() {
  return this.setNextInvoiceDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.hasNextInvoiceDate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool cancel_offer_applied = 10;
 * @return {boolean}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getCancelOfferApplied = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.setCancelOfferApplied = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional uint32 cancel_offer_percent_bps = 11;
 * @return {number}
 */
proto.billingmanager.PreviewCheckoutReply.prototype.getCancelOfferPercentBps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewCheckoutReply} returns this
 */
proto.billingmanager.PreviewCheckoutReply.prototype.setCancelOfferPercentBps = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.PreviewLine.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.PreviewLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.PreviewLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewLine.toObject = function(includeInstance, msg) {
  var f, obj = {
description: jspb.Message.getFieldWithDefault(msg, 1, ""),
amount: jspb.Message.getFieldWithDefault(msg, 2, 0),
quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
proration: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
periodStart: (f = msg.getPeriodStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
periodEnd: (f = msg.getPeriodEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
priceId: jspb.Message.getFieldWithDefault(msg, 7, ""),
source: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.PreviewLine}
 */
proto.billingmanager.PreviewLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.PreviewLine;
  return proto.billingmanager.PreviewLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.PreviewLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.PreviewLine}
 */
proto.billingmanager.PreviewLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProration(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPeriodStart(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPeriodEnd(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.PreviewLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.PreviewLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.PreviewLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getProration();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPeriodStart();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPeriodEnd();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.billingmanager.PreviewLine.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PreviewLine} returns this
 */
proto.billingmanager.PreviewLine.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.billingmanager.PreviewLine.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewLine} returns this
 */
proto.billingmanager.PreviewLine.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 quantity = 3;
 * @return {number}
 */
proto.billingmanager.PreviewLine.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewLine} returns this
 */
proto.billingmanager.PreviewLine.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool proration = 4;
 * @return {boolean}
 */
proto.billingmanager.PreviewLine.prototype.getProration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.PreviewLine} returns this
 */
proto.billingmanager.PreviewLine.prototype.setProration = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp period_start = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.PreviewLine.prototype.getPeriodStart = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.PreviewLine} returns this
*/
proto.billingmanager.PreviewLine.prototype.setPeriodStart = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.PreviewLine} returns this
 */
proto.billingmanager.PreviewLine.prototype.clearPeriodStart = function() {
  return this.setPeriodStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.PreviewLine.prototype.hasPeriodStart = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp period_end = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.PreviewLine.prototype.getPeriodEnd = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.PreviewLine} returns this
*/
proto.billingmanager.PreviewLine.prototype.setPeriodEnd = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.PreviewLine} returns this
 */
proto.billingmanager.PreviewLine.prototype.clearPeriodEnd = function() {
  return this.setPeriodEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.PreviewLine.prototype.hasPeriodEnd = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string price_id = 7;
 * @return {string}
 */
proto.billingmanager.PreviewLine.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PreviewLine} returns this
 */
proto.billingmanager.PreviewLine.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string source = 8;
 * @return {string}
 */
proto.billingmanager.PreviewLine.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PreviewLine} returns this
 */
proto.billingmanager.PreviewLine.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetDownloadableInvoiceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetDownloadableInvoiceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetDownloadableInvoiceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetDownloadableInvoiceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
invoiceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetDownloadableInvoiceReq}
 */
proto.billingmanager.GetDownloadableInvoiceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetDownloadableInvoiceReq;
  return proto.billingmanager.GetDownloadableInvoiceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetDownloadableInvoiceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetDownloadableInvoiceReq}
 */
proto.billingmanager.GetDownloadableInvoiceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetDownloadableInvoiceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetDownloadableInvoiceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetDownloadableInvoiceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetDownloadableInvoiceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.GetDownloadableInvoiceReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetDownloadableInvoiceReq} returns this
 */
proto.billingmanager.GetDownloadableInvoiceReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string invoice_id = 2;
 * @return {string}
 */
proto.billingmanager.GetDownloadableInvoiceReq.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetDownloadableInvoiceReq} returns this
 */
proto.billingmanager.GetDownloadableInvoiceReq.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetDownloadableInvoiceReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetDownloadableInvoiceReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetDownloadableInvoiceReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetDownloadableInvoiceReply.toObject = function(includeInstance, msg) {
  var f, obj = {
receiptUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetDownloadableInvoiceReply}
 */
proto.billingmanager.GetDownloadableInvoiceReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetDownloadableInvoiceReply;
  return proto.billingmanager.GetDownloadableInvoiceReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetDownloadableInvoiceReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetDownloadableInvoiceReply}
 */
proto.billingmanager.GetDownloadableInvoiceReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetDownloadableInvoiceReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetDownloadableInvoiceReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetDownloadableInvoiceReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetDownloadableInvoiceReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiptUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string receipt_url = 1;
 * @return {string}
 */
proto.billingmanager.GetDownloadableInvoiceReply.prototype.getReceiptUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetDownloadableInvoiceReply} returns this
 */
proto.billingmanager.GetDownloadableInvoiceReply.prototype.setReceiptUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.BillingOverviewReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.BillingOverviewReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.BillingOverviewReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.BillingOverviewReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.BillingOverviewReq}
 */
proto.billingmanager.BillingOverviewReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.BillingOverviewReq;
  return proto.billingmanager.BillingOverviewReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.BillingOverviewReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.BillingOverviewReq}
 */
proto.billingmanager.BillingOverviewReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.BillingOverviewReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.BillingOverviewReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.BillingOverviewReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.BillingOverviewReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.BillingOverviewReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.BillingOverviewReq} returns this
 */
proto.billingmanager.BillingOverviewReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.BillingOverviewReply.repeatedFields_ = [3,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.BillingOverviewReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.BillingOverviewReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.BillingOverviewReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.BillingOverviewReply.toObject = function(includeInstance, msg) {
  var f, obj = {
activeSubscription: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountLimit: jspb.Message.getFieldWithDefault(msg, 2, 0),
addOnsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
defaultPayment: (f = msg.getDefaultPayment()) && proto.billingmanager.Card.toObject(includeInstance, f),
joinDate: (f = msg.getJoinDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
availableCredit: jspb.Message.getFieldWithDefault(msg, 6, 0),
trialUsedProductIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
stripeAccount: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.BillingOverviewReply}
 */
proto.billingmanager.BillingOverviewReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.BillingOverviewReply;
  return proto.billingmanager.BillingOverviewReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.BillingOverviewReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.BillingOverviewReply}
 */
proto.billingmanager.BillingOverviewReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setActiveSubscription(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddOns(value);
      break;
    case 4:
      var value = new proto.billingmanager.Card;
      reader.readMessage(value,proto.billingmanager.Card.deserializeBinaryFromReader);
      msg.setDefaultPayment(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setJoinDate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvailableCredit(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addTrialUsedProductIds(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStripeAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.BillingOverviewReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.BillingOverviewReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.BillingOverviewReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.BillingOverviewReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActiveSubscription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountLimit();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAddOnsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getDefaultPayment();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.billingmanager.Card.serializeBinaryToWriter
    );
  }
  f = message.getJoinDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAvailableCredit();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTrialUsedProductIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getStripeAccount();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string active_subscription = 1;
 * @return {string}
 */
proto.billingmanager.BillingOverviewReply.prototype.getActiveSubscription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.setActiveSubscription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 account_limit = 2;
 * @return {number}
 */
proto.billingmanager.BillingOverviewReply.prototype.getAccountLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.setAccountLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string add_ons = 3;
 * @return {!Array<string>}
 */
proto.billingmanager.BillingOverviewReply.prototype.getAddOnsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.setAddOnsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.addAddOns = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.clearAddOnsList = function() {
  return this.setAddOnsList([]);
};


/**
 * optional Card default_payment = 4;
 * @return {?proto.billingmanager.Card}
 */
proto.billingmanager.BillingOverviewReply.prototype.getDefaultPayment = function() {
  return /** @type{?proto.billingmanager.Card} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.Card, 4));
};


/**
 * @param {?proto.billingmanager.Card|undefined} value
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
*/
proto.billingmanager.BillingOverviewReply.prototype.setDefaultPayment = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.clearDefaultPayment = function() {
  return this.setDefaultPayment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.BillingOverviewReply.prototype.hasDefaultPayment = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp join_date = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.BillingOverviewReply.prototype.getJoinDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
*/
proto.billingmanager.BillingOverviewReply.prototype.setJoinDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.clearJoinDate = function() {
  return this.setJoinDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.BillingOverviewReply.prototype.hasJoinDate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 available_credit = 6;
 * @return {number}
 */
proto.billingmanager.BillingOverviewReply.prototype.getAvailableCredit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.setAvailableCredit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated string trial_used_product_ids = 7;
 * @return {!Array<string>}
 */
proto.billingmanager.BillingOverviewReply.prototype.getTrialUsedProductIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.setTrialUsedProductIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.addTrialUsedProductIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.clearTrialUsedProductIdsList = function() {
  return this.setTrialUsedProductIdsList([]);
};


/**
 * optional string stripe_account = 8;
 * @return {string}
 */
proto.billingmanager.BillingOverviewReply.prototype.getStripeAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.BillingOverviewReply} returns this
 */
proto.billingmanager.BillingOverviewReply.prototype.setStripeAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelSubscriptionImmediatelyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelSubscriptionImmediatelyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelSubscriptionImmediatelyReq}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelSubscriptionImmediatelyReq;
  return proto.billingmanager.CancelSubscriptionImmediatelyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelSubscriptionImmediatelyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelSubscriptionImmediatelyReq}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelSubscriptionImmediatelyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelSubscriptionImmediatelyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelSubscriptionImmediatelyReq} returns this
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelSubscriptionImmediatelyReq} returns this
 */
proto.billingmanager.CancelSubscriptionImmediatelyReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelSubscriptionImmediatelyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelSubscriptionImmediatelyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionImmediatelyReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelSubscriptionImmediatelyReply}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelSubscriptionImmediatelyReply;
  return proto.billingmanager.CancelSubscriptionImmediatelyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelSubscriptionImmediatelyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelSubscriptionImmediatelyReply}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelSubscriptionImmediatelyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelSubscriptionImmediatelyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelSubscriptionImmediatelyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionImmediatelyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.RenewOverDueSubscriptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.RenewOverDueSubscriptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.RenewOverDueSubscriptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.RenewOverDueSubscriptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
invoiceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
paymentMethodId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.RenewOverDueSubscriptionReq}
 */
proto.billingmanager.RenewOverDueSubscriptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.RenewOverDueSubscriptionReq;
  return proto.billingmanager.RenewOverDueSubscriptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.RenewOverDueSubscriptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.RenewOverDueSubscriptionReq}
 */
proto.billingmanager.RenewOverDueSubscriptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethodId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.RenewOverDueSubscriptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.RenewOverDueSubscriptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.RenewOverDueSubscriptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.RenewOverDueSubscriptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaymentMethodId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.RenewOverDueSubscriptionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.RenewOverDueSubscriptionReq} returns this
 */
proto.billingmanager.RenewOverDueSubscriptionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string invoice_id = 2;
 * @return {string}
 */
proto.billingmanager.RenewOverDueSubscriptionReq.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.RenewOverDueSubscriptionReq} returns this
 */
proto.billingmanager.RenewOverDueSubscriptionReq.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string payment_method_id = 3;
 * @return {string}
 */
proto.billingmanager.RenewOverDueSubscriptionReq.prototype.getPaymentMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.RenewOverDueSubscriptionReq} returns this
 */
proto.billingmanager.RenewOverDueSubscriptionReq.prototype.setPaymentMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.RenewOverDueSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.RenewOverDueSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.RenewOverDueSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.RenewOverDueSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.RenewOverDueSubscriptionReply}
 */
proto.billingmanager.RenewOverDueSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.RenewOverDueSubscriptionReply;
  return proto.billingmanager.RenewOverDueSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.RenewOverDueSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.RenewOverDueSubscriptionReply}
 */
proto.billingmanager.RenewOverDueSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.RenewOverDueSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.RenewOverDueSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.RenewOverDueSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.RenewOverDueSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
};


/**
 * optional PaymentIntent payment_intent = 1;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.RenewOverDueSubscriptionReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 1));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.RenewOverDueSubscriptionReply} returns this
*/
proto.billingmanager.RenewOverDueSubscriptionReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.RenewOverDueSubscriptionReply} returns this
 */
proto.billingmanager.RenewOverDueSubscriptionReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.RenewOverDueSubscriptionReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetOverDueInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetOverDueInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetOverDueInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetOverDueInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetOverDueInfoReq}
 */
proto.billingmanager.GetOverDueInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetOverDueInfoReq;
  return proto.billingmanager.GetOverDueInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetOverDueInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetOverDueInfoReq}
 */
proto.billingmanager.GetOverDueInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetOverDueInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetOverDueInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetOverDueInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetOverDueInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.GetOverDueInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetOverDueInfoReq} returns this
 */
proto.billingmanager.GetOverDueInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.GetOverDueInfoReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetOverDueInfoReq} returns this
 */
proto.billingmanager.GetOverDueInfoReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetOverDueInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetOverDueInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetOverDueInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
amountDue: jspb.Message.getFieldWithDefault(msg, 1, 0),
amountPaid: jspb.Message.getFieldWithDefault(msg, 2, 0),
total: jspb.Message.getFieldWithDefault(msg, 3, 0),
subTotal: jspb.Message.getFieldWithDefault(msg, 4, 0),
currency: jspb.Message.getFieldWithDefault(msg, 5, ""),
discount: jspb.Message.getFieldWithDefault(msg, 6, 0),
appliedBalance: jspb.Message.getFieldWithDefault(msg, 7, 0),
invoiceId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetOverDueInfoReply}
 */
proto.billingmanager.GetOverDueInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetOverDueInfoReply;
  return proto.billingmanager.GetOverDueInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetOverDueInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetOverDueInfoReply}
 */
proto.billingmanager.GetOverDueInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountDue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountPaid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubTotal(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAppliedBalance(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetOverDueInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetOverDueInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetOverDueInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmountDue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAmountPaid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSubTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAppliedBalance();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional int64 amount_due = 1;
 * @return {number}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.getAmountDue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetOverDueInfoReply} returns this
 */
proto.billingmanager.GetOverDueInfoReply.prototype.setAmountDue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 amount_paid = 2;
 * @return {number}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.getAmountPaid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetOverDueInfoReply} returns this
 */
proto.billingmanager.GetOverDueInfoReply.prototype.setAmountPaid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 total = 3;
 * @return {number}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetOverDueInfoReply} returns this
 */
proto.billingmanager.GetOverDueInfoReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 sub_total = 4;
 * @return {number}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.getSubTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetOverDueInfoReply} returns this
 */
proto.billingmanager.GetOverDueInfoReply.prototype.setSubTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string currency = 5;
 * @return {string}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetOverDueInfoReply} returns this
 */
proto.billingmanager.GetOverDueInfoReply.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 discount = 6;
 * @return {number}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetOverDueInfoReply} returns this
 */
proto.billingmanager.GetOverDueInfoReply.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 applied_balance = 7;
 * @return {number}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.getAppliedBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetOverDueInfoReply} returns this
 */
proto.billingmanager.GetOverDueInfoReply.prototype.setAppliedBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string invoice_id = 8;
 * @return {string}
 */
proto.billingmanager.GetOverDueInfoReply.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetOverDueInfoReply} returns this
 */
proto.billingmanager.GetOverDueInfoReply.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminBillingOverviewReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminBillingOverviewReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminBillingOverviewReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminBillingOverviewReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminBillingOverviewReq}
 */
proto.billingmanager.AdminBillingOverviewReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminBillingOverviewReq;
  return proto.billingmanager.AdminBillingOverviewReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminBillingOverviewReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminBillingOverviewReq}
 */
proto.billingmanager.AdminBillingOverviewReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminBillingOverviewReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminBillingOverviewReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminBillingOverviewReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminBillingOverviewReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminBillingOverviewReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminBillingOverviewReq} returns this
 */
proto.billingmanager.AdminBillingOverviewReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminBillingOverviewReply.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminBillingOverviewReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminBillingOverviewReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminBillingOverviewReply.toObject = function(includeInstance, msg) {
  var f, obj = {
activeSubscription: jspb.Message.getFieldWithDefault(msg, 1, ""),
accountLimit: jspb.Message.getFieldWithDefault(msg, 2, 0),
addOnsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
defaultPayment: (f = msg.getDefaultPayment()) && proto.billingmanager.Card.toObject(includeInstance, f),
joinDate: (f = msg.getJoinDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
availableCredit: jspb.Message.getFieldWithDefault(msg, 6, 0),
stripeAccount: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminBillingOverviewReply}
 */
proto.billingmanager.AdminBillingOverviewReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminBillingOverviewReply;
  return proto.billingmanager.AdminBillingOverviewReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminBillingOverviewReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminBillingOverviewReply}
 */
proto.billingmanager.AdminBillingOverviewReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setActiveSubscription(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAccountLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddOns(value);
      break;
    case 4:
      var value = new proto.billingmanager.Card;
      reader.readMessage(value,proto.billingmanager.Card.deserializeBinaryFromReader);
      msg.setDefaultPayment(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setJoinDate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAvailableCredit(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStripeAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminBillingOverviewReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminBillingOverviewReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminBillingOverviewReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActiveSubscription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountLimit();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAddOnsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getDefaultPayment();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.billingmanager.Card.serializeBinaryToWriter
    );
  }
  f = message.getJoinDate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAvailableCredit();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getStripeAccount();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string active_subscription = 1;
 * @return {string}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.getActiveSubscription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.setActiveSubscription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 account_limit = 2;
 * @return {number}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.getAccountLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.setAccountLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string add_ons = 3;
 * @return {!Array<string>}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.getAddOnsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.setAddOnsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.addAddOns = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.clearAddOnsList = function() {
  return this.setAddOnsList([]);
};


/**
 * optional Card default_payment = 4;
 * @return {?proto.billingmanager.Card}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.getDefaultPayment = function() {
  return /** @type{?proto.billingmanager.Card} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.Card, 4));
};


/**
 * @param {?proto.billingmanager.Card|undefined} value
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
*/
proto.billingmanager.AdminBillingOverviewReply.prototype.setDefaultPayment = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.clearDefaultPayment = function() {
  return this.setDefaultPayment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.hasDefaultPayment = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp join_date = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.getJoinDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
*/
proto.billingmanager.AdminBillingOverviewReply.prototype.setJoinDate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.clearJoinDate = function() {
  return this.setJoinDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.hasJoinDate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 available_credit = 6;
 * @return {number}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.getAvailableCredit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.setAvailableCredit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string stripe_account = 7;
 * @return {string}
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.getStripeAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminBillingOverviewReply} returns this
 */
proto.billingmanager.AdminBillingOverviewReply.prototype.setStripeAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListSubscriptionsReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListSubscriptionsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListSubscriptionsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListSubscriptionsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListSubscriptionsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
statusList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListSubscriptionsReq}
 */
proto.billingmanager.AdminListSubscriptionsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListSubscriptionsReq;
  return proto.billingmanager.AdminListSubscriptionsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListSubscriptionsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListSubscriptionsReq}
 */
proto.billingmanager.AdminListSubscriptionsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListSubscriptionsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListSubscriptionsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListSubscriptionsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListSubscriptionsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatusList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminListSubscriptionsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListSubscriptionsReq} returns this
 */
proto.billingmanager.AdminListSubscriptionsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string status = 2;
 * @return {!Array<string>}
 */
proto.billingmanager.AdminListSubscriptionsReq.prototype.getStatusList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.AdminListSubscriptionsReq} returns this
 */
proto.billingmanager.AdminListSubscriptionsReq.prototype.setStatusList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.AdminListSubscriptionsReq} returns this
 */
proto.billingmanager.AdminListSubscriptionsReq.prototype.addStatus = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListSubscriptionsReq} returns this
 */
proto.billingmanager.AdminListSubscriptionsReq.prototype.clearStatusList = function() {
  return this.setStatusList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListSubscriptionsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListSubscriptionsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListSubscriptionsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListSubscriptionsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListSubscriptionsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
subscriptionsList: jspb.Message.toObjectList(msg.getSubscriptionsList(),
    proto.billingmanager.SubscriptionLite.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListSubscriptionsReply}
 */
proto.billingmanager.AdminListSubscriptionsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListSubscriptionsReply;
  return proto.billingmanager.AdminListSubscriptionsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListSubscriptionsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListSubscriptionsReply}
 */
proto.billingmanager.AdminListSubscriptionsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionLite;
      reader.readMessage(value,proto.billingmanager.SubscriptionLite.deserializeBinaryFromReader);
      msg.addSubscriptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListSubscriptionsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListSubscriptionsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListSubscriptionsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListSubscriptionsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.SubscriptionLite.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubscriptionLite subscriptions = 1;
 * @return {!Array<!proto.billingmanager.SubscriptionLite>}
 */
proto.billingmanager.AdminListSubscriptionsReply.prototype.getSubscriptionsList = function() {
  return /** @type{!Array<!proto.billingmanager.SubscriptionLite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.SubscriptionLite, 1));
};


/**
 * @param {!Array<!proto.billingmanager.SubscriptionLite>} value
 * @return {!proto.billingmanager.AdminListSubscriptionsReply} returns this
*/
proto.billingmanager.AdminListSubscriptionsReply.prototype.setSubscriptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.SubscriptionLite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.SubscriptionLite}
 */
proto.billingmanager.AdminListSubscriptionsReply.prototype.addSubscriptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.SubscriptionLite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListSubscriptionsReply} returns this
 */
proto.billingmanager.AdminListSubscriptionsReply.prototype.clearSubscriptionsList = function() {
  return this.setSubscriptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListInvoicesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListInvoicesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListInvoicesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListInvoicesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListInvoicesReq}
 */
proto.billingmanager.AdminListInvoicesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListInvoicesReq;
  return proto.billingmanager.AdminListInvoicesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListInvoicesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListInvoicesReq}
 */
proto.billingmanager.AdminListInvoicesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListInvoicesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListInvoicesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListInvoicesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListInvoicesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminListInvoicesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListInvoicesReq} returns this
 */
proto.billingmanager.AdminListInvoicesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.billingmanager.AdminListInvoicesReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListInvoicesReq} returns this
 */
proto.billingmanager.AdminListInvoicesReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.billingmanager.AdminListInvoicesReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminListInvoicesReq} returns this
 */
proto.billingmanager.AdminListInvoicesReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListInvoicesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListInvoicesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListInvoicesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListInvoicesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListInvoicesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
invoicesList: jspb.Message.toObjectList(msg.getInvoicesList(),
    proto.billingmanager.Invoice.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
total: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListInvoicesReply}
 */
proto.billingmanager.AdminListInvoicesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListInvoicesReply;
  return proto.billingmanager.AdminListInvoicesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListInvoicesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListInvoicesReply}
 */
proto.billingmanager.AdminListInvoicesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.Invoice;
      reader.readMessage(value,proto.billingmanager.Invoice.deserializeBinaryFromReader);
      msg.addInvoices(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListInvoicesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListInvoicesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListInvoicesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListInvoicesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.Invoice.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * repeated Invoice invoices = 1;
 * @return {!Array<!proto.billingmanager.Invoice>}
 */
proto.billingmanager.AdminListInvoicesReply.prototype.getInvoicesList = function() {
  return /** @type{!Array<!proto.billingmanager.Invoice>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.Invoice, 1));
};


/**
 * @param {!Array<!proto.billingmanager.Invoice>} value
 * @return {!proto.billingmanager.AdminListInvoicesReply} returns this
*/
proto.billingmanager.AdminListInvoicesReply.prototype.setInvoicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.Invoice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.Invoice}
 */
proto.billingmanager.AdminListInvoicesReply.prototype.addInvoices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.Invoice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListInvoicesReply} returns this
 */
proto.billingmanager.AdminListInvoicesReply.prototype.clearInvoicesList = function() {
  return this.setInvoicesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.billingmanager.AdminListInvoicesReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListInvoicesReply} returns this
 */
proto.billingmanager.AdminListInvoicesReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.billingmanager.AdminListInvoicesReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminListInvoicesReply} returns this
 */
proto.billingmanager.AdminListInvoicesReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total = 4;
 * @return {number}
 */
proto.billingmanager.AdminListInvoicesReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminListInvoicesReply} returns this
 */
proto.billingmanager.AdminListInvoicesReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetDownloadableInvoiceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetDownloadableInvoiceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
invoiceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetDownloadableInvoiceReq}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetDownloadableInvoiceReq;
  return proto.billingmanager.AdminGetDownloadableInvoiceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetDownloadableInvoiceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetDownloadableInvoiceReq}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetDownloadableInvoiceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetDownloadableInvoiceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetDownloadableInvoiceReq} returns this
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string invoice_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetDownloadableInvoiceReq} returns this
 */
proto.billingmanager.AdminGetDownloadableInvoiceReq.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetDownloadableInvoiceReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetDownloadableInvoiceReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetDownloadableInvoiceReply.toObject = function(includeInstance, msg) {
  var f, obj = {
receiptUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetDownloadableInvoiceReply}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetDownloadableInvoiceReply;
  return proto.billingmanager.AdminGetDownloadableInvoiceReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetDownloadableInvoiceReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetDownloadableInvoiceReply}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetDownloadableInvoiceReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetDownloadableInvoiceReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetDownloadableInvoiceReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiptUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string receipt_url = 1;
 * @return {string}
 */
proto.billingmanager.AdminGetDownloadableInvoiceReply.prototype.getReceiptUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetDownloadableInvoiceReply} returns this
 */
proto.billingmanager.AdminGetDownloadableInvoiceReply.prototype.setReceiptUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListCardsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListCardsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListCardsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCardsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListCardsReq}
 */
proto.billingmanager.AdminListCardsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListCardsReq;
  return proto.billingmanager.AdminListCardsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListCardsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListCardsReq}
 */
proto.billingmanager.AdminListCardsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListCardsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListCardsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListCardsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCardsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminListCardsReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListCardsReq} returns this
 */
proto.billingmanager.AdminListCardsReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListCardsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListCardsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListCardsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListCardsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCardsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
cardsList: jspb.Message.toObjectList(msg.getCardsList(),
    proto.billingmanager.Card.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListCardsReply}
 */
proto.billingmanager.AdminListCardsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListCardsReply;
  return proto.billingmanager.AdminListCardsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListCardsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListCardsReply}
 */
proto.billingmanager.AdminListCardsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.Card;
      reader.readMessage(value,proto.billingmanager.Card.deserializeBinaryFromReader);
      msg.addCards(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListCardsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListCardsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListCardsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCardsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.Card.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Card cards = 1;
 * @return {!Array<!proto.billingmanager.Card>}
 */
proto.billingmanager.AdminListCardsReply.prototype.getCardsList = function() {
  return /** @type{!Array<!proto.billingmanager.Card>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.Card, 1));
};


/**
 * @param {!Array<!proto.billingmanager.Card>} value
 * @return {!proto.billingmanager.AdminListCardsReply} returns this
*/
proto.billingmanager.AdminListCardsReply.prototype.setCardsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.Card=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.Card}
 */
proto.billingmanager.AdminListCardsReply.prototype.addCards = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.Card, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListCardsReply} returns this
 */
proto.billingmanager.AdminListCardsReply.prototype.clearCardsList = function() {
  return this.setCardsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminSetDefaultPaymentMethodReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminSetDefaultPaymentMethodReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
cardId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminSetDefaultPaymentMethodReq}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminSetDefaultPaymentMethodReq;
  return proto.billingmanager.AdminSetDefaultPaymentMethodReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminSetDefaultPaymentMethodReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminSetDefaultPaymentMethodReq}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminSetDefaultPaymentMethodReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminSetDefaultPaymentMethodReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminSetDefaultPaymentMethodReq} returns this
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string card_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.prototype.getCardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminSetDefaultPaymentMethodReq} returns this
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReq.prototype.setCardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminSetDefaultPaymentMethodReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminSetDefaultPaymentMethodReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminSetDefaultPaymentMethodReply}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminSetDefaultPaymentMethodReply;
  return proto.billingmanager.AdminSetDefaultPaymentMethodReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminSetDefaultPaymentMethodReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminSetDefaultPaymentMethodReply}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminSetDefaultPaymentMethodReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminSetDefaultPaymentMethodReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminSetDefaultPaymentMethodReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminDeleteCardReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminDeleteCardReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminDeleteCardReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminDeleteCardReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
cardId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminDeleteCardReq}
 */
proto.billingmanager.AdminDeleteCardReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminDeleteCardReq;
  return proto.billingmanager.AdminDeleteCardReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminDeleteCardReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminDeleteCardReq}
 */
proto.billingmanager.AdminDeleteCardReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminDeleteCardReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminDeleteCardReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminDeleteCardReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminDeleteCardReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminDeleteCardReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminDeleteCardReq} returns this
 */
proto.billingmanager.AdminDeleteCardReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string card_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminDeleteCardReq.prototype.getCardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminDeleteCardReq} returns this
 */
proto.billingmanager.AdminDeleteCardReq.prototype.setCardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminDeleteCardReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminDeleteCardReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminDeleteCardReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminDeleteCardReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminDeleteCardReply}
 */
proto.billingmanager.AdminDeleteCardReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminDeleteCardReply;
  return proto.billingmanager.AdminDeleteCardReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminDeleteCardReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminDeleteCardReply}
 */
proto.billingmanager.AdminDeleteCardReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminDeleteCardReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminDeleteCardReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminDeleteCardReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminDeleteCardReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetUpcomingInvoiceReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetUpcomingInvoiceReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 2, 0),
invoiceType: jspb.Message.getFieldWithDefault(msg, 3, 0),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
priceId: jspb.Message.getFieldWithDefault(msg, 5, ""),
coupon: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReq}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetUpcomingInvoiceReq;
  return proto.billingmanager.AdminGetUpcomingInvoiceReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetUpcomingInvoiceReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReq}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 3:
      var value = /** @type {!proto.billingmanager.UpcomingInvoiceTypeEnum} */ (reader.readEnum());
      msg.setInvoiceType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoupon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetUpcomingInvoiceReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetUpcomingInvoiceReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getInvoiceType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCoupon();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 quantity = 2;
 * @return {number}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional UpcomingInvoiceTypeEnum invoice_type = 3;
 * @return {!proto.billingmanager.UpcomingInvoiceTypeEnum}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.getInvoiceType = function() {
  return /** @type {!proto.billingmanager.UpcomingInvoiceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.billingmanager.UpcomingInvoiceTypeEnum} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.setInvoiceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string subscription_id = 4;
 * @return {string}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string price_id = 5;
 * @return {string}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string coupon = 6;
 * @return {string}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.getCoupon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReq} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReq.prototype.setCoupon = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetUpcomingInvoiceReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetUpcomingInvoiceReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.toObject = function(includeInstance, msg) {
  var f, obj = {
amountDue: jspb.Message.getFieldWithDefault(msg, 1, 0),
amountPaid: jspb.Message.getFieldWithDefault(msg, 2, 0),
total: jspb.Message.getFieldWithDefault(msg, 3, 0),
subTotal: jspb.Message.getFieldWithDefault(msg, 4, 0),
currency: jspb.Message.getFieldWithDefault(msg, 5, ""),
discount: jspb.Message.getFieldWithDefault(msg, 6, 0),
appliedBalance: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReply}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetUpcomingInvoiceReply;
  return proto.billingmanager.AdminGetUpcomingInvoiceReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetUpcomingInvoiceReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReply}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountDue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountPaid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubTotal(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAppliedBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetUpcomingInvoiceReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetUpcomingInvoiceReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmountDue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAmountPaid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSubTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAppliedBalance();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 amount_due = 1;
 * @return {number}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.getAmountDue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.setAmountDue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 amount_paid = 2;
 * @return {number}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.getAmountPaid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.setAmountPaid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 total = 3;
 * @return {number}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 sub_total = 4;
 * @return {number}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.getSubTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.setSubTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string currency = 5;
 * @return {string}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 discount = 6;
 * @return {number}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 applied_balance = 7;
 * @return {number}
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.getAppliedBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetUpcomingInvoiceReply} returns this
 */
proto.billingmanager.AdminGetUpcomingInvoiceReply.prototype.setAppliedBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListPricesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListPricesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListPricesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListPricesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListPricesReq}
 */
proto.billingmanager.AdminListPricesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListPricesReq;
  return proto.billingmanager.AdminListPricesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListPricesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListPricesReq}
 */
proto.billingmanager.AdminListPricesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListPricesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListPricesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListPricesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListPricesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminListPricesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListPricesReq} returns this
 */
proto.billingmanager.AdminListPricesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListPricesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListPricesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListPricesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListPricesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListPricesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
pricesList: jspb.Message.toObjectList(msg.getPricesList(),
    proto.billingmanager.Price.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListPricesReply}
 */
proto.billingmanager.AdminListPricesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListPricesReply;
  return proto.billingmanager.AdminListPricesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListPricesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListPricesReply}
 */
proto.billingmanager.AdminListPricesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.Price;
      reader.readMessage(value,proto.billingmanager.Price.deserializeBinaryFromReader);
      msg.addPrices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListPricesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListPricesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListPricesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListPricesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPricesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.Price.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Price prices = 1;
 * @return {!Array<!proto.billingmanager.Price>}
 */
proto.billingmanager.AdminListPricesReply.prototype.getPricesList = function() {
  return /** @type{!Array<!proto.billingmanager.Price>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.Price, 1));
};


/**
 * @param {!Array<!proto.billingmanager.Price>} value
 * @return {!proto.billingmanager.AdminListPricesReply} returns this
*/
proto.billingmanager.AdminListPricesReply.prototype.setPricesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.Price=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.Price}
 */
proto.billingmanager.AdminListPricesReply.prototype.addPrices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.Price, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListPricesReply} returns this
 */
proto.billingmanager.AdminListPricesReply.prototype.clearPricesList = function() {
  return this.setPricesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminModifySubscriptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminModifySubscriptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminModifySubscriptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 3, 0),
subscriptionItemId: jspb.Message.getFieldWithDefault(msg, 4, ""),
priceId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminModifySubscriptionReq}
 */
proto.billingmanager.AdminModifySubscriptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminModifySubscriptionReq;
  return proto.billingmanager.AdminModifySubscriptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminModifySubscriptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminModifySubscriptionReq}
 */
proto.billingmanager.AdminModifySubscriptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionItemId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminModifySubscriptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminModifySubscriptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminModifySubscriptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSubscriptionItemId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminModifySubscriptionReq} returns this
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminModifySubscriptionReq} returns this
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 quantity = 3;
 * @return {number}
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminModifySubscriptionReq} returns this
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string subscription_item_id = 4;
 * @return {string}
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.getSubscriptionItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminModifySubscriptionReq} returns this
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.setSubscriptionItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string price_id = 5;
 * @return {string}
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminModifySubscriptionReq} returns this
 */
proto.billingmanager.AdminModifySubscriptionReq.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminModifySubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminModifySubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminModifySubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminModifySubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminModifySubscriptionReply}
 */
proto.billingmanager.AdminModifySubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminModifySubscriptionReply;
  return proto.billingmanager.AdminModifySubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminModifySubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminModifySubscriptionReply}
 */
proto.billingmanager.AdminModifySubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminModifySubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminModifySubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminModifySubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminModifySubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
};


/**
 * optional PaymentIntent payment_intent = 1;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.AdminModifySubscriptionReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 1));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.AdminModifySubscriptionReply} returns this
*/
proto.billingmanager.AdminModifySubscriptionReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminModifySubscriptionReply} returns this
 */
proto.billingmanager.AdminModifySubscriptionReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminModifySubscriptionReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminAddSubscriptionItemReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminAddSubscriptionItemReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAddSubscriptionItemReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
priceId: jspb.Message.getFieldWithDefault(msg, 3, ""),
quantity: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReq}
 */
proto.billingmanager.AdminAddSubscriptionItemReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminAddSubscriptionItemReq;
  return proto.billingmanager.AdminAddSubscriptionItemReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminAddSubscriptionItemReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReq}
 */
proto.billingmanager.AdminAddSubscriptionItemReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuantity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminAddSubscriptionItemReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminAddSubscriptionItemReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAddSubscriptionItemReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPriceId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQuantity();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReq} returns this
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReq} returns this
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string price_id = 3;
 * @return {string}
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.getPriceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReq} returns this
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.setPriceId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 quantity = 4;
 * @return {number}
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.getQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReq} returns this
 */
proto.billingmanager.AdminAddSubscriptionItemReq.prototype.setQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminAddSubscriptionItemReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminAddSubscriptionItemReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminAddSubscriptionItemReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAddSubscriptionItemReply.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f),
subscriptionItemId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReply}
 */
proto.billingmanager.AdminAddSubscriptionItemReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminAddSubscriptionItemReply;
  return proto.billingmanager.AdminAddSubscriptionItemReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminAddSubscriptionItemReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReply}
 */
proto.billingmanager.AdminAddSubscriptionItemReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminAddSubscriptionItemReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminAddSubscriptionItemReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminAddSubscriptionItemReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAddSubscriptionItemReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionItemId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional PaymentIntent payment_intent = 1;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.AdminAddSubscriptionItemReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 1));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReply} returns this
*/
proto.billingmanager.AdminAddSubscriptionItemReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReply} returns this
 */
proto.billingmanager.AdminAddSubscriptionItemReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminAddSubscriptionItemReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string subscription_item_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminAddSubscriptionItemReply.prototype.getSubscriptionItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminAddSubscriptionItemReply} returns this
 */
proto.billingmanager.AdminAddSubscriptionItemReply.prototype.setSubscriptionItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminRemoveSubscriptionItemReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminRemoveSubscriptionItemReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
subscriptionItemId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminRemoveSubscriptionItemReq}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminRemoveSubscriptionItemReq;
  return proto.billingmanager.AdminRemoveSubscriptionItemReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminRemoveSubscriptionItemReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminRemoveSubscriptionItemReq}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionItemId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminRemoveSubscriptionItemReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminRemoveSubscriptionItemReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubscriptionItemId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminRemoveSubscriptionItemReq} returns this
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminRemoveSubscriptionItemReq} returns this
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subscription_item_id = 3;
 * @return {string}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.prototype.getSubscriptionItemId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminRemoveSubscriptionItemReq} returns this
 */
proto.billingmanager.AdminRemoveSubscriptionItemReq.prototype.setSubscriptionItemId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminRemoveSubscriptionItemReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminRemoveSubscriptionItemReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminRemoveSubscriptionItemReply}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminRemoveSubscriptionItemReply;
  return proto.billingmanager.AdminRemoveSubscriptionItemReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminRemoveSubscriptionItemReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminRemoveSubscriptionItemReply}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminRemoveSubscriptionItemReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminRemoveSubscriptionItemReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
};


/**
 * optional PaymentIntent payment_intent = 1;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 1));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.AdminRemoveSubscriptionItemReply} returns this
*/
proto.billingmanager.AdminRemoveSubscriptionItemReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminRemoveSubscriptionItemReply} returns this
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminRemoveSubscriptionItemReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminPreviewCheckoutReq.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminPreviewCheckoutReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminPreviewCheckoutReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminPreviewCheckoutReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
updatesList: jspb.Message.toObjectList(msg.getUpdatesList(),
    proto.billingmanager.SubscriptionUpdate.toObject, includeInstance),
newSubsList: jspb.Message.toObjectList(msg.getNewSubsList(),
    proto.billingmanager.NewSubscriptionPreview.toObject, includeInstance),
coupon: jspb.Message.getFieldWithDefault(msg, 4, ""),
useTrial: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminPreviewCheckoutReq}
 */
proto.billingmanager.AdminPreviewCheckoutReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminPreviewCheckoutReq;
  return proto.billingmanager.AdminPreviewCheckoutReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminPreviewCheckoutReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminPreviewCheckoutReq}
 */
proto.billingmanager.AdminPreviewCheckoutReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.billingmanager.SubscriptionUpdate;
      reader.readMessage(value,proto.billingmanager.SubscriptionUpdate.deserializeBinaryFromReader);
      msg.addUpdates(value);
      break;
    case 3:
      var value = new proto.billingmanager.NewSubscriptionPreview;
      reader.readMessage(value,proto.billingmanager.NewSubscriptionPreview.deserializeBinaryFromReader);
      msg.addNewSubs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoupon(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseTrial(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminPreviewCheckoutReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminPreviewCheckoutReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminPreviewCheckoutReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.billingmanager.SubscriptionUpdate.serializeBinaryToWriter
    );
  }
  f = message.getNewSubsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.billingmanager.NewSubscriptionPreview.serializeBinaryToWriter
    );
  }
  f = message.getCoupon();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUseTrial();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminPreviewCheckoutReq} returns this
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SubscriptionUpdate updates = 2;
 * @return {!Array<!proto.billingmanager.SubscriptionUpdate>}
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.getUpdatesList = function() {
  return /** @type{!Array<!proto.billingmanager.SubscriptionUpdate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.SubscriptionUpdate, 2));
};


/**
 * @param {!Array<!proto.billingmanager.SubscriptionUpdate>} value
 * @return {!proto.billingmanager.AdminPreviewCheckoutReq} returns this
*/
proto.billingmanager.AdminPreviewCheckoutReq.prototype.setUpdatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.billingmanager.SubscriptionUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.SubscriptionUpdate}
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.addUpdates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.billingmanager.SubscriptionUpdate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminPreviewCheckoutReq} returns this
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.clearUpdatesList = function() {
  return this.setUpdatesList([]);
};


/**
 * repeated NewSubscriptionPreview new_subs = 3;
 * @return {!Array<!proto.billingmanager.NewSubscriptionPreview>}
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.getNewSubsList = function() {
  return /** @type{!Array<!proto.billingmanager.NewSubscriptionPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.NewSubscriptionPreview, 3));
};


/**
 * @param {!Array<!proto.billingmanager.NewSubscriptionPreview>} value
 * @return {!proto.billingmanager.AdminPreviewCheckoutReq} returns this
*/
proto.billingmanager.AdminPreviewCheckoutReq.prototype.setNewSubsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.billingmanager.NewSubscriptionPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.NewSubscriptionPreview}
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.addNewSubs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.billingmanager.NewSubscriptionPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminPreviewCheckoutReq} returns this
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.clearNewSubsList = function() {
  return this.setNewSubsList([]);
};


/**
 * optional string coupon = 4;
 * @return {string}
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.getCoupon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminPreviewCheckoutReq} returns this
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.setCoupon = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool use_trial = 5;
 * @return {boolean}
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.getUseTrial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.AdminPreviewCheckoutReq} returns this
 */
proto.billingmanager.AdminPreviewCheckoutReq.prototype.setUseTrial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminPreviewCheckoutReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminPreviewCheckoutReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminPreviewCheckoutReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminPreviewCheckoutReply.toObject = function(includeInstance, msg) {
  var f, obj = {
preview: (f = msg.getPreview()) && proto.billingmanager.PreviewCheckoutReply.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminPreviewCheckoutReply}
 */
proto.billingmanager.AdminPreviewCheckoutReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminPreviewCheckoutReply;
  return proto.billingmanager.AdminPreviewCheckoutReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminPreviewCheckoutReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminPreviewCheckoutReply}
 */
proto.billingmanager.AdminPreviewCheckoutReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PreviewCheckoutReply;
      reader.readMessage(value,proto.billingmanager.PreviewCheckoutReply.deserializeBinaryFromReader);
      msg.setPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminPreviewCheckoutReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminPreviewCheckoutReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminPreviewCheckoutReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminPreviewCheckoutReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.PreviewCheckoutReply.serializeBinaryToWriter
    );
  }
};


/**
 * optional PreviewCheckoutReply preview = 1;
 * @return {?proto.billingmanager.PreviewCheckoutReply}
 */
proto.billingmanager.AdminPreviewCheckoutReply.prototype.getPreview = function() {
  return /** @type{?proto.billingmanager.PreviewCheckoutReply} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PreviewCheckoutReply, 1));
};


/**
 * @param {?proto.billingmanager.PreviewCheckoutReply|undefined} value
 * @return {!proto.billingmanager.AdminPreviewCheckoutReply} returns this
*/
proto.billingmanager.AdminPreviewCheckoutReply.prototype.setPreview = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminPreviewCheckoutReply} returns this
 */
proto.billingmanager.AdminPreviewCheckoutReply.prototype.clearPreview = function() {
  return this.setPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminPreviewCheckoutReply.prototype.hasPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminCancelSubscriptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminCancelSubscriptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminCancelSubscriptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCancelSubscriptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminCancelSubscriptionReq}
 */
proto.billingmanager.AdminCancelSubscriptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminCancelSubscriptionReq;
  return proto.billingmanager.AdminCancelSubscriptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminCancelSubscriptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminCancelSubscriptionReq}
 */
proto.billingmanager.AdminCancelSubscriptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminCancelSubscriptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminCancelSubscriptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminCancelSubscriptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCancelSubscriptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminCancelSubscriptionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCancelSubscriptionReq} returns this
 */
proto.billingmanager.AdminCancelSubscriptionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminCancelSubscriptionReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCancelSubscriptionReq} returns this
 */
proto.billingmanager.AdminCancelSubscriptionReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminCancelSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminCancelSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminCancelSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCancelSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminCancelSubscriptionReply}
 */
proto.billingmanager.AdminCancelSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminCancelSubscriptionReply;
  return proto.billingmanager.AdminCancelSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminCancelSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminCancelSubscriptionReply}
 */
proto.billingmanager.AdminCancelSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminCancelSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminCancelSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminCancelSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCancelSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminReactivateSubscriptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminReactivateSubscriptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminReactivateSubscriptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminReactivateSubscriptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminReactivateSubscriptionReq}
 */
proto.billingmanager.AdminReactivateSubscriptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminReactivateSubscriptionReq;
  return proto.billingmanager.AdminReactivateSubscriptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminReactivateSubscriptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminReactivateSubscriptionReq}
 */
proto.billingmanager.AdminReactivateSubscriptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminReactivateSubscriptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminReactivateSubscriptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminReactivateSubscriptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminReactivateSubscriptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminReactivateSubscriptionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminReactivateSubscriptionReq} returns this
 */
proto.billingmanager.AdminReactivateSubscriptionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminReactivateSubscriptionReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminReactivateSubscriptionReq} returns this
 */
proto.billingmanager.AdminReactivateSubscriptionReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminReactivateSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminReactivateSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminReactivateSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminReactivateSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminReactivateSubscriptionReply}
 */
proto.billingmanager.AdminReactivateSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminReactivateSubscriptionReply;
  return proto.billingmanager.AdminReactivateSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminReactivateSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminReactivateSubscriptionReply}
 */
proto.billingmanager.AdminReactivateSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminReactivateSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminReactivateSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminReactivateSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminReactivateSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminRenewOverDueSubscriptionReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminRenewOverDueSubscriptionReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
invoiceId: jspb.Message.getFieldWithDefault(msg, 2, ""),
paymentMethodId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminRenewOverDueSubscriptionReq}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminRenewOverDueSubscriptionReq;
  return proto.billingmanager.AdminRenewOverDueSubscriptionReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminRenewOverDueSubscriptionReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminRenewOverDueSubscriptionReq}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethodId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminRenewOverDueSubscriptionReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminRenewOverDueSubscriptionReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPaymentMethodId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminRenewOverDueSubscriptionReq} returns this
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string invoice_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminRenewOverDueSubscriptionReq} returns this
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string payment_method_id = 3;
 * @return {string}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.prototype.getPaymentMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminRenewOverDueSubscriptionReq} returns this
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReq.prototype.setPaymentMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminRenewOverDueSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminRenewOverDueSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminRenewOverDueSubscriptionReply}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminRenewOverDueSubscriptionReply;
  return proto.billingmanager.AdminRenewOverDueSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminRenewOverDueSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminRenewOverDueSubscriptionReply}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminRenewOverDueSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminRenewOverDueSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
};


/**
 * optional PaymentIntent payment_intent = 1;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 1));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.AdminRenewOverDueSubscriptionReply} returns this
*/
proto.billingmanager.AdminRenewOverDueSubscriptionReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminRenewOverDueSubscriptionReply} returns this
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminRenewOverDueSubscriptionReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetOverDueInfoReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetOverDueInfoReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetOverDueInfoReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetOverDueInfoReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetOverDueInfoReq}
 */
proto.billingmanager.AdminGetOverDueInfoReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetOverDueInfoReq;
  return proto.billingmanager.AdminGetOverDueInfoReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetOverDueInfoReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetOverDueInfoReq}
 */
proto.billingmanager.AdminGetOverDueInfoReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetOverDueInfoReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetOverDueInfoReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetOverDueInfoReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetOverDueInfoReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminGetOverDueInfoReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReq} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminGetOverDueInfoReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReq} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetOverDueInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetOverDueInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetOverDueInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
amountDue: jspb.Message.getFieldWithDefault(msg, 1, 0),
amountPaid: jspb.Message.getFieldWithDefault(msg, 2, 0),
total: jspb.Message.getFieldWithDefault(msg, 3, 0),
subTotal: jspb.Message.getFieldWithDefault(msg, 4, 0),
currency: jspb.Message.getFieldWithDefault(msg, 5, ""),
discount: jspb.Message.getFieldWithDefault(msg, 6, 0),
appliedBalance: jspb.Message.getFieldWithDefault(msg, 7, 0),
invoiceId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply}
 */
proto.billingmanager.AdminGetOverDueInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetOverDueInfoReply;
  return proto.billingmanager.AdminGetOverDueInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetOverDueInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply}
 */
proto.billingmanager.AdminGetOverDueInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountDue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountPaid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubTotal(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDiscount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAppliedBalance(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvoiceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetOverDueInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetOverDueInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetOverDueInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmountDue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getAmountPaid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSubTotal();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getAppliedBalance();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional int64 amount_due = 1;
 * @return {number}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.getAmountDue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.setAmountDue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 amount_paid = 2;
 * @return {number}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.getAmountPaid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.setAmountPaid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 total = 3;
 * @return {number}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 sub_total = 4;
 * @return {number}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.getSubTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.setSubTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string currency = 5;
 * @return {string}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 discount = 6;
 * @return {number}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 applied_balance = 7;
 * @return {number}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.getAppliedBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.setAppliedBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string invoice_id = 8;
 * @return {string}
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetOverDueInfoReply} returns this
 */
proto.billingmanager.AdminGetOverDueInfoReply.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReq}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminCancelSubscriptionImmediatelyReq;
  return proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReq}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReq} returns this
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReq} returns this
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReq.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReply}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminCancelSubscriptionImmediatelyReply;
  return proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReply}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminCancelSubscriptionImmediatelyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCancelSubscriptionImmediatelyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntPauseSubscriptionsManyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntPauseSubscriptionsManyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReq}
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntPauseSubscriptionsManyReq;
  return proto.billingmanager.IntPauseSubscriptionsManyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntPauseSubscriptionsManyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReq}
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntPauseSubscriptionsManyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntPauseSubscriptionsManyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string users = 1;
 * @return {!Array<string>}
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.prototype.getUsersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReq} returns this
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.prototype.setUsersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReq} returns this
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.prototype.addUsers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReq} returns this
 */
proto.billingmanager.IntPauseSubscriptionsManyReq.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntPauseSubscriptionsManyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntPauseSubscriptionsManyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReply}
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntPauseSubscriptionsManyReply;
  return proto.billingmanager.IntPauseSubscriptionsManyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntPauseSubscriptionsManyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReply}
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntPauseSubscriptionsManyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntPauseSubscriptionsManyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string failed = 1;
 * @return {!Array<string>}
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.prototype.getFailedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReply} returns this
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.prototype.setFailedList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReply} returns this
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.prototype.addFailed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.IntPauseSubscriptionsManyReply} returns this
 */
proto.billingmanager.IntPauseSubscriptionsManyReply.prototype.clearFailedList = function() {
  return this.setFailedList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.IntResumeSubscriptionManyReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntResumeSubscriptionManyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntResumeSubscriptionManyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntResumeSubscriptionManyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntResumeSubscriptionManyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReq}
 */
proto.billingmanager.IntResumeSubscriptionManyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntResumeSubscriptionManyReq;
  return proto.billingmanager.IntResumeSubscriptionManyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntResumeSubscriptionManyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReq}
 */
proto.billingmanager.IntResumeSubscriptionManyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntResumeSubscriptionManyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntResumeSubscriptionManyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntResumeSubscriptionManyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntResumeSubscriptionManyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string users = 1;
 * @return {!Array<string>}
 */
proto.billingmanager.IntResumeSubscriptionManyReq.prototype.getUsersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReq} returns this
 */
proto.billingmanager.IntResumeSubscriptionManyReq.prototype.setUsersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReq} returns this
 */
proto.billingmanager.IntResumeSubscriptionManyReq.prototype.addUsers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReq} returns this
 */
proto.billingmanager.IntResumeSubscriptionManyReq.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.IntResumeSubscriptionManyReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntResumeSubscriptionManyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntResumeSubscriptionManyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntResumeSubscriptionManyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntResumeSubscriptionManyReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReply}
 */
proto.billingmanager.IntResumeSubscriptionManyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntResumeSubscriptionManyReply;
  return proto.billingmanager.IntResumeSubscriptionManyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntResumeSubscriptionManyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReply}
 */
proto.billingmanager.IntResumeSubscriptionManyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntResumeSubscriptionManyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntResumeSubscriptionManyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntResumeSubscriptionManyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntResumeSubscriptionManyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string failed = 1;
 * @return {!Array<string>}
 */
proto.billingmanager.IntResumeSubscriptionManyReply.prototype.getFailedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReply} returns this
 */
proto.billingmanager.IntResumeSubscriptionManyReply.prototype.setFailedList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReply} returns this
 */
proto.billingmanager.IntResumeSubscriptionManyReply.prototype.addFailed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.IntResumeSubscriptionManyReply} returns this
 */
proto.billingmanager.IntResumeSubscriptionManyReply.prototype.clearFailedList = function() {
  return this.setFailedList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntApplyCouponToSubsManyReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntApplyCouponToSubsManyReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.toObject = function(includeInstance, msg) {
  var f, obj = {
usersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReq}
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntApplyCouponToSubsManyReq;
  return proto.billingmanager.IntApplyCouponToSubsManyReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntApplyCouponToSubsManyReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReq}
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntApplyCouponToSubsManyReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntApplyCouponToSubsManyReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string users = 1;
 * @return {!Array<string>}
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.prototype.getUsersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReq} returns this
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.prototype.setUsersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReq} returns this
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.prototype.addUsers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReq} returns this
 */
proto.billingmanager.IntApplyCouponToSubsManyReq.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntApplyCouponToSubsManyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntApplyCouponToSubsManyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReply}
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntApplyCouponToSubsManyReply;
  return proto.billingmanager.IntApplyCouponToSubsManyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntApplyCouponToSubsManyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReply}
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntApplyCouponToSubsManyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntApplyCouponToSubsManyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string failed = 1;
 * @return {!Array<string>}
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.prototype.getFailedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReply} returns this
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.prototype.setFailedList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReply} returns this
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.prototype.addFailed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.IntApplyCouponToSubsManyReply} returns this
 */
proto.billingmanager.IntApplyCouponToSubsManyReply.prototype.clearFailedList = function() {
  return this.setFailedList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntUpdateSubscriptionRenewalReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntUpdateSubscriptionRenewalReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.toObject = function(includeInstance, msg) {
  var f, obj = {
subscriptionsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReq}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntUpdateSubscriptionRenewalReq;
  return proto.billingmanager.IntUpdateSubscriptionRenewalReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntUpdateSubscriptionRenewalReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReq}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addSubscriptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntUpdateSubscriptionRenewalReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntUpdateSubscriptionRenewalReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string subscriptions = 1;
 * @return {!Array<string>}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.prototype.getSubscriptionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReq} returns this
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.prototype.setSubscriptionsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReq} returns this
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.prototype.addSubscriptions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReq} returns this
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReq.prototype.clearSubscriptionsList = function() {
  return this.setSubscriptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntUpdateSubscriptionRenewalReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntUpdateSubscriptionRenewalReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.toObject = function(includeInstance, msg) {
  var f, obj = {
failedList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReply}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntUpdateSubscriptionRenewalReply;
  return proto.billingmanager.IntUpdateSubscriptionRenewalReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntUpdateSubscriptionRenewalReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReply}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntUpdateSubscriptionRenewalReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntUpdateSubscriptionRenewalReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailedList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string failed = 1;
 * @return {!Array<string>}
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.prototype.getFailedList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReply} returns this
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.prototype.setFailedList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReply} returns this
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.prototype.addFailed = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.IntUpdateSubscriptionRenewalReply} returns this
 */
proto.billingmanager.IntUpdateSubscriptionRenewalReply.prototype.clearFailedList = function() {
  return this.setFailedList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CreateCryptoPaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CreateCryptoPaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateCryptoPaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
createSubscription: (f = msg.getCreateSubscription()) && proto.billingmanager.CreateSubscriptionReq.toObject(includeInstance, f),
modifySubscription: (f = msg.getModifySubscription()) && proto.billingmanager.ModifySubscriptionReq.toObject(includeInstance, f),
purchaseTotal: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
creditPurchaseTotal: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
payInvoiceId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest}
 */
proto.billingmanager.CreateCryptoPaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CreateCryptoPaymentRequest;
  return proto.billingmanager.CreateCryptoPaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CreateCryptoPaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest}
 */
proto.billingmanager.CreateCryptoPaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.billingmanager.CreateSubscriptionReq;
      reader.readMessage(value,proto.billingmanager.CreateSubscriptionReq.deserializeBinaryFromReader);
      msg.setCreateSubscription(value);
      break;
    case 3:
      var value = new proto.billingmanager.ModifySubscriptionReq;
      reader.readMessage(value,proto.billingmanager.ModifySubscriptionReq.deserializeBinaryFromReader);
      msg.setModifySubscription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPurchaseTotal(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCreditPurchaseTotal(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPayInvoiceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CreateCryptoPaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CreateCryptoPaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateCryptoPaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreateSubscription();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.billingmanager.CreateSubscriptionReq.serializeBinaryToWriter
    );
  }
  f = message.getModifySubscription();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.billingmanager.ModifySubscriptionReq.serializeBinaryToWriter
    );
  }
  f = message.getPurchaseTotal();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getCreditPurchaseTotal();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getPayInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest} returns this
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CreateSubscriptionReq create_subscription = 2;
 * @return {?proto.billingmanager.CreateSubscriptionReq}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.getCreateSubscription = function() {
  return /** @type{?proto.billingmanager.CreateSubscriptionReq} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.CreateSubscriptionReq, 2));
};


/**
 * @param {?proto.billingmanager.CreateSubscriptionReq|undefined} value
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest} returns this
*/
proto.billingmanager.CreateCryptoPaymentRequest.prototype.setCreateSubscription = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest} returns this
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.clearCreateSubscription = function() {
  return this.setCreateSubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.hasCreateSubscription = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ModifySubscriptionReq modify_subscription = 3;
 * @return {?proto.billingmanager.ModifySubscriptionReq}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.getModifySubscription = function() {
  return /** @type{?proto.billingmanager.ModifySubscriptionReq} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.ModifySubscriptionReq, 3));
};


/**
 * @param {?proto.billingmanager.ModifySubscriptionReq|undefined} value
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest} returns this
*/
proto.billingmanager.CreateCryptoPaymentRequest.prototype.setModifySubscription = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest} returns this
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.clearModifySubscription = function() {
  return this.setModifySubscription(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.hasModifySubscription = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional double purchase_total = 4;
 * @return {number}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.getPurchaseTotal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest} returns this
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.setPurchaseTotal = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double credit_purchase_total = 5;
 * @return {number}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.getCreditPurchaseTotal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest} returns this
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.setCreditPurchaseTotal = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string pay_invoice_id = 6;
 * @return {string}
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.getPayInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateCryptoPaymentRequest} returns this
 */
proto.billingmanager.CreateCryptoPaymentRequest.prototype.setPayInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CreateCryptoPaymentReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CreateCryptoPaymentReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CreateCryptoPaymentReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateCryptoPaymentReply.toObject = function(includeInstance, msg) {
  var f, obj = {
purchaseUrl: jspb.Message.getFieldWithDefault(msg, 1, ""),
order: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CreateCryptoPaymentReply}
 */
proto.billingmanager.CreateCryptoPaymentReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CreateCryptoPaymentReply;
  return proto.billingmanager.CreateCryptoPaymentReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CreateCryptoPaymentReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CreateCryptoPaymentReply}
 */
proto.billingmanager.CreateCryptoPaymentReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchaseUrl(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CreateCryptoPaymentReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CreateCryptoPaymentReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CreateCryptoPaymentReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateCryptoPaymentReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPurchaseUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrder();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional string purchase_url = 1;
 * @return {string}
 */
proto.billingmanager.CreateCryptoPaymentReply.prototype.getPurchaseUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateCryptoPaymentReply} returns this
 */
proto.billingmanager.CreateCryptoPaymentReply.prototype.setPurchaseUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double order = 2;
 * @return {number}
 */
proto.billingmanager.CreateCryptoPaymentReply.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.CreateCryptoPaymentReply} returns this
 */
proto.billingmanager.CreateCryptoPaymentReply.prototype.setOrder = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.HasPendingCryptoPaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.HasPendingCryptoPaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.HasPendingCryptoPaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.HasPendingCryptoPaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.HasPendingCryptoPaymentRequest}
 */
proto.billingmanager.HasPendingCryptoPaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.HasPendingCryptoPaymentRequest;
  return proto.billingmanager.HasPendingCryptoPaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.HasPendingCryptoPaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.HasPendingCryptoPaymentRequest}
 */
proto.billingmanager.HasPendingCryptoPaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.HasPendingCryptoPaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.HasPendingCryptoPaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.HasPendingCryptoPaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.HasPendingCryptoPaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.HasPendingCryptoPaymentRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.HasPendingCryptoPaymentRequest} returns this
 */
proto.billingmanager.HasPendingCryptoPaymentRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.HasPendingCryptoPaymentReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.HasPendingCryptoPaymentReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.HasPendingCryptoPaymentReply.toObject = function(includeInstance, msg) {
  var f, obj = {
hasPendingCryptoPayment: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
status: jspb.Message.getFieldWithDefault(msg, 2, ""),
purchaseUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
paymentId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.HasPendingCryptoPaymentReply}
 */
proto.billingmanager.HasPendingCryptoPaymentReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.HasPendingCryptoPaymentReply;
  return proto.billingmanager.HasPendingCryptoPaymentReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.HasPendingCryptoPaymentReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.HasPendingCryptoPaymentReply}
 */
proto.billingmanager.HasPendingCryptoPaymentReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasPendingCryptoPayment(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurchaseUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.HasPendingCryptoPaymentReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.HasPendingCryptoPaymentReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.HasPendingCryptoPaymentReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasPendingCryptoPayment();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPurchaseUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaymentId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional bool has_pending_crypto_payment = 1;
 * @return {boolean}
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.getHasPendingCryptoPayment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.HasPendingCryptoPaymentReply} returns this
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.setHasPendingCryptoPayment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.HasPendingCryptoPaymentReply} returns this
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string purchase_url = 3;
 * @return {string}
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.getPurchaseUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.HasPendingCryptoPaymentReply} returns this
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.setPurchaseUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string payment_id = 4;
 * @return {string}
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.getPaymentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.HasPendingCryptoPaymentReply} returns this
 */
proto.billingmanager.HasPendingCryptoPaymentReply.prototype.setPaymentId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelCryptoPaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelCryptoPaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelCryptoPaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelCryptoPaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
paymentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelCryptoPaymentRequest}
 */
proto.billingmanager.CancelCryptoPaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelCryptoPaymentRequest;
  return proto.billingmanager.CancelCryptoPaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelCryptoPaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelCryptoPaymentRequest}
 */
proto.billingmanager.CancelCryptoPaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelCryptoPaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelCryptoPaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelCryptoPaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelCryptoPaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPaymentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.CancelCryptoPaymentRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelCryptoPaymentRequest} returns this
 */
proto.billingmanager.CancelCryptoPaymentRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string payment_id = 2;
 * @return {string}
 */
proto.billingmanager.CancelCryptoPaymentRequest.prototype.getPaymentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelCryptoPaymentRequest} returns this
 */
proto.billingmanager.CancelCryptoPaymentRequest.prototype.setPaymentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelCryptoPaymentReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelCryptoPaymentReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelCryptoPaymentReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelCryptoPaymentReply.toObject = function(includeInstance, msg) {
  var f, obj = {
canceled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelCryptoPaymentReply}
 */
proto.billingmanager.CancelCryptoPaymentReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelCryptoPaymentReply;
  return proto.billingmanager.CancelCryptoPaymentReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelCryptoPaymentReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelCryptoPaymentReply}
 */
proto.billingmanager.CancelCryptoPaymentReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanceled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelCryptoPaymentReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelCryptoPaymentReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelCryptoPaymentReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelCryptoPaymentReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCanceled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool canceled = 1;
 * @return {boolean}
 */
proto.billingmanager.CancelCryptoPaymentReply.prototype.getCanceled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.CancelCryptoPaymentReply} returns this
 */
proto.billingmanager.CancelCryptoPaymentReply.prototype.setCanceled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.Purchase.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.Purchase.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.Purchase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.Purchase.toObject = function(includeInstance, msg) {
  var f, obj = {
orderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.Purchase}
 */
proto.billingmanager.Purchase.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.Purchase;
  return proto.billingmanager.Purchase.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.Purchase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.Purchase}
 */
proto.billingmanager.Purchase.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.Purchase.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.Purchase.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.Purchase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.Purchase.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string order_id = 1;
 * @return {string}
 */
proto.billingmanager.Purchase.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.Purchase} returns this
 */
proto.billingmanager.Purchase.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminCampaign.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminCampaign.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminCampaign} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCampaign.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
type: jspb.Message.getFieldWithDefault(msg, 3, ""),
creditCents: jspb.Message.getFieldWithDefault(msg, 4, 0),
partnerName: jspb.Message.getFieldWithDefault(msg, 5, ""),
partnerLogoUrl: jspb.Message.getFieldWithDefault(msg, 6, ""),
toltReferral: jspb.Message.getFieldWithDefault(msg, 7, ""),
itemsJson: jspb.Message.getFieldWithDefault(msg, 8, ""),
trialDays: jspb.Message.getFieldWithDefault(msg, 9, 0),
active: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
startsAt: (f = msg.getStartsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endsAt: (f = msg.getEndsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
allowlistTotal: jspb.Message.getFieldWithDefault(msg, 15, 0),
allowlistClaimed: jspb.Message.getFieldWithDefault(msg, 16, 0),
headline: jspb.Message.getFieldWithDefault(msg, 17, ""),
headlineAccent: jspb.Message.getFieldWithDefault(msg, 18, ""),
subtitle: jspb.Message.getFieldWithDefault(msg, 19, ""),
open: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
claimsTotal: jspb.Message.getFieldWithDefault(msg, 21, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminCampaign}
 */
proto.billingmanager.AdminCampaign.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminCampaign;
  return proto.billingmanager.AdminCampaign.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminCampaign} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminCampaign}
 */
proto.billingmanager.AdminCampaign.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreditCents(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerLogoUrl(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setToltReferral(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemsJson(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrialDays(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartsAt(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndsAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAllowlistTotal(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAllowlistClaimed(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeadline(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeadlineAccent(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitle(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOpen(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setClaimsTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminCampaign.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminCampaign.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminCampaign} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCampaign.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreditCents();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPartnerName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPartnerLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getToltReferral();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getItemsJson();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getTrialDays();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getStartsAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndsAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAllowlistTotal();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getAllowlistClaimed();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getHeadline();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getHeadlineAccent();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getSubtitle();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getOpen();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getClaimsTotal();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
};


/**
 * optional string campaign_key = 1;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getCampaignKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setCampaignKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 credit_cents = 4;
 * @return {number}
 */
proto.billingmanager.AdminCampaign.prototype.getCreditCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setCreditCents = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string partner_name = 5;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getPartnerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setPartnerName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string partner_logo_url = 6;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getPartnerLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setPartnerLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string tolt_referral = 7;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getToltReferral = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setToltReferral = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string items_json = 8;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getItemsJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setItemsJson = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 trial_days = 9;
 * @return {number}
 */
proto.billingmanager.AdminCampaign.prototype.getTrialDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setTrialDays = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool active = 10;
 * @return {boolean}
 */
proto.billingmanager.AdminCampaign.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional google.protobuf.Timestamp starts_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.AdminCampaign.prototype.getStartsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
*/
proto.billingmanager.AdminCampaign.prototype.setStartsAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.clearStartsAt = function() {
  return this.setStartsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminCampaign.prototype.hasStartsAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.Timestamp ends_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.AdminCampaign.prototype.getEndsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
*/
proto.billingmanager.AdminCampaign.prototype.setEndsAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.clearEndsAt = function() {
  return this.setEndsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminCampaign.prototype.hasEndsAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.AdminCampaign.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
*/
proto.billingmanager.AdminCampaign.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminCampaign.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.AdminCampaign.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
*/
proto.billingmanager.AdminCampaign.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminCampaign.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional int64 allowlist_total = 15;
 * @return {number}
 */
proto.billingmanager.AdminCampaign.prototype.getAllowlistTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setAllowlistTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 allowlist_claimed = 16;
 * @return {number}
 */
proto.billingmanager.AdminCampaign.prototype.getAllowlistClaimed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setAllowlistClaimed = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional string headline = 17;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getHeadline = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setHeadline = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string headline_accent = 18;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getHeadlineAccent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setHeadlineAccent = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string subtitle = 19;
 * @return {string}
 */
proto.billingmanager.AdminCampaign.prototype.getSubtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setSubtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional bool open = 20;
 * @return {boolean}
 */
proto.billingmanager.AdminCampaign.prototype.getOpen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setOpen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional int64 claims_total = 21;
 * @return {number}
 */
proto.billingmanager.AdminCampaign.prototype.getClaimsTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminCampaign} returns this
 */
proto.billingmanager.AdminCampaign.prototype.setClaimsTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListCampaignsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListCampaignsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListCampaignsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCampaignsReq.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListCampaignsReq}
 */
proto.billingmanager.AdminListCampaignsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListCampaignsReq;
  return proto.billingmanager.AdminListCampaignsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListCampaignsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListCampaignsReq}
 */
proto.billingmanager.AdminListCampaignsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListCampaignsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListCampaignsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListCampaignsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCampaignsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListCampaignsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListCampaignsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListCampaignsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListCampaignsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCampaignsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignsList: jspb.Message.toObjectList(msg.getCampaignsList(),
    proto.billingmanager.AdminCampaign.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListCampaignsReply}
 */
proto.billingmanager.AdminListCampaignsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListCampaignsReply;
  return proto.billingmanager.AdminListCampaignsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListCampaignsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListCampaignsReply}
 */
proto.billingmanager.AdminListCampaignsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.AdminCampaign;
      reader.readMessage(value,proto.billingmanager.AdminCampaign.deserializeBinaryFromReader);
      msg.addCampaigns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListCampaignsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListCampaignsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListCampaignsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCampaignsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.AdminCampaign.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AdminCampaign campaigns = 1;
 * @return {!Array<!proto.billingmanager.AdminCampaign>}
 */
proto.billingmanager.AdminListCampaignsReply.prototype.getCampaignsList = function() {
  return /** @type{!Array<!proto.billingmanager.AdminCampaign>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.AdminCampaign, 1));
};


/**
 * @param {!Array<!proto.billingmanager.AdminCampaign>} value
 * @return {!proto.billingmanager.AdminListCampaignsReply} returns this
*/
proto.billingmanager.AdminListCampaignsReply.prototype.setCampaignsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.AdminCampaign=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.AdminCampaign}
 */
proto.billingmanager.AdminListCampaignsReply.prototype.addCampaigns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.AdminCampaign, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListCampaignsReply} returns this
 */
proto.billingmanager.AdminListCampaignsReply.prototype.clearCampaignsList = function() {
  return this.setCampaignsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminCreateCampaignReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminCreateCampaignReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCreateCampaignReq.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, ""),
creditCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
partnerName: jspb.Message.getFieldWithDefault(msg, 4, ""),
partnerLogoUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
toltReferral: jspb.Message.getFieldWithDefault(msg, 6, ""),
itemsJson: jspb.Message.getFieldWithDefault(msg, 7, ""),
trialDays: jspb.Message.getFieldWithDefault(msg, 8, 0),
active: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
startsAt: (f = msg.getStartsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endsAt: (f = msg.getEndsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
headline: jspb.Message.getFieldWithDefault(msg, 12, ""),
headlineAccent: jspb.Message.getFieldWithDefault(msg, 13, ""),
subtitle: jspb.Message.getFieldWithDefault(msg, 14, ""),
open: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminCreateCampaignReq}
 */
proto.billingmanager.AdminCreateCampaignReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminCreateCampaignReq;
  return proto.billingmanager.AdminCreateCampaignReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminCreateCampaignReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminCreateCampaignReq}
 */
proto.billingmanager.AdminCreateCampaignReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreditCents(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerLogoUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setToltReferral(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemsJson(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrialDays(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartsAt(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndsAt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeadline(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeadlineAccent(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitle(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOpen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminCreateCampaignReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminCreateCampaignReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCreateCampaignReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreditCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPartnerName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPartnerLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getToltReferral();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getItemsJson();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTrialDays();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getStartsAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndsAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getHeadline();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getHeadlineAccent();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSubtitle();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getOpen();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string type = 2;
 * @return {string}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 credit_cents = 3;
 * @return {number}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getCreditCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setCreditCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string partner_name = 4;
 * @return {string}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getPartnerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setPartnerName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string partner_logo_url = 5;
 * @return {string}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getPartnerLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setPartnerLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string tolt_referral = 6;
 * @return {string}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getToltReferral = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setToltReferral = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string items_json = 7;
 * @return {string}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getItemsJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setItemsJson = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 trial_days = 8;
 * @return {number}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getTrialDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setTrialDays = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool active = 9;
 * @return {boolean}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp starts_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getStartsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
*/
proto.billingmanager.AdminCreateCampaignReq.prototype.setStartsAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.clearStartsAt = function() {
  return this.setStartsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.hasStartsAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp ends_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getEndsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
*/
proto.billingmanager.AdminCreateCampaignReq.prototype.setEndsAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.clearEndsAt = function() {
  return this.setEndsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.hasEndsAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string headline = 12;
 * @return {string}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getHeadline = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setHeadline = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string headline_accent = 13;
 * @return {string}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getHeadlineAccent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setHeadlineAccent = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string subtitle = 14;
 * @return {string}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getSubtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setSubtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool open = 15;
 * @return {boolean}
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.getOpen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.AdminCreateCampaignReq} returns this
 */
proto.billingmanager.AdminCreateCampaignReq.prototype.setOpen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminCreateCampaignReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminCreateCampaignReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminCreateCampaignReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCreateCampaignReply.toObject = function(includeInstance, msg) {
  var f, obj = {
campaign: (f = msg.getCampaign()) && proto.billingmanager.AdminCampaign.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminCreateCampaignReply}
 */
proto.billingmanager.AdminCreateCampaignReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminCreateCampaignReply;
  return proto.billingmanager.AdminCreateCampaignReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminCreateCampaignReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminCreateCampaignReply}
 */
proto.billingmanager.AdminCreateCampaignReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.AdminCampaign;
      reader.readMessage(value,proto.billingmanager.AdminCampaign.deserializeBinaryFromReader);
      msg.setCampaign(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminCreateCampaignReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminCreateCampaignReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminCreateCampaignReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminCreateCampaignReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaign();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.AdminCampaign.serializeBinaryToWriter
    );
  }
};


/**
 * optional AdminCampaign campaign = 1;
 * @return {?proto.billingmanager.AdminCampaign}
 */
proto.billingmanager.AdminCreateCampaignReply.prototype.getCampaign = function() {
  return /** @type{?proto.billingmanager.AdminCampaign} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.AdminCampaign, 1));
};


/**
 * @param {?proto.billingmanager.AdminCampaign|undefined} value
 * @return {!proto.billingmanager.AdminCreateCampaignReply} returns this
*/
proto.billingmanager.AdminCreateCampaignReply.prototype.setCampaign = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminCreateCampaignReply} returns this
 */
proto.billingmanager.AdminCreateCampaignReply.prototype.clearCampaign = function() {
  return this.setCampaign(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminCreateCampaignReply.prototype.hasCampaign = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminUpdateCampaignReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminUpdateCampaignReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminUpdateCampaignReq.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
creditCents: jspb.Message.getFieldWithDefault(msg, 3, 0),
partnerName: jspb.Message.getFieldWithDefault(msg, 4, ""),
partnerLogoUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
toltReferral: jspb.Message.getFieldWithDefault(msg, 6, ""),
itemsJson: jspb.Message.getFieldWithDefault(msg, 7, ""),
trialDays: jspb.Message.getFieldWithDefault(msg, 8, 0),
active: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
startsAt: (f = msg.getStartsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endsAt: (f = msg.getEndsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
headline: jspb.Message.getFieldWithDefault(msg, 12, ""),
headlineAccent: jspb.Message.getFieldWithDefault(msg, 13, ""),
subtitle: jspb.Message.getFieldWithDefault(msg, 14, ""),
open: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminUpdateCampaignReq}
 */
proto.billingmanager.AdminUpdateCampaignReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminUpdateCampaignReq;
  return proto.billingmanager.AdminUpdateCampaignReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminUpdateCampaignReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminUpdateCampaignReq}
 */
proto.billingmanager.AdminUpdateCampaignReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreditCents(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartnerLogoUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setToltReferral(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setItemsJson(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrialDays(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartsAt(value);
      break;
    case 11:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndsAt(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeadline(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeadlineAccent(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitle(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOpen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminUpdateCampaignReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminUpdateCampaignReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminUpdateCampaignReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreditCents();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPartnerName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPartnerLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getToltReferral();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getItemsJson();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTrialDays();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getStartsAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndsAt();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getHeadline();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getHeadlineAccent();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSubtitle();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getOpen();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional string campaign_key = 1;
 * @return {string}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getCampaignKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setCampaignKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 credit_cents = 3;
 * @return {number}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getCreditCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setCreditCents = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string partner_name = 4;
 * @return {string}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getPartnerName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setPartnerName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string partner_logo_url = 5;
 * @return {string}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getPartnerLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setPartnerLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string tolt_referral = 6;
 * @return {string}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getToltReferral = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setToltReferral = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string items_json = 7;
 * @return {string}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getItemsJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setItemsJson = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 trial_days = 8;
 * @return {number}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getTrialDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setTrialDays = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool active = 9;
 * @return {boolean}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional google.protobuf.Timestamp starts_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getStartsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
*/
proto.billingmanager.AdminUpdateCampaignReq.prototype.setStartsAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.clearStartsAt = function() {
  return this.setStartsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.hasStartsAt = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional google.protobuf.Timestamp ends_at = 11;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getEndsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 11));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
*/
proto.billingmanager.AdminUpdateCampaignReq.prototype.setEndsAt = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.clearEndsAt = function() {
  return this.setEndsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.hasEndsAt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string headline = 12;
 * @return {string}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getHeadline = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setHeadline = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string headline_accent = 13;
 * @return {string}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getHeadlineAccent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setHeadlineAccent = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string subtitle = 14;
 * @return {string}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getSubtitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setSubtitle = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool open = 15;
 * @return {boolean}
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.getOpen = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReq} returns this
 */
proto.billingmanager.AdminUpdateCampaignReq.prototype.setOpen = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminUpdateCampaignReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminUpdateCampaignReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminUpdateCampaignReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminUpdateCampaignReply.toObject = function(includeInstance, msg) {
  var f, obj = {
campaign: (f = msg.getCampaign()) && proto.billingmanager.AdminCampaign.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminUpdateCampaignReply}
 */
proto.billingmanager.AdminUpdateCampaignReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminUpdateCampaignReply;
  return proto.billingmanager.AdminUpdateCampaignReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminUpdateCampaignReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminUpdateCampaignReply}
 */
proto.billingmanager.AdminUpdateCampaignReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.AdminCampaign;
      reader.readMessage(value,proto.billingmanager.AdminCampaign.deserializeBinaryFromReader);
      msg.setCampaign(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminUpdateCampaignReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminUpdateCampaignReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminUpdateCampaignReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminUpdateCampaignReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaign();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.AdminCampaign.serializeBinaryToWriter
    );
  }
};


/**
 * optional AdminCampaign campaign = 1;
 * @return {?proto.billingmanager.AdminCampaign}
 */
proto.billingmanager.AdminUpdateCampaignReply.prototype.getCampaign = function() {
  return /** @type{?proto.billingmanager.AdminCampaign} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.AdminCampaign, 1));
};


/**
 * @param {?proto.billingmanager.AdminCampaign|undefined} value
 * @return {!proto.billingmanager.AdminUpdateCampaignReply} returns this
*/
proto.billingmanager.AdminUpdateCampaignReply.prototype.setCampaign = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminUpdateCampaignReply} returns this
 */
proto.billingmanager.AdminUpdateCampaignReply.prototype.clearCampaign = function() {
  return this.setCampaign(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminUpdateCampaignReply.prototype.hasCampaign = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListCampaignAllowlistReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListCampaignAllowlistReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCampaignAllowlistReq.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
search: jspb.Message.getFieldWithDefault(msg, 2, ""),
claimedFilter: jspb.Message.getFieldWithDefault(msg, 3, ""),
page: jspb.Message.getFieldWithDefault(msg, 4, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReq}
 */
proto.billingmanager.AdminListCampaignAllowlistReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListCampaignAllowlistReq;
  return proto.billingmanager.AdminListCampaignAllowlistReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListCampaignAllowlistReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReq}
 */
proto.billingmanager.AdminListCampaignAllowlistReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearch(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClaimedFilter(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListCampaignAllowlistReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListCampaignAllowlistReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCampaignAllowlistReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClaimedFilter();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * optional string campaign_key = 1;
 * @return {string}
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.getCampaignKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReq} returns this
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.setCampaignKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string search = 2;
 * @return {string}
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReq} returns this
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string claimed_filter = 3;
 * @return {string}
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.getClaimedFilter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReq} returns this
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.setClaimedFilter = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 page = 4;
 * @return {number}
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReq} returns this
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional uint32 page_size = 5;
 * @return {number}
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReq} returns this
 */
proto.billingmanager.AdminListCampaignAllowlistReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CampaignAllowlistEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CampaignAllowlistEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CampaignAllowlistEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
email: jspb.Message.getFieldWithDefault(msg, 1, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
claimedAt: (f = msg.getClaimedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
claimedUserId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CampaignAllowlistEntry}
 */
proto.billingmanager.CampaignAllowlistEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CampaignAllowlistEntry;
  return proto.billingmanager.CampaignAllowlistEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CampaignAllowlistEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CampaignAllowlistEntry}
 */
proto.billingmanager.CampaignAllowlistEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setClaimedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClaimedUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CampaignAllowlistEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CampaignAllowlistEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CampaignAllowlistEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getClaimedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getClaimedUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CampaignAllowlistEntry} returns this
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.CampaignAllowlistEntry} returns this
*/
proto.billingmanager.CampaignAllowlistEntry.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CampaignAllowlistEntry} returns this
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp claimed_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.getClaimedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.CampaignAllowlistEntry} returns this
*/
proto.billingmanager.CampaignAllowlistEntry.prototype.setClaimedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CampaignAllowlistEntry} returns this
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.clearClaimedAt = function() {
  return this.setClaimedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.hasClaimedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string claimed_user_id = 4;
 * @return {string}
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.getClaimedUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CampaignAllowlistEntry} returns this
 */
proto.billingmanager.CampaignAllowlistEntry.prototype.setClaimedUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListCampaignAllowlistReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListCampaignAllowlistReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListCampaignAllowlistReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListCampaignAllowlistReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCampaignAllowlistReply.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.billingmanager.CampaignAllowlistEntry.toObject, includeInstance),
total: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReply}
 */
proto.billingmanager.AdminListCampaignAllowlistReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListCampaignAllowlistReply;
  return proto.billingmanager.AdminListCampaignAllowlistReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListCampaignAllowlistReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReply}
 */
proto.billingmanager.AdminListCampaignAllowlistReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.CampaignAllowlistEntry;
      reader.readMessage(value,proto.billingmanager.CampaignAllowlistEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListCampaignAllowlistReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListCampaignAllowlistReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListCampaignAllowlistReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCampaignAllowlistReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.CampaignAllowlistEntry.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * repeated CampaignAllowlistEntry entries = 1;
 * @return {!Array<!proto.billingmanager.CampaignAllowlistEntry>}
 */
proto.billingmanager.AdminListCampaignAllowlistReply.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.billingmanager.CampaignAllowlistEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.CampaignAllowlistEntry, 1));
};


/**
 * @param {!Array<!proto.billingmanager.CampaignAllowlistEntry>} value
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReply} returns this
*/
proto.billingmanager.AdminListCampaignAllowlistReply.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.CampaignAllowlistEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.CampaignAllowlistEntry}
 */
proto.billingmanager.AdminListCampaignAllowlistReply.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.CampaignAllowlistEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReply} returns this
 */
proto.billingmanager.AdminListCampaignAllowlistReply.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.billingmanager.AdminListCampaignAllowlistReply.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminListCampaignAllowlistReply} returns this
 */
proto.billingmanager.AdminListCampaignAllowlistReply.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
emailsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReq}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminAddCampaignAllowlistEmailsReq;
  return proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReq}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addEmails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string campaign_key = 1;
 * @return {string}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.prototype.getCampaignKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReq} returns this
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.prototype.setCampaignKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string emails = 2;
 * @return {!Array<string>}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.prototype.getEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReq} returns this
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.prototype.setEmailsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReq} returns this
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.prototype.addEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReq} returns this
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReq.prototype.clearEmailsList = function() {
  return this.setEmailsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
added: jspb.Message.getFieldWithDefault(msg, 1, 0),
duplicates: jspb.Message.getFieldWithDefault(msg, 2, 0),
invalidList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminAddCampaignAllowlistEmailsReply;
  return proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAdded(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuplicates(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addInvalid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAdded();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDuplicates();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getInvalidList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional int64 added = 1;
 * @return {number}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.getAdded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply} returns this
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.setAdded = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 duplicates = 2;
 * @return {number}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.getDuplicates = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply} returns this
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.setDuplicates = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated string invalid = 3;
 * @return {!Array<string>}
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.getInvalidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply} returns this
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.setInvalidList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply} returns this
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.addInvalid = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminAddCampaignAllowlistEmailsReply} returns this
 */
proto.billingmanager.AdminAddCampaignAllowlistEmailsReply.prototype.clearInvalidList = function() {
  return this.setInvalidList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.toObject = function(includeInstance, msg) {
  var f, obj = {
campaignKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
email: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq;
  return proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCampaignKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string campaign_key = 1;
 * @return {string}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.prototype.getCampaignKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq} returns this
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.prototype.setCampaignKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq} returns this
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReq.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.toObject = function(includeInstance, msg) {
  var f, obj = {
removed: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
claimed: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply;
  return proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRemoved(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClaimed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRemoved();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getClaimed();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool removed = 1;
 * @return {boolean}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.prototype.getRemoved = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply} returns this
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.prototype.setRemoved = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool claimed = 2;
 * @return {boolean}
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.prototype.getClaimed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply} returns this
 */
proto.billingmanager.AdminRemoveCampaignAllowlistEmailReply.prototype.setClaimed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.SubscriptionFreezeState.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.SubscriptionFreezeState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.SubscriptionFreezeState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionFreezeState.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, 0),
durationDays: jspb.Message.getFieldWithDefault(msg, 3, 0),
plannedResumeAt: (f = msg.getPlannedResumeAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
requestedAt: (f = msg.getRequestedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
effectiveAt: (f = msg.getEffectiveAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
resumedAt: (f = msg.getResumedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
currentStep: jspb.Message.getFieldWithDefault(msg, 9, ""),
errorCode: jspb.Message.getFieldWithDefault(msg, 12, ""),
version: jspb.Message.getFieldWithDefault(msg, 13, 0),
allowedActionsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.SubscriptionFreezeState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.SubscriptionFreezeState;
  return proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.SubscriptionFreezeState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.billingmanager.SubscriptionFreezeStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDurationDays(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPlannedResumeAt(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRequestedAt(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveAt(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setResumedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentStep(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorCode(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setVersion(value);
      break;
    case 14:
      var values = /** @type {!Array<!proto.billingmanager.SubscriptionFreezeAllowedAction>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAllowedActions(values[i]);
      }
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.SubscriptionFreezeState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDurationDays();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getPlannedResumeAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getRequestedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getResumedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCurrentStep();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getErrorCode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = message.getAllowedActionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      14,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SubscriptionFreezeStatus status = 2;
 * @return {!proto.billingmanager.SubscriptionFreezeStatus}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getStatus = function() {
  return /** @type {!proto.billingmanager.SubscriptionFreezeStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.billingmanager.SubscriptionFreezeStatus} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint32 duration_days = 3;
 * @return {number}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getDurationDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.setDurationDays = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp planned_resume_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getPlannedResumeAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
*/
proto.billingmanager.SubscriptionFreezeState.prototype.setPlannedResumeAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.clearPlannedResumeAt = function() {
  return this.setPlannedResumeAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.hasPlannedResumeAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp requested_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getRequestedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
*/
proto.billingmanager.SubscriptionFreezeState.prototype.setRequestedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.clearRequestedAt = function() {
  return this.setRequestedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.hasRequestedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp effective_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getEffectiveAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
*/
proto.billingmanager.SubscriptionFreezeState.prototype.setEffectiveAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.clearEffectiveAt = function() {
  return this.setEffectiveAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.hasEffectiveAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.Timestamp resumed_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getResumedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
*/
proto.billingmanager.SubscriptionFreezeState.prototype.setResumedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.clearResumedAt = function() {
  return this.setResumedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.hasResumedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string current_step = 9;
 * @return {string}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getCurrentStep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.setCurrentStep = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string error_code = 12;
 * @return {string}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getErrorCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.setErrorCode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional uint64 version = 13;
 * @return {number}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * repeated SubscriptionFreezeAllowedAction allowed_actions = 14;
 * @return {!Array<!proto.billingmanager.SubscriptionFreezeAllowedAction>}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getAllowedActionsList = function() {
  return /** @type {!Array<!proto.billingmanager.SubscriptionFreezeAllowedAction>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<!proto.billingmanager.SubscriptionFreezeAllowedAction>} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.setAllowedActionsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {!proto.billingmanager.SubscriptionFreezeAllowedAction} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.addAllowedActions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.clearAllowedActionsList = function() {
  return this.setAllowedActionsList([]);
};


/**
 * optional google.protobuf.Timestamp updated_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
*/
proto.billingmanager.SubscriptionFreezeState.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.SubscriptionFreezeState} returns this
 */
proto.billingmanager.SubscriptionFreezeState.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.SubscriptionFreezeState.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.PreviewSubscriptionFreezeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.PreviewSubscriptionFreezeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.PreviewSubscriptionFreezeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewSubscriptionFreezeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReq}
 */
proto.billingmanager.PreviewSubscriptionFreezeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.PreviewSubscriptionFreezeReq;
  return proto.billingmanager.PreviewSubscriptionFreezeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.PreviewSubscriptionFreezeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReq}
 */
proto.billingmanager.PreviewSubscriptionFreezeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.PreviewSubscriptionFreezeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.PreviewSubscriptionFreezeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.PreviewSubscriptionFreezeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewSubscriptionFreezeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.PreviewSubscriptionFreezeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReq} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.SubscriptionFreezeEligibility.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.SubscriptionFreezeEligibility.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.SubscriptionFreezeEligibility} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionFreezeEligibility.toObject = function(includeInstance, msg) {
  var f, obj = {
eligible: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
reasonCodesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
freezeCyclesUsed: jspb.Message.getFieldWithDefault(msg, 3, 0),
freezeCyclesLimit: jspb.Message.getFieldWithDefault(msg, 4, 0),
nextEligibleAt: (f = msg.getNextEligibleAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
cooldownEndsAt: (f = msg.getCooldownEndsAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility}
 */
proto.billingmanager.SubscriptionFreezeEligibility.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.SubscriptionFreezeEligibility;
  return proto.billingmanager.SubscriptionFreezeEligibility.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.SubscriptionFreezeEligibility} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility}
 */
proto.billingmanager.SubscriptionFreezeEligibility.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEligible(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addReasonCodes(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFreezeCyclesUsed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFreezeCyclesLimit(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextEligibleAt(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCooldownEndsAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.SubscriptionFreezeEligibility.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.SubscriptionFreezeEligibility} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.SubscriptionFreezeEligibility.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEligible();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getReasonCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getFreezeCyclesUsed();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getFreezeCyclesLimit();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getNextEligibleAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCooldownEndsAt();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool eligible = 1;
 * @return {boolean}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.getEligible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.setEligible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated string reason_codes = 2;
 * @return {!Array<string>}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.getReasonCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.setReasonCodesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.addReasonCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.clearReasonCodesList = function() {
  return this.setReasonCodesList([]);
};


/**
 * optional uint32 freeze_cycles_used = 3;
 * @return {number}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.getFreezeCyclesUsed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.setFreezeCyclesUsed = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 freeze_cycles_limit = 4;
 * @return {number}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.getFreezeCyclesLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.setFreezeCyclesLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp next_eligible_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.getNextEligibleAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
*/
proto.billingmanager.SubscriptionFreezeEligibility.prototype.setNextEligibleAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.clearNextEligibleAt = function() {
  return this.setNextEligibleAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.hasNextEligibleAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp cooldown_ends_at = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.getCooldownEndsAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
*/
proto.billingmanager.SubscriptionFreezeEligibility.prototype.setCooldownEndsAt = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.SubscriptionFreezeEligibility} returns this
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.clearCooldownEndsAt = function() {
  return this.setCooldownEndsAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.SubscriptionFreezeEligibility.prototype.hasCooldownEndsAt = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetSubscriptionFreezeEligibilityReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetSubscriptionFreezeEligibilityReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetSubscriptionFreezeEligibilityReq}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetSubscriptionFreezeEligibilityReq;
  return proto.billingmanager.GetSubscriptionFreezeEligibilityReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetSubscriptionFreezeEligibilityReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetSubscriptionFreezeEligibilityReq}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetSubscriptionFreezeEligibilityReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetSubscriptionFreezeEligibilityReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeEligibilityReq} returns this
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetSubscriptionFreezeEligibilityReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetSubscriptionFreezeEligibilityReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.toObject = function(includeInstance, msg) {
  var f, obj = {
eligibility: (f = msg.getEligibility()) && proto.billingmanager.SubscriptionFreezeEligibility.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetSubscriptionFreezeEligibilityReply}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetSubscriptionFreezeEligibilityReply;
  return proto.billingmanager.GetSubscriptionFreezeEligibilityReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetSubscriptionFreezeEligibilityReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetSubscriptionFreezeEligibilityReply}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeEligibility;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeEligibility.deserializeBinaryFromReader);
      msg.setEligibility(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetSubscriptionFreezeEligibilityReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetSubscriptionFreezeEligibilityReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEligibility();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeEligibility.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionFreezeEligibility eligibility = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeEligibility}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.prototype.getEligibility = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeEligibility} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeEligibility, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeEligibility|undefined} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeEligibilityReply} returns this
*/
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.prototype.setEligibility = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.GetSubscriptionFreezeEligibilityReply} returns this
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.prototype.clearEligibility = function() {
  return this.setEligibility(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.GetSubscriptionFreezeEligibilityReply.prototype.hasEligibility = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.PreviewSubscriptionFreezeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.PreviewSubscriptionFreezeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
eligible: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
ineligibleReasonCodesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
snapshotHash: jspb.Message.getFieldWithDefault(msg, 3, ""),
activeSubscriptions: jspb.Message.getFieldWithDefault(msg, 6, 0),
plannedResumeAt: (f = msg.getPlannedResumeAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
eligibility: (f = msg.getEligibility()) && proto.billingmanager.SubscriptionFreezeEligibility.toObject(includeInstance, f),
durationDays: jspb.Message.getFieldWithDefault(msg, 12, 0),
restartAmount: jspb.Message.getFieldWithDefault(msg, 13, 0),
restartCurrency: jspb.Message.getFieldWithDefault(msg, 14, ""),
cancelOfferWaiting: jspb.Message.getBooleanFieldWithDefault(msg, 16, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.PreviewSubscriptionFreezeReply;
  return proto.billingmanager.PreviewSubscriptionFreezeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.PreviewSubscriptionFreezeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEligible(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addIneligibleReasonCodes(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotHash(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setActiveSubscriptions(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPlannedResumeAt(value);
      break;
    case 8:
      var value = new proto.billingmanager.SubscriptionFreezeEligibility;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeEligibility.deserializeBinaryFromReader);
      msg.setEligibility(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDurationDays(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRestartAmount(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setRestartCurrency(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCancelOfferWaiting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.PreviewSubscriptionFreezeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.PreviewSubscriptionFreezeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEligible();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIneligibleReasonCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getSnapshotHash();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActiveSubscriptions();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getPlannedResumeAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEligibility();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.billingmanager.SubscriptionFreezeEligibility.serializeBinaryToWriter
    );
  }
  f = message.getDurationDays();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getRestartAmount();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getRestartCurrency();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getCancelOfferWaiting();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
};


/**
 * optional bool eligible = 1;
 * @return {boolean}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getEligible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setEligible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated string ineligible_reason_codes = 2;
 * @return {!Array<string>}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getIneligibleReasonCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setIneligibleReasonCodesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.addIneligibleReasonCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.clearIneligibleReasonCodesList = function() {
  return this.setIneligibleReasonCodesList([]);
};


/**
 * optional string snapshot_hash = 3;
 * @return {string}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getSnapshotHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setSnapshotHash = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 active_subscriptions = 6;
 * @return {number}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getActiveSubscriptions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setActiveSubscriptions = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp planned_resume_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getPlannedResumeAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
*/
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setPlannedResumeAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.clearPlannedResumeAt = function() {
  return this.setPlannedResumeAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.hasPlannedResumeAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SubscriptionFreezeEligibility eligibility = 8;
 * @return {?proto.billingmanager.SubscriptionFreezeEligibility}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getEligibility = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeEligibility} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeEligibility, 8));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeEligibility|undefined} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
*/
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setEligibility = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.clearEligibility = function() {
  return this.setEligibility(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.hasEligibility = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint32 duration_days = 12;
 * @return {number}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getDurationDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setDurationDays = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 restart_amount = 13;
 * @return {number}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getRestartAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setRestartAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string restart_currency = 14;
 * @return {string}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getRestartCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setRestartCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool cancel_offer_waiting = 16;
 * @return {boolean}
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.getCancelOfferWaiting = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.PreviewSubscriptionFreezeReply} returns this
 */
proto.billingmanager.PreviewSubscriptionFreezeReply.prototype.setCancelOfferWaiting = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CreateSubscriptionFreezeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CreateSubscriptionFreezeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CreateSubscriptionFreezeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateSubscriptionFreezeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
snapshotHash: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CreateSubscriptionFreezeReq}
 */
proto.billingmanager.CreateSubscriptionFreezeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CreateSubscriptionFreezeReq;
  return proto.billingmanager.CreateSubscriptionFreezeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CreateSubscriptionFreezeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CreateSubscriptionFreezeReq}
 */
proto.billingmanager.CreateSubscriptionFreezeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapshotHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CreateSubscriptionFreezeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CreateSubscriptionFreezeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CreateSubscriptionFreezeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateSubscriptionFreezeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSnapshotHash();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionFreezeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionFreezeReq} returns this
 */
proto.billingmanager.CreateSubscriptionFreezeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string idempotency_key = 3;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionFreezeReq.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionFreezeReq} returns this
 */
proto.billingmanager.CreateSubscriptionFreezeReq.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string snapshot_hash = 4;
 * @return {string}
 */
proto.billingmanager.CreateSubscriptionFreezeReq.prototype.getSnapshotHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CreateSubscriptionFreezeReq} returns this
 */
proto.billingmanager.CreateSubscriptionFreezeReq.prototype.setSnapshotHash = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CreateSubscriptionFreezeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CreateSubscriptionFreezeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CreateSubscriptionFreezeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateSubscriptionFreezeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CreateSubscriptionFreezeReply}
 */
proto.billingmanager.CreateSubscriptionFreezeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CreateSubscriptionFreezeReply;
  return proto.billingmanager.CreateSubscriptionFreezeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CreateSubscriptionFreezeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CreateSubscriptionFreezeReply}
 */
proto.billingmanager.CreateSubscriptionFreezeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CreateSubscriptionFreezeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CreateSubscriptionFreezeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CreateSubscriptionFreezeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CreateSubscriptionFreezeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionFreezeState freeze = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.CreateSubscriptionFreezeReply.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.CreateSubscriptionFreezeReply} returns this
*/
proto.billingmanager.CreateSubscriptionFreezeReply.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CreateSubscriptionFreezeReply} returns this
 */
proto.billingmanager.CreateSubscriptionFreezeReply.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CreateSubscriptionFreezeReply.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetSubscriptionFreezeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetSubscriptionFreezeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetSubscriptionFreezeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetSubscriptionFreezeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetSubscriptionFreezeReq}
 */
proto.billingmanager.GetSubscriptionFreezeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetSubscriptionFreezeReq;
  return proto.billingmanager.GetSubscriptionFreezeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetSubscriptionFreezeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetSubscriptionFreezeReq}
 */
proto.billingmanager.GetSubscriptionFreezeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetSubscriptionFreezeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetSubscriptionFreezeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetSubscriptionFreezeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetSubscriptionFreezeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.GetSubscriptionFreezeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeReq} returns this
 */
proto.billingmanager.GetSubscriptionFreezeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetSubscriptionFreezeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetSubscriptionFreezeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetSubscriptionFreezeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f),
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f),
creditAmount: jspb.Message.getFieldWithDefault(msg, 3, 0),
creditCurrency: jspb.Message.getFieldWithDefault(msg, 4, ""),
failedFreeze: (f = msg.getFailedFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f),
restartAmount: jspb.Message.getFieldWithDefault(msg, 6, 0),
restartCurrency: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply}
 */
proto.billingmanager.GetSubscriptionFreezeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetSubscriptionFreezeReply;
  return proto.billingmanager.GetSubscriptionFreezeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetSubscriptionFreezeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply}
 */
proto.billingmanager.GetSubscriptionFreezeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    case 2:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreditAmount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreditCurrency(value);
      break;
    case 5:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFailedFreeze(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRestartAmount(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRestartCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetSubscriptionFreezeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetSubscriptionFreezeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetSubscriptionFreezeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
  f = message.getCreditAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreditCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getFailedFreeze();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
  f = message.getRestartAmount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getRestartCurrency();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional SubscriptionFreezeState freeze = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
*/
proto.billingmanager.GetSubscriptionFreezeReply.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PaymentIntent payment_intent = 2;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 2));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
*/
proto.billingmanager.GetSubscriptionFreezeReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 credit_amount = 3;
 * @return {number}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.getCreditAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.setCreditAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string credit_currency = 4;
 * @return {string}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.getCreditCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.setCreditCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional SubscriptionFreezeState failed_freeze = 5;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.getFailedFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 5));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
*/
proto.billingmanager.GetSubscriptionFreezeReply.prototype.setFailedFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.clearFailedFreeze = function() {
  return this.setFailedFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.hasFailedFreeze = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 restart_amount = 6;
 * @return {number}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.getRestartAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.setRestartAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string restart_currency = 7;
 * @return {string}
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.getRestartCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.GetSubscriptionFreezeReply.prototype.setRestartCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ResumeSubscriptionFreezeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ResumeSubscriptionFreezeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
freezeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
paymentMethodId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReq}
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ResumeSubscriptionFreezeReq;
  return proto.billingmanager.ResumeSubscriptionFreezeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ResumeSubscriptionFreezeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReq}
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreezeId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethodId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ResumeSubscriptionFreezeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ResumeSubscriptionFreezeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFreezeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaymentMethodId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReq} returns this
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string freeze_id = 2;
 * @return {string}
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.getFreezeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReq} returns this
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.setFreezeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string idempotency_key = 3;
 * @return {string}
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReq} returns this
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string payment_method_id = 4;
 * @return {string}
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.getPaymentMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReq} returns this
 */
proto.billingmanager.ResumeSubscriptionFreezeReq.prototype.setPaymentMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.ResumeSubscriptionFreezeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.ResumeSubscriptionFreezeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f),
paymentIntent: (f = msg.getPaymentIntent()) && proto.billingmanager.PaymentIntent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReply}
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.ResumeSubscriptionFreezeReply;
  return proto.billingmanager.ResumeSubscriptionFreezeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.ResumeSubscriptionFreezeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReply}
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    case 2:
      var value = new proto.billingmanager.PaymentIntent;
      reader.readMessage(value,proto.billingmanager.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.ResumeSubscriptionFreezeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.ResumeSubscriptionFreezeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.billingmanager.PaymentIntent.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionFreezeState freeze = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReply} returns this
*/
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReply} returns this
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PaymentIntent payment_intent = 2;
 * @return {?proto.billingmanager.PaymentIntent}
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.getPaymentIntent = function() {
  return /** @type{?proto.billingmanager.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.PaymentIntent, 2));
};


/**
 * @param {?proto.billingmanager.PaymentIntent|undefined} value
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReply} returns this
*/
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.ResumeSubscriptionFreezeReply} returns this
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.ResumeSubscriptionFreezeReply.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetSubscriptionFreezeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetSubscriptionFreezeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
freezeId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReq}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetSubscriptionFreezeReq;
  return proto.billingmanager.AdminGetSubscriptionFreezeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetSubscriptionFreezeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReq}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreezeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetSubscriptionFreezeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetSubscriptionFreezeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFreezeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReq} returns this
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string freeze_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.prototype.getFreezeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReq} returns this
 */
proto.billingmanager.AdminGetSubscriptionFreezeReq.prototype.setFreezeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminGetSubscriptionFreezeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminGetSubscriptionFreezeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
eligibility: (f = msg.getEligibility()) && proto.billingmanager.SubscriptionFreezeEligibility.toObject(includeInstance, f),
user: (f = msg.getUser()) && proto.billingmanager.AdminUser.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReply}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminGetSubscriptionFreezeReply;
  return proto.billingmanager.AdminGetSubscriptionFreezeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminGetSubscriptionFreezeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReply}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = new proto.billingmanager.SubscriptionFreezeEligibility;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeEligibility.deserializeBinaryFromReader);
      msg.setEligibility(value);
      break;
    case 4:
      var value = new proto.billingmanager.AdminUser;
      reader.readMessage(value,proto.billingmanager.AdminUser.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminGetSubscriptionFreezeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminGetSubscriptionFreezeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEligibility();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.billingmanager.SubscriptionFreezeEligibility.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.billingmanager.AdminUser.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionFreezeState freeze = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReply} returns this
*/
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SubscriptionFreezeEligibility eligibility = 3;
 * @return {?proto.billingmanager.SubscriptionFreezeEligibility}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.getEligibility = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeEligibility} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeEligibility, 3));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeEligibility|undefined} value
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReply} returns this
*/
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.setEligibility = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.clearEligibility = function() {
  return this.setEligibility(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.hasEligibility = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AdminUser user = 4;
 * @return {?proto.billingmanager.AdminUser}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.getUser = function() {
  return /** @type{?proto.billingmanager.AdminUser} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.AdminUser, 4));
};


/**
 * @param {?proto.billingmanager.AdminUser|undefined} value
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReply} returns this
*/
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminGetSubscriptionFreezeReply} returns this
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminGetSubscriptionFreezeReply.prototype.hasUser = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListSubscriptionFreezesReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListSubscriptionFreezesReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.toObject = function(includeInstance, msg) {
  var f, obj = {
statusesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
paginationCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
userId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReq}
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListSubscriptionFreezesReq;
  return proto.billingmanager.AdminListSubscriptionFreezesReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListSubscriptionFreezesReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReq}
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.billingmanager.SubscriptionFreezeStatus>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStatuses(values[i]);
      }
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaginationCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListSubscriptionFreezesReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListSubscriptionFreezesReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatusesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getPaginationCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated SubscriptionFreezeStatus statuses = 1;
 * @return {!Array<!proto.billingmanager.SubscriptionFreezeStatus>}
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.getStatusesList = function() {
  return /** @type {!Array<!proto.billingmanager.SubscriptionFreezeStatus>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.billingmanager.SubscriptionFreezeStatus>} value
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReq} returns this
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.setStatusesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.billingmanager.SubscriptionFreezeStatus} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReq} returns this
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.addStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReq} returns this
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.clearStatusesList = function() {
  return this.setStatusesList([]);
};


/**
 * optional string pagination_cursor = 2;
 * @return {string}
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.getPaginationCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReq} returns this
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.setPaginationCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReq} returns this
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string user_id = 4;
 * @return {string}
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReq} returns this
 */
proto.billingmanager.AdminListSubscriptionFreezesReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminUser.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminUser.toObject = function(includeInstance, msg) {
  var f, obj = {
firstName: jspb.Message.getFieldWithDefault(msg, 1, ""),
lastName: jspb.Message.getFieldWithDefault(msg, 2, ""),
email: jspb.Message.getFieldWithDefault(msg, 3, ""),
avatar: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminUser}
 */
proto.billingmanager.AdminUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminUser;
  return proto.billingmanager.AdminUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminUser}
 */
proto.billingmanager.AdminUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatar(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAvatar();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string first_name = 1;
 * @return {string}
 */
proto.billingmanager.AdminUser.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUser} returns this
 */
proto.billingmanager.AdminUser.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string last_name = 2;
 * @return {string}
 */
proto.billingmanager.AdminUser.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUser} returns this
 */
proto.billingmanager.AdminUser.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.billingmanager.AdminUser.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUser} returns this
 */
proto.billingmanager.AdminUser.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string avatar = 4;
 * @return {string}
 */
proto.billingmanager.AdminUser.prototype.getAvatar = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminUser} returns this
 */
proto.billingmanager.AdminUser.prototype.setAvatar = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminSubscriptionFreeze.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminSubscriptionFreeze} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminSubscriptionFreeze.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f),
user: (f = msg.getUser()) && proto.billingmanager.AdminUser.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminSubscriptionFreeze}
 */
proto.billingmanager.AdminSubscriptionFreeze.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminSubscriptionFreeze;
  return proto.billingmanager.AdminSubscriptionFreeze.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminSubscriptionFreeze} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminSubscriptionFreeze}
 */
proto.billingmanager.AdminSubscriptionFreeze.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    case 3:
      var value = new proto.billingmanager.AdminUser;
      reader.readMessage(value,proto.billingmanager.AdminUser.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminSubscriptionFreeze.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminSubscriptionFreeze} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminSubscriptionFreeze.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.billingmanager.AdminUser.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminSubscriptionFreeze} returns this
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SubscriptionFreezeState freeze = 2;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 2));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.AdminSubscriptionFreeze} returns this
*/
proto.billingmanager.AdminSubscriptionFreeze.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminSubscriptionFreeze} returns this
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AdminUser user = 3;
 * @return {?proto.billingmanager.AdminUser}
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.getUser = function() {
  return /** @type{?proto.billingmanager.AdminUser} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.AdminUser, 3));
};


/**
 * @param {?proto.billingmanager.AdminUser|undefined} value
 * @return {!proto.billingmanager.AdminSubscriptionFreeze} returns this
*/
proto.billingmanager.AdminSubscriptionFreeze.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminSubscriptionFreeze} returns this
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminSubscriptionFreeze.prototype.hasUser = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListSubscriptionFreezesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListSubscriptionFreezesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freezesList: jspb.Message.toObjectList(msg.getFreezesList(),
    proto.billingmanager.AdminSubscriptionFreeze.toObject, includeInstance),
nextPageCursor: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReply}
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListSubscriptionFreezesReply;
  return proto.billingmanager.AdminListSubscriptionFreezesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListSubscriptionFreezesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReply}
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.AdminSubscriptionFreeze;
      reader.readMessage(value,proto.billingmanager.AdminSubscriptionFreeze.deserializeBinaryFromReader);
      msg.addFreezes(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageCursor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListSubscriptionFreezesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListSubscriptionFreezesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreezesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.AdminSubscriptionFreeze.serializeBinaryToWriter
    );
  }
  f = message.getNextPageCursor();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * repeated AdminSubscriptionFreeze freezes = 1;
 * @return {!Array<!proto.billingmanager.AdminSubscriptionFreeze>}
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.getFreezesList = function() {
  return /** @type{!Array<!proto.billingmanager.AdminSubscriptionFreeze>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.AdminSubscriptionFreeze, 1));
};


/**
 * @param {!Array<!proto.billingmanager.AdminSubscriptionFreeze>} value
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReply} returns this
*/
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.setFreezesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.AdminSubscriptionFreeze=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.AdminSubscriptionFreeze}
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.addFreezes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.AdminSubscriptionFreeze, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReply} returns this
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.clearFreezesList = function() {
  return this.setFreezesList([]);
};


/**
 * optional string next_page_cursor = 2;
 * @return {string}
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.getNextPageCursor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReply} returns this
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.setNextPageCursor = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminListSubscriptionFreezesReply} returns this
 */
proto.billingmanager.AdminListSubscriptionFreezesReply.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelSubscriptionFreezeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelSubscriptionFreezeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelSubscriptionFreezeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionFreezeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
freezeId: jspb.Message.getFieldWithDefault(msg, 2, ""),
expectedVersion: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelSubscriptionFreezeReq}
 */
proto.billingmanager.CancelSubscriptionFreezeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelSubscriptionFreezeReq;
  return proto.billingmanager.CancelSubscriptionFreezeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelSubscriptionFreezeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelSubscriptionFreezeReq}
 */
proto.billingmanager.CancelSubscriptionFreezeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreezeId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExpectedVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelSubscriptionFreezeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelSubscriptionFreezeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelSubscriptionFreezeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionFreezeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFreezeId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getExpectedVersion();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.CancelSubscriptionFreezeReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelSubscriptionFreezeReq} returns this
 */
proto.billingmanager.CancelSubscriptionFreezeReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string freeze_id = 2;
 * @return {string}
 */
proto.billingmanager.CancelSubscriptionFreezeReq.prototype.getFreezeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelSubscriptionFreezeReq} returns this
 */
proto.billingmanager.CancelSubscriptionFreezeReq.prototype.setFreezeId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 expected_version = 3;
 * @return {number}
 */
proto.billingmanager.CancelSubscriptionFreezeReq.prototype.getExpectedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.CancelSubscriptionFreezeReq} returns this
 */
proto.billingmanager.CancelSubscriptionFreezeReq.prototype.setExpectedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelSubscriptionFreezeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelSubscriptionFreezeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelSubscriptionFreezeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionFreezeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelSubscriptionFreezeReply}
 */
proto.billingmanager.CancelSubscriptionFreezeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelSubscriptionFreezeReply;
  return proto.billingmanager.CancelSubscriptionFreezeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelSubscriptionFreezeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelSubscriptionFreezeReply}
 */
proto.billingmanager.CancelSubscriptionFreezeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelSubscriptionFreezeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelSubscriptionFreezeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelSubscriptionFreezeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelSubscriptionFreezeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionFreezeState freeze = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.CancelSubscriptionFreezeReply.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.CancelSubscriptionFreezeReply} returns this
*/
proto.billingmanager.CancelSubscriptionFreezeReply.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CancelSubscriptionFreezeReply} returns this
 */
proto.billingmanager.CancelSubscriptionFreezeReply.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CancelSubscriptionFreezeReply.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelOfferCharge.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelOfferCharge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelOfferCharge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelOfferCharge.toObject = function(includeInstance, msg) {
  var f, obj = {
subscriptionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
interval: jspb.Message.getFieldWithDefault(msg, 2, ""),
intervalCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
chargeAmount: jspb.Message.getFieldWithDefault(msg, 5, 0),
offerAmount: jspb.Message.getFieldWithDefault(msg, 6, 0),
chargeAt: (f = msg.getChargeAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelOfferCharge}
 */
proto.billingmanager.CancelOfferCharge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelOfferCharge;
  return proto.billingmanager.CancelOfferCharge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelOfferCharge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelOfferCharge}
 */
proto.billingmanager.CancelOfferCharge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterval(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIntervalCount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChargeAmount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOfferAmount(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setChargeAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelOfferCharge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelOfferCharge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelOfferCharge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelOfferCharge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterval();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIntervalCount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getChargeAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getOfferAmount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getChargeAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string subscription_id = 1;
 * @return {string}
 */
proto.billingmanager.CancelOfferCharge.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelOfferCharge} returns this
 */
proto.billingmanager.CancelOfferCharge.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string interval = 2;
 * @return {string}
 */
proto.billingmanager.CancelOfferCharge.prototype.getInterval = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelOfferCharge} returns this
 */
proto.billingmanager.CancelOfferCharge.prototype.setInterval = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 interval_count = 3;
 * @return {number}
 */
proto.billingmanager.CancelOfferCharge.prototype.getIntervalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.CancelOfferCharge} returns this
 */
proto.billingmanager.CancelOfferCharge.prototype.setIntervalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.billingmanager.CancelOfferCharge.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelOfferCharge} returns this
 */
proto.billingmanager.CancelOfferCharge.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 charge_amount = 5;
 * @return {number}
 */
proto.billingmanager.CancelOfferCharge.prototype.getChargeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.CancelOfferCharge} returns this
 */
proto.billingmanager.CancelOfferCharge.prototype.setChargeAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 offer_amount = 6;
 * @return {number}
 */
proto.billingmanager.CancelOfferCharge.prototype.getOfferAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.CancelOfferCharge} returns this
 */
proto.billingmanager.CancelOfferCharge.prototype.setOfferAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp charge_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.CancelOfferCharge.prototype.getChargeAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.CancelOfferCharge} returns this
*/
proto.billingmanager.CancelOfferCharge.prototype.setChargeAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CancelOfferCharge} returns this
 */
proto.billingmanager.CancelOfferCharge.prototype.clearChargeAt = function() {
  return this.setChargeAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CancelOfferCharge.prototype.hasChargeAt = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetCancelOfferReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetCancelOfferReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetCancelOfferReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetCancelOfferReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetCancelOfferReq}
 */
proto.billingmanager.GetCancelOfferReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetCancelOfferReq;
  return proto.billingmanager.GetCancelOfferReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetCancelOfferReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetCancelOfferReq}
 */
proto.billingmanager.GetCancelOfferReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetCancelOfferReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetCancelOfferReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetCancelOfferReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetCancelOfferReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.GetCancelOfferReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.GetCancelOfferReq} returns this
 */
proto.billingmanager.GetCancelOfferReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.GetCancelOfferReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.GetCancelOfferReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.GetCancelOfferReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.GetCancelOfferReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetCancelOfferReply.toObject = function(includeInstance, msg) {
  var f, obj = {
eligible: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
reasonCodesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
percentBps: jspb.Message.getFieldWithDefault(msg, 3, 0),
nextCharge: (f = msg.getNextCharge()) && proto.billingmanager.CancelOfferCharge.toObject(includeInstance, f),
waitingOffer: (f = msg.getWaitingOffer()) && proto.billingmanager.CancelOffer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.GetCancelOfferReply}
 */
proto.billingmanager.GetCancelOfferReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.GetCancelOfferReply;
  return proto.billingmanager.GetCancelOfferReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.GetCancelOfferReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.GetCancelOfferReply}
 */
proto.billingmanager.GetCancelOfferReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEligible(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addReasonCodes(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPercentBps(value);
      break;
    case 9:
      var value = new proto.billingmanager.CancelOfferCharge;
      reader.readMessage(value,proto.billingmanager.CancelOfferCharge.deserializeBinaryFromReader);
      msg.setNextCharge(value);
      break;
    case 10:
      var value = new proto.billingmanager.CancelOffer;
      reader.readMessage(value,proto.billingmanager.CancelOffer.deserializeBinaryFromReader);
      msg.setWaitingOffer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.GetCancelOfferReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.GetCancelOfferReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.GetCancelOfferReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.GetCancelOfferReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEligible();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getReasonCodesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getPercentBps();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getNextCharge();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.billingmanager.CancelOfferCharge.serializeBinaryToWriter
    );
  }
  f = message.getWaitingOffer();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.billingmanager.CancelOffer.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool eligible = 1;
 * @return {boolean}
 */
proto.billingmanager.GetCancelOfferReply.prototype.getEligible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.GetCancelOfferReply} returns this
 */
proto.billingmanager.GetCancelOfferReply.prototype.setEligible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated string reason_codes = 2;
 * @return {!Array<string>}
 */
proto.billingmanager.GetCancelOfferReply.prototype.getReasonCodesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.billingmanager.GetCancelOfferReply} returns this
 */
proto.billingmanager.GetCancelOfferReply.prototype.setReasonCodesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.GetCancelOfferReply} returns this
 */
proto.billingmanager.GetCancelOfferReply.prototype.addReasonCodes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.GetCancelOfferReply} returns this
 */
proto.billingmanager.GetCancelOfferReply.prototype.clearReasonCodesList = function() {
  return this.setReasonCodesList([]);
};


/**
 * optional uint32 percent_bps = 3;
 * @return {number}
 */
proto.billingmanager.GetCancelOfferReply.prototype.getPercentBps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.GetCancelOfferReply} returns this
 */
proto.billingmanager.GetCancelOfferReply.prototype.setPercentBps = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional CancelOfferCharge next_charge = 9;
 * @return {?proto.billingmanager.CancelOfferCharge}
 */
proto.billingmanager.GetCancelOfferReply.prototype.getNextCharge = function() {
  return /** @type{?proto.billingmanager.CancelOfferCharge} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.CancelOfferCharge, 9));
};


/**
 * @param {?proto.billingmanager.CancelOfferCharge|undefined} value
 * @return {!proto.billingmanager.GetCancelOfferReply} returns this
*/
proto.billingmanager.GetCancelOfferReply.prototype.setNextCharge = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.GetCancelOfferReply} returns this
 */
proto.billingmanager.GetCancelOfferReply.prototype.clearNextCharge = function() {
  return this.setNextCharge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.GetCancelOfferReply.prototype.hasNextCharge = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional CancelOffer waiting_offer = 10;
 * @return {?proto.billingmanager.CancelOffer}
 */
proto.billingmanager.GetCancelOfferReply.prototype.getWaitingOffer = function() {
  return /** @type{?proto.billingmanager.CancelOffer} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.CancelOffer, 10));
};


/**
 * @param {?proto.billingmanager.CancelOffer|undefined} value
 * @return {!proto.billingmanager.GetCancelOfferReply} returns this
*/
proto.billingmanager.GetCancelOfferReply.prototype.setWaitingOffer = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.GetCancelOfferReply} returns this
 */
proto.billingmanager.GetCancelOfferReply.prototype.clearWaitingOffer = function() {
  return this.setWaitingOffer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.GetCancelOfferReply.prototype.hasWaitingOffer = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AcceptCancelOfferReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AcceptCancelOfferReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AcceptCancelOfferReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AcceptCancelOfferReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
idempotencyKey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AcceptCancelOfferReq}
 */
proto.billingmanager.AcceptCancelOfferReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AcceptCancelOfferReq;
  return proto.billingmanager.AcceptCancelOfferReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AcceptCancelOfferReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AcceptCancelOfferReq}
 */
proto.billingmanager.AcceptCancelOfferReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdempotencyKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AcceptCancelOfferReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AcceptCancelOfferReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AcceptCancelOfferReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AcceptCancelOfferReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIdempotencyKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AcceptCancelOfferReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AcceptCancelOfferReq} returns this
 */
proto.billingmanager.AcceptCancelOfferReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string idempotency_key = 3;
 * @return {string}
 */
proto.billingmanager.AcceptCancelOfferReq.prototype.getIdempotencyKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AcceptCancelOfferReq} returns this
 */
proto.billingmanager.AcceptCancelOfferReq.prototype.setIdempotencyKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.CancelOffer.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.CancelOffer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.CancelOffer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelOffer.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, ""),
acceptedAt: (f = msg.getAcceptedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
percentBps: jspb.Message.getFieldWithDefault(msg, 4, 0),
closedAt: (f = msg.getClosedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
usedFor: jspb.Message.getFieldWithDefault(msg, 8, ""),
usedOn: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.CancelOffer}
 */
proto.billingmanager.CancelOffer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.CancelOffer;
  return proto.billingmanager.CancelOffer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.CancelOffer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.CancelOffer}
 */
proto.billingmanager.CancelOffer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setAcceptedAt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPercentBps(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setClosedAt(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsedFor(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsedOn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.CancelOffer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.CancelOffer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.CancelOffer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.CancelOffer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAcceptedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPercentBps();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getClosedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUsedFor();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUsedOn();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.billingmanager.CancelOffer.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelOffer} returns this
 */
proto.billingmanager.CancelOffer.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.billingmanager.CancelOffer.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelOffer} returns this
 */
proto.billingmanager.CancelOffer.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp accepted_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.CancelOffer.prototype.getAcceptedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.CancelOffer} returns this
*/
proto.billingmanager.CancelOffer.prototype.setAcceptedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CancelOffer} returns this
 */
proto.billingmanager.CancelOffer.prototype.clearAcceptedAt = function() {
  return this.setAcceptedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CancelOffer.prototype.hasAcceptedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint32 percent_bps = 4;
 * @return {number}
 */
proto.billingmanager.CancelOffer.prototype.getPercentBps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.CancelOffer} returns this
 */
proto.billingmanager.CancelOffer.prototype.setPercentBps = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp closed_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.billingmanager.CancelOffer.prototype.getClosedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.billingmanager.CancelOffer} returns this
*/
proto.billingmanager.CancelOffer.prototype.setClosedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.CancelOffer} returns this
 */
proto.billingmanager.CancelOffer.prototype.clearClosedAt = function() {
  return this.setClosedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.CancelOffer.prototype.hasClosedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string used_for = 8;
 * @return {string}
 */
proto.billingmanager.CancelOffer.prototype.getUsedFor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelOffer} returns this
 */
proto.billingmanager.CancelOffer.prototype.setUsedFor = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string used_on = 9;
 * @return {string}
 */
proto.billingmanager.CancelOffer.prototype.getUsedOn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.CancelOffer} returns this
 */
proto.billingmanager.CancelOffer.prototype.setUsedOn = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AcceptCancelOfferReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AcceptCancelOfferReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AcceptCancelOfferReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AcceptCancelOfferReply.toObject = function(includeInstance, msg) {
  var f, obj = {
offer: (f = msg.getOffer()) && proto.billingmanager.CancelOffer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AcceptCancelOfferReply}
 */
proto.billingmanager.AcceptCancelOfferReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AcceptCancelOfferReply;
  return proto.billingmanager.AcceptCancelOfferReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AcceptCancelOfferReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AcceptCancelOfferReply}
 */
proto.billingmanager.AcceptCancelOfferReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.CancelOffer;
      reader.readMessage(value,proto.billingmanager.CancelOffer.deserializeBinaryFromReader);
      msg.setOffer(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AcceptCancelOfferReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AcceptCancelOfferReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AcceptCancelOfferReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AcceptCancelOfferReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.CancelOffer.serializeBinaryToWriter
    );
  }
};


/**
 * optional CancelOffer offer = 1;
 * @return {?proto.billingmanager.CancelOffer}
 */
proto.billingmanager.AcceptCancelOfferReply.prototype.getOffer = function() {
  return /** @type{?proto.billingmanager.CancelOffer} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.CancelOffer, 1));
};


/**
 * @param {?proto.billingmanager.CancelOffer|undefined} value
 * @return {!proto.billingmanager.AcceptCancelOfferReply} returns this
*/
proto.billingmanager.AcceptCancelOfferReply.prototype.setOffer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AcceptCancelOfferReply} returns this
 */
proto.billingmanager.AcceptCancelOfferReply.prototype.clearOffer = function() {
  return this.setOffer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AcceptCancelOfferReply.prototype.hasOffer = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListCancelOffersReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListCancelOffersReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListCancelOffersReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCancelOffersReq.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListCancelOffersReq}
 */
proto.billingmanager.AdminListCancelOffersReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListCancelOffersReq;
  return proto.billingmanager.AdminListCancelOffersReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListCancelOffersReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListCancelOffersReq}
 */
proto.billingmanager.AdminListCancelOffersReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListCancelOffersReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListCancelOffersReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListCancelOffersReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCancelOffersReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminListCancelOffersReq.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminListCancelOffersReq} returns this
 */
proto.billingmanager.AdminListCancelOffersReq.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.billingmanager.AdminListCancelOffersReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminListCancelOffersReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminListCancelOffersReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminListCancelOffersReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCancelOffersReply.toObject = function(includeInstance, msg) {
  var f, obj = {
offersList: jspb.Message.toObjectList(msg.getOffersList(),
    proto.billingmanager.CancelOffer.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminListCancelOffersReply}
 */
proto.billingmanager.AdminListCancelOffersReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminListCancelOffersReply;
  return proto.billingmanager.AdminListCancelOffersReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminListCancelOffersReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminListCancelOffersReply}
 */
proto.billingmanager.AdminListCancelOffersReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.CancelOffer;
      reader.readMessage(value,proto.billingmanager.CancelOffer.deserializeBinaryFromReader);
      msg.addOffers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminListCancelOffersReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminListCancelOffersReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminListCancelOffersReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminListCancelOffersReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.billingmanager.CancelOffer.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CancelOffer offers = 1;
 * @return {!Array<!proto.billingmanager.CancelOffer>}
 */
proto.billingmanager.AdminListCancelOffersReply.prototype.getOffersList = function() {
  return /** @type{!Array<!proto.billingmanager.CancelOffer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.billingmanager.CancelOffer, 1));
};


/**
 * @param {!Array<!proto.billingmanager.CancelOffer>} value
 * @return {!proto.billingmanager.AdminListCancelOffersReply} returns this
*/
proto.billingmanager.AdminListCancelOffersReply.prototype.setOffersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.billingmanager.CancelOffer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billingmanager.CancelOffer}
 */
proto.billingmanager.AdminListCancelOffersReply.prototype.addOffers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billingmanager.CancelOffer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billingmanager.AdminListCancelOffersReply} returns this
 */
proto.billingmanager.AdminListCancelOffersReply.prototype.clearOffersList = function() {
  return this.setOffersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminRetrySubscriptionFreezeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminRetrySubscriptionFreezeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
freezeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
expectedVersion: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminRetrySubscriptionFreezeReq}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminRetrySubscriptionFreezeReq;
  return proto.billingmanager.AdminRetrySubscriptionFreezeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminRetrySubscriptionFreezeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminRetrySubscriptionFreezeReq}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreezeId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExpectedVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminRetrySubscriptionFreezeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminRetrySubscriptionFreezeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreezeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpectedVersion();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string freeze_id = 1;
 * @return {string}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.prototype.getFreezeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.AdminRetrySubscriptionFreezeReq} returns this
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.prototype.setFreezeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 expected_version = 2;
 * @return {number}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.prototype.getExpectedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.AdminRetrySubscriptionFreezeReq} returns this
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReq.prototype.setExpectedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.AdminRetrySubscriptionFreezeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.AdminRetrySubscriptionFreezeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.AdminRetrySubscriptionFreezeReply}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.AdminRetrySubscriptionFreezeReply;
  return proto.billingmanager.AdminRetrySubscriptionFreezeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.AdminRetrySubscriptionFreezeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.AdminRetrySubscriptionFreezeReply}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.AdminRetrySubscriptionFreezeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.AdminRetrySubscriptionFreezeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionFreezeState freeze = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.AdminRetrySubscriptionFreezeReply} returns this
*/
proto.billingmanager.AdminRetrySubscriptionFreezeReply.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.AdminRetrySubscriptionFreezeReply} returns this
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.AdminRetrySubscriptionFreezeReply.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntFinalizeSubscriptionFreezeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
freezeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
expectedVersion: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeReq}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntFinalizeSubscriptionFreezeReq;
  return proto.billingmanager.IntFinalizeSubscriptionFreezeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeReq}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreezeId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExpectedVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntFinalizeSubscriptionFreezeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreezeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpectedVersion();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string freeze_id = 1;
 * @return {string}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.prototype.getFreezeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeReq} returns this
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.prototype.setFreezeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 expected_version = 2;
 * @return {number}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.prototype.getExpectedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeReq} returns this
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReq.prototype.setExpectedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntFinalizeSubscriptionFreezeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeReply}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntFinalizeSubscriptionFreezeReply;
  return proto.billingmanager.IntFinalizeSubscriptionFreezeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeReply}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntFinalizeSubscriptionFreezeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionFreezeState freeze = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeReply} returns this
*/
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeReply} returns this
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeReply.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
freezeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq;
  return proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreezeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreezeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string freeze_id = 1;
 * @return {string}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.prototype.getFreezeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq} returns this
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReq.prototype.setFreezeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f),
ready: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply;
  return proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReady(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
  f = message.getReady();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional SubscriptionFreezeState freeze = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply} returns this
*/
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply} returns this
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool ready = 2;
 * @return {boolean}
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.prototype.getReady = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply} returns this
 */
proto.billingmanager.IntPrepareSubscriptionFreezeResumeReply.prototype.setReady = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.toObject = function(includeInstance, msg) {
  var f, obj = {
freezeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
expectedVersion: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq;
  return proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFreezeId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExpectedVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreezeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExpectedVersion();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional string freeze_id = 1;
 * @return {string}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.prototype.getFreezeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq} returns this
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.prototype.setFreezeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 expected_version = 2;
 * @return {number}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.prototype.getExpectedVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq} returns this
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReq.prototype.setExpectedVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.prototype.toObject = function(opt_includeInstance) {
  return proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.toObject = function(includeInstance, msg) {
  var f, obj = {
freeze: (f = msg.getFreeze()) && proto.billingmanager.SubscriptionFreezeState.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply;
  return proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.billingmanager.SubscriptionFreezeState;
      reader.readMessage(value,proto.billingmanager.SubscriptionFreezeState.deserializeBinaryFromReader);
      msg.setFreeze(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreeze();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.billingmanager.SubscriptionFreezeState.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionFreezeState freeze = 1;
 * @return {?proto.billingmanager.SubscriptionFreezeState}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.prototype.getFreeze = function() {
  return /** @type{?proto.billingmanager.SubscriptionFreezeState} */ (
    jspb.Message.getWrapperField(this, proto.billingmanager.SubscriptionFreezeState, 1));
};


/**
 * @param {?proto.billingmanager.SubscriptionFreezeState|undefined} value
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply} returns this
*/
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.prototype.setFreeze = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply} returns this
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.prototype.clearFreeze = function() {
  return this.setFreeze(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.billingmanager.IntFinalizeSubscriptionFreezeResumeReply.prototype.hasFreeze = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.billingmanager.UpcomingInvoiceTypeEnum = {
  CREATE: 0,
  UPDATE: 1
};

/**
 * @enum {number}
 */
proto.billingmanager.SubscriptionFreezeStatus = {
  SUBSCRIPTION_FREEZE_STATUS_UNSPECIFIED: 0,
  SUBSCRIPTION_FREEZE_STATUS_FREEZING: 2,
  SUBSCRIPTION_FREEZE_STATUS_FROZEN: 3,
  SUBSCRIPTION_FREEZE_STATUS_RESUME_PAYMENT_PENDING: 4,
  SUBSCRIPTION_FREEZE_STATUS_RESUMING: 5,
  SUBSCRIPTION_FREEZE_STATUS_RESUMED: 6,
  SUBSCRIPTION_FREEZE_STATUS_FREEZE_REPAIR_REQUIRED: 8,
  SUBSCRIPTION_FREEZE_STATUS_RESUME_REPAIR_REQUIRED: 9,
  SUBSCRIPTION_FREEZE_STATUS_CANCELED: 10,
  SUBSCRIPTION_FREEZE_STATUS_CANCELING: 11,
  SUBSCRIPTION_FREEZE_STATUS_FAILED: 12
};

/**
 * @enum {number}
 */
proto.billingmanager.SubscriptionFreezeAllowedAction = {
  SUBSCRIPTION_FREEZE_ALLOWED_ACTION_UNSPECIFIED: 0,
  SUBSCRIPTION_FREEZE_ALLOWED_ACTION_CONFIRM_PAYMENT: 1,
  SUBSCRIPTION_FREEZE_ALLOWED_ACTION_VIEW_STATUS: 2,
  SUBSCRIPTION_FREEZE_ALLOWED_ACTION_UPDATE_PAYMENT_METHOD: 3,
  SUBSCRIPTION_FREEZE_ALLOWED_ACTION_CONTACT_SUPPORT: 4,
  SUBSCRIPTION_FREEZE_ALLOWED_ACTION_START_RESUME: 5,
  SUBSCRIPTION_FREEZE_ALLOWED_ACTION_CANCEL: 6
};

goog.object.extend(exports, proto.billingmanager);
